import _regeneratorRuntime from "/Users/ebemunk/proj/livechat-sentiment/app/node_modules/@babel/runtime/regenerator";
import "core-js/modules/es6.typed.float64-array";
import "core-js/modules/es6.typed.int32-array";
import "core-js/modules/es6.typed.uint32-array";
import "core-js/modules/es6.typed.int8-array";
import "core-js/modules/es6.array.last-index-of";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.copy-within";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.typed.data-view";
import "core-js/modules/es6.array.fill";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.date.now";
import "core-js/modules/es7.object.values";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.set";
import "core-js/modules/es6.map";
import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.regexp.flags";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.object.freeze";
import "core-js/modules/es6.object.prevent-extensions";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.array.some";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.define-property";
import t, { useRef as e, useMemo as r, useImperativeHandle as n, useEffect as i, forwardRef as o, useCallback as a, useState as u, createContext as s, useLayoutEffect as c, useContext as l } from "react";
import f from "react-dom";
var d = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

function p(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t["default"] : t;
}

function h(t, e) {
  return t(e = {
    exports: {}
  }, e.exports), e.exports;
}

var v = function v(t) {
  return t && t.Math == Math && t;
},
    y = v("object" == typeof globalThis && globalThis) || v("object" == typeof window && window) || v("object" == typeof self && self) || v("object" == typeof d && d) || Function("return this")(),
    g = function g(t) {
  try {
    return !!t();
  } catch (t) {
    return !0;
  }
},
    m = !g(function () {
  return 7 != Object.defineProperty({}, 1, {
    get: function get() {
      return 7;
    }
  })[1];
}),
    b = {}.propertyIsEnumerable,
    w = Object.getOwnPropertyDescriptor,
    x = {
  f: w && !b.call({
    1: 2
  }, 1) ? function (t) {
    var e = w(this, t);
    return !!e && e.enumerable;
  } : b
},
    O = function O(t, e) {
  return {
    enumerable: !(1 & t),
    configurable: !(2 & t),
    writable: !(4 & t),
    value: e
  };
},
    S = {}.toString,
    E = function E(t) {
  return S.call(t).slice(8, -1);
},
    k = "".split,
    A = g(function () {
  return !Object("z").propertyIsEnumerable(0);
}) ? function (t) {
  return "String" == E(t) ? k.call(t, "") : Object(t);
} : Object,
    j = function j(t) {
  if (null == t) throw TypeError("Can't call method on " + t);
  return t;
},
    T = function T(t) {
  return A(j(t));
},
    _ = function _(t) {
  return "object" == typeof t ? null !== t : "function" == typeof t;
},
    P = function P(t, e) {
  if (!_(t)) return t;
  var r, n;
  if (e && "function" == typeof (r = t.toString) && !_(n = r.call(t))) return n;
  if ("function" == typeof (r = t.valueOf) && !_(n = r.call(t))) return n;
  if (!e && "function" == typeof (r = t.toString) && !_(n = r.call(t))) return n;
  throw TypeError("Can't convert object to primitive value");
},
    M = {}.hasOwnProperty,
    R = function R(t, e) {
  return M.call(t, e);
},
    I = y.document,
    C = _(I) && _(I.createElement),
    V = function V(t) {
  return C ? I.createElement(t) : {};
},
    N = !m && !g(function () {
  return 7 != Object.defineProperty(V("div"), "a", {
    get: function get() {
      return 7;
    }
  }).a;
}),
    F = Object.getOwnPropertyDescriptor,
    L = {
  f: m ? F : function (t, e) {
    if (t = T(t), e = P(e, !0), N) try {
      return F(t, e);
    } catch (t) {}
    if (R(t, e)) return O(!x.f.call(t, e), t[e]);
  }
},
    D = function D(t) {
  if (!_(t)) throw TypeError(String(t) + " is not an object");
  return t;
},
    z = Object.defineProperty,
    q = {
  f: m ? z : function (t, e, r) {
    if (D(t), e = P(e, !0), D(r), N) try {
      return z(t, e, r);
    } catch (t) {}
    if ("get" in r || "set" in r) throw TypeError("Accessors not supported");
    return "value" in r && (t[e] = r.value), t;
  }
},
    B = m ? function (t, e, r) {
  return q.f(t, e, O(1, r));
} : function (t, e, r) {
  return t[e] = r, t;
},
    U = function U(t, e) {
  try {
    B(y, t, e);
  } catch (r) {
    y[t] = e;
  }

  return e;
},
    W = y["__core-js_shared__"] || U("__core-js_shared__", {}),
    $ = Function.toString;

"function" != typeof W.inspectSource && (W.inspectSource = function (t) {
  return $.call(t);
});

var H,
    G,
    Y,
    K = W.inspectSource,
    X = y.WeakMap,
    Q = "function" == typeof X && /native code/.test(K(X)),
    J = h(function (t) {
  (t.exports = function (t, e) {
    return W[t] || (W[t] = void 0 !== e ? e : {});
  })("versions", []).push({
    version: "3.6.5",
    mode: "global",
    copyright: "© 2020 Denis Pushkarev (zloirock.ru)"
  });
}),
    Z = 0,
    tt = Math.random(),
    et = function et(t) {
  return "Symbol(" + String(void 0 === t ? "" : t) + ")_" + (++Z + tt).toString(36);
},
    rt = J("keys"),
    nt = function nt(t) {
  return rt[t] || (rt[t] = et(t));
},
    it = {},
    ot = y.WeakMap;

if (Q) {
  var at = new ot(),
      ut = at.get,
      st = at.has,
      ct = at.set;
  H = function H(t, e) {
    return ct.call(at, t, e), e;
  }, G = function G(t) {
    return ut.call(at, t) || {};
  }, Y = function Y(t) {
    return st.call(at, t);
  };
} else {
  var lt = nt("state");
  it[lt] = !0, H = function H(t, e) {
    return B(t, lt, e), e;
  }, G = function G(t) {
    return R(t, lt) ? t[lt] : {};
  }, Y = function Y(t) {
    return R(t, lt);
  };
}

var ft,
    dt,
    pt = {
  set: H,
  get: G,
  has: Y,
  enforce: function enforce(t) {
    return Y(t) ? G(t) : H(t, {});
  },
  getterFor: function getterFor(t) {
    return function (e) {
      var r;
      if (!_(e) || (r = G(e)).type !== t) throw TypeError("Incompatible receiver, " + t + " required");
      return r;
    };
  }
},
    ht = h(function (t) {
  var e = pt.get,
      r = pt.enforce,
      n = String(String).split("String");
  (t.exports = function (t, e, i, o) {
    var a = !!o && !!o.unsafe,
        u = !!o && !!o.enumerable,
        s = !!o && !!o.noTargetGet;
    "function" == typeof i && ("string" != typeof e || R(i, "name") || B(i, "name", e), r(i).source = n.join("string" == typeof e ? e : "")), t !== y ? (a ? !s && t[e] && (u = !0) : delete t[e], u ? t[e] = i : B(t, e, i)) : u ? t[e] = i : U(e, i);
  })(Function.prototype, "toString", function () {
    return "function" == typeof this && e(this).source || K(this);
  });
}),
    vt = y,
    yt = function yt(t) {
  return "function" == typeof t ? t : void 0;
},
    gt = function gt(t, e) {
  return arguments.length < 2 ? yt(vt[t]) || yt(y[t]) : vt[t] && vt[t][e] || y[t] && y[t][e];
},
    mt = Math.ceil,
    bt = Math.floor,
    wt = function wt(t) {
  return isNaN(t = +t) ? 0 : (t > 0 ? bt : mt)(t);
},
    xt = Math.min,
    Ot = function Ot(t) {
  return t > 0 ? xt(wt(t), 9007199254740991) : 0;
},
    St = Math.max,
    Et = Math.min,
    kt = function kt(t, e) {
  var r = wt(t);
  return r < 0 ? St(r + e, 0) : Et(r, e);
},
    At = function At(t) {
  return function (e, r, n) {
    var i,
        o = T(e),
        a = Ot(o.length),
        u = kt(n, a);

    if (t && r != r) {
      for (; a > u;) {
        if ((i = o[u++]) != i) return !0;
      }
    } else for (; a > u; u++) {
      if ((t || u in o) && o[u] === r) return t || u || 0;
    }

    return !t && -1;
  };
},
    jt = {
  includes: At(!0),
  indexOf: At(!1)
},
    Tt = jt.indexOf,
    _t = function _t(t, e) {
  var r,
      n = T(t),
      i = 0,
      o = [];

  for (r in n) {
    !R(it, r) && R(n, r) && o.push(r);
  }

  for (; e.length > i;) {
    R(n, r = e[i++]) && (~Tt(o, r) || o.push(r));
  }

  return o;
},
    Pt = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"],
    Mt = Pt.concat("length", "prototype"),
    Rt = {
  f: Object.getOwnPropertyNames || function (t) {
    return _t(t, Mt);
  }
},
    It = {
  f: Object.getOwnPropertySymbols
},
    Ct = gt("Reflect", "ownKeys") || function (t) {
  var e = Rt.f(D(t)),
      r = It.f;
  return r ? e.concat(r(t)) : e;
},
    Vt = function Vt(t, e) {
  for (var r = Ct(e), n = q.f, i = L.f, o = 0; o < r.length; o++) {
    var a = r[o];
    R(t, a) || n(t, a, i(e, a));
  }
},
    Nt = /#|\.prototype\./,
    Ft = function Ft(t, e) {
  var r = Dt[Lt(t)];
  return r == qt || r != zt && ("function" == typeof e ? g(e) : !!e);
},
    Lt = Ft.normalize = function (t) {
  return String(t).replace(Nt, ".").toLowerCase();
},
    Dt = Ft.data = {},
    zt = Ft.NATIVE = "N",
    qt = Ft.POLYFILL = "P",
    Bt = Ft,
    Ut = L.f,
    Wt = function Wt(t, e) {
  var r,
      n,
      i,
      o,
      a,
      u = t.target,
      s = t.global,
      c = t.stat;
  if (r = s ? y : c ? y[u] || U(u, {}) : (y[u] || {}).prototype) for (n in e) {
    if (o = e[n], i = t.noTargetGet ? (a = Ut(r, n)) && a.value : r[n], !Bt(s ? n : u + (c ? "." : "#") + n, t.forced) && void 0 !== i) {
      if (typeof o == typeof i) continue;
      Vt(o, i);
    }

    (t.sham || i && i.sham) && B(o, "sham", !0), ht(r, n, o, t);
  }
},
    $t = Array.isArray || function (t) {
  return "Array" == E(t);
},
    Ht = function Ht(t) {
  return Object(j(t));
},
    Gt = function Gt(t, e, r) {
  var n = P(e);
  n in t ? q.f(t, n, O(0, r)) : t[n] = r;
},
    Yt = !!Object.getOwnPropertySymbols && !g(function () {
  return !String(Symbol());
}),
    Kt = Yt && !Symbol.sham && "symbol" == typeof Symbol.iterator,
    Xt = J("wks"),
    Qt = y.Symbol,
    Jt = Kt ? Qt : Qt && Qt.withoutSetter || et,
    Zt = function Zt(t) {
  return R(Xt, t) || (Yt && R(Qt, t) ? Xt[t] = Qt[t] : Xt[t] = Jt("Symbol." + t)), Xt[t];
},
    te = Zt("species"),
    ee = function ee(t, e) {
  var r;
  return $t(t) && ("function" != typeof (r = t.constructor) || r !== Array && !$t(r.prototype) ? _(r) && null === (r = r[te]) && (r = void 0) : r = void 0), new (void 0 === r ? Array : r)(0 === e ? 0 : e);
},
    re = gt("navigator", "userAgent") || "",
    ne = y.process,
    ie = ne && ne.versions,
    oe = ie && ie.v8;

oe ? dt = (ft = oe.split("."))[0] + ft[1] : re && (!(ft = re.match(/Edge\/(\d+)/)) || ft[1] >= 74) && (ft = re.match(/Chrome\/(\d+)/)) && (dt = ft[1]);

var ae = dt && +dt,
    ue = Zt("species"),
    se = function se(t) {
  return ae >= 51 || !g(function () {
    var e = [];
    return (e.constructor = {})[ue] = function () {
      return {
        foo: 1
      };
    }, 1 !== e[t](Boolean).foo;
  });
},
    ce = Zt("isConcatSpreadable"),
    le = ae >= 51 || !g(function () {
  var t = [];
  return t[ce] = !1, t.concat()[0] !== t;
}),
    fe = se("concat"),
    de = function de(t) {
  if (!_(t)) return !1;
  var e = t[ce];
  return void 0 !== e ? !!e : $t(t);
};

Wt({
  target: "Array",
  proto: !0,
  forced: !le || !fe
}, {
  concat: function concat(t) {
    var e,
        r,
        n,
        i,
        o,
        a = Ht(this),
        u = ee(a, 0),
        s = 0;

    for (e = -1, n = arguments.length; e < n; e++) {
      if (o = -1 === e ? a : arguments[e], de(o)) {
        if (s + (i = Ot(o.length)) > 9007199254740991) throw TypeError("Maximum allowed index exceeded");

        for (r = 0; r < i; r++, s++) {
          r in o && Gt(u, s, o[r]);
        }
      } else {
        if (s >= 9007199254740991) throw TypeError("Maximum allowed index exceeded");
        Gt(u, s++, o);
      }
    }

    return u.length = s, u;
  }
});

var pe = function pe(t) {
  if ("function" != typeof t) throw TypeError(String(t) + " is not a function");
  return t;
},
    he = function he(t, e, r) {
  if (pe(t), void 0 === e) return t;

  switch (r) {
    case 0:
      return function () {
        return t.call(e);
      };

    case 1:
      return function (r) {
        return t.call(e, r);
      };

    case 2:
      return function (r, n) {
        return t.call(e, r, n);
      };

    case 3:
      return function (r, n, i) {
        return t.call(e, r, n, i);
      };
  }

  return function () {
    return t.apply(e, arguments);
  };
},
    ve = [].push,
    ye = function ye(t) {
  var e = 1 == t,
      r = 2 == t,
      n = 3 == t,
      i = 4 == t,
      o = 6 == t,
      a = 5 == t || o;
  return function (u, s, c, l) {
    for (var f, d, p = Ht(u), h = A(p), v = he(s, c, 3), y = Ot(h.length), g = 0, m = l || ee, b = e ? m(u, y) : r ? m(u, 0) : void 0; y > g; g++) {
      if ((a || g in h) && (d = v(f = h[g], g, p), t)) if (e) b[g] = d;else if (d) switch (t) {
        case 3:
          return !0;

        case 5:
          return f;

        case 6:
          return g;

        case 2:
          ve.call(b, f);
      } else if (i) return !1;
    }

    return o ? -1 : n || i ? i : b;
  };
},
    ge = {
  forEach: ye(0),
  map: ye(1),
  filter: ye(2),
  some: ye(3),
  every: ye(4),
  find: ye(5),
  findIndex: ye(6)
},
    me = Object.defineProperty,
    be = {},
    we = function we(t) {
  throw t;
},
    xe = function xe(t, e) {
  if (R(be, t)) return be[t];
  e || (e = {});
  var r = [][t],
      n = !!R(e, "ACCESSORS") && e.ACCESSORS,
      i = R(e, 0) ? e[0] : we,
      o = R(e, 1) ? e[1] : void 0;
  return be[t] = !!r && !g(function () {
    if (n && !m) return !0;
    var t = {
      length: -1
    };
    n ? me(t, 1, {
      enumerable: !0,
      get: we
    }) : t[1] = 1, r.call(t, i, o);
  });
},
    Oe = ge.map,
    Se = se("map"),
    Ee = xe("map");

function ke(t) {
  return (ke = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
    return typeof t;
  } : function (t) {
    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  })(t);
}

function Ae(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}

function je(t, e) {
  for (var r = 0; r < e.length; r++) {
    var n = e[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
  }
}

function Te(t, e, r) {
  return e && je(t.prototype, e), r && je(t, r), t;
}

function _e(t, e, r) {
  return e in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}

function Pe() {
  return (Pe = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
      }
    }

    return t;
  }).apply(this, arguments);
}

function Me(t, e) {
  var r = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), r.push.apply(r, n);
  }

  return r;
}

function Re(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = null != arguments[e] ? arguments[e] : {};
    e % 2 ? Me(Object(r), !0).forEach(function (e) {
      _e(t, e, r[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Me(Object(r)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
    });
  }

  return t;
}

function Ie(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), e && Ve(t, e);
}

function Ce(t) {
  return (Ce = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  })(t);
}

function Ve(t, e) {
  return (Ve = Object.setPrototypeOf || function (t, e) {
    return t.__proto__ = e, t;
  })(t, e);
}

function Ne(t, e) {
  if (null == t) return {};

  var r,
      n,
      i = function (t, e) {
    if (null == t) return {};
    var r,
        n,
        i = {},
        o = Object.keys(t);

    for (n = 0; n < o.length; n++) {
      r = o[n], e.indexOf(r) >= 0 || (i[r] = t[r]);
    }

    return i;
  }(t, e);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);

    for (n = 0; n < o.length; n++) {
      r = o[n], e.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(t, r) && (i[r] = t[r]);
    }
  }

  return i;
}

function Fe(t) {
  if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}

function Le(t, e) {
  return !e || "object" != typeof e && "function" != typeof e ? Fe(t) : e;
}

function De(t, e) {
  return function (t) {
    if (Array.isArray(t)) return t;
  }(t) || function (t, e) {
    if (!(Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t))) return;
    var r = [],
        n = !0,
        i = !1,
        o = void 0;

    try {
      for (var a, u = t[Symbol.iterator](); !(n = (a = u.next()).done) && (r.push(a.value), !e || r.length !== e); n = !0) {
        ;
      }
    } catch (t) {
      i = !0, o = t;
    } finally {
      try {
        n || null == u["return"] || u["return"]();
      } finally {
        if (i) throw o;
      }
    }

    return r;
  }(t, e) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }();
}

function ze(t) {
  return function (t) {
    if (Array.isArray(t)) {
      for (var e = 0, r = new Array(t.length); e < t.length; e++) {
        r[e] = t[e];
      }

      return r;
    }
  }(t) || function (t) {
    if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
  }(t) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }();
}

Wt({
  target: "Array",
  proto: !0,
  forced: !Se || !Ee
}, {
  map: function map(t) {
    return Oe(this, t, arguments.length > 1 ? arguments[1] : void 0);
  }
});

var qe,
    Be = Object.keys || function (t) {
  return _t(t, Pt);
},
    Ue = m ? Object.defineProperties : function (t, e) {
  D(t);

  for (var r, n = Be(e), i = n.length, o = 0; i > o;) {
    q.f(t, r = n[o++], e[r]);
  }

  return t;
},
    We = gt("document", "documentElement"),
    $e = nt("IE_PROTO"),
    He = function He() {},
    Ge = function Ge(t) {
  return "<script>" + t + "<\/script>";
},
    _Ye = function Ye() {
  try {
    qe = document.domain && new ActiveXObject("htmlfile");
  } catch (t) {}

  var t, e;
  _Ye = qe ? function (t) {
    t.write(Ge("")), t.close();
    var e = t.parentWindow.Object;
    return t = null, e;
  }(qe) : ((e = V("iframe")).style.display = "none", We.appendChild(e), e.src = String("javascript:"), (t = e.contentWindow.document).open(), t.write(Ge("document.F=Object")), t.close(), t.F);

  for (var r = Pt.length; r--;) {
    delete _Ye.prototype[Pt[r]];
  }

  return _Ye();
};

it[$e] = !0;

var Ke = Object.create || function (t, e) {
  var r;
  return null !== t ? (He.prototype = D(t), r = new He(), He.prototype = null, r[$e] = t) : r = _Ye(), void 0 === e ? r : Ue(r, e);
},
    Xe = Rt.f,
    Qe = {}.toString,
    Je = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [],
    Ze = {
  f: function f(t) {
    return Je && "[object Window]" == Qe.call(t) ? function (t) {
      try {
        return Xe(t);
      } catch (t) {
        return Je.slice();
      }
    }(t) : Xe(T(t));
  }
},
    tr = {
  f: Zt
},
    er = q.f,
    rr = function rr(t) {
  var e = vt.Symbol || (vt.Symbol = {});
  R(e, t) || er(e, t, {
    value: tr.f(t)
  });
},
    nr = q.f,
    ir = Zt("toStringTag"),
    or = function or(t, e, r) {
  t && !R(t = r ? t : t.prototype, ir) && nr(t, ir, {
    configurable: !0,
    value: e
  });
},
    ar = ge.forEach,
    ur = nt("hidden"),
    sr = Zt("toPrimitive"),
    cr = pt.set,
    lr = pt.getterFor("Symbol"),
    fr = Object.prototype,
    _dr = y.Symbol,
    pr = gt("JSON", "stringify"),
    hr = L.f,
    vr = q.f,
    yr = Ze.f,
    gr = x.f,
    mr = J("symbols"),
    br = J("op-symbols"),
    wr = J("string-to-symbol-registry"),
    xr = J("symbol-to-string-registry"),
    Or = J("wks"),
    Sr = y.QObject,
    Er = !Sr || !Sr.prototype || !Sr.prototype.findChild,
    kr = m && g(function () {
  return 7 != Ke(vr({}, "a", {
    get: function get() {
      return vr(this, "a", {
        value: 7
      }).a;
    }
  })).a;
}) ? function (t, e, r) {
  var n = hr(fr, e);
  n && delete fr[e], vr(t, e, r), n && t !== fr && vr(fr, e, n);
} : vr,
    Ar = function Ar(t, e) {
  var r = mr[t] = Ke(_dr.prototype);
  return cr(r, {
    type: "Symbol",
    tag: t,
    description: e
  }), m || (r.description = e), r;
},
    jr = Kt ? function (t) {
  return "symbol" == typeof t;
} : function (t) {
  return Object(t) instanceof _dr;
},
    Tr = function Tr(t, e, r) {
  t === fr && Tr(br, e, r), D(t);
  var n = P(e, !0);
  return D(r), R(mr, n) ? (r.enumerable ? (R(t, ur) && t[ur][n] && (t[ur][n] = !1), r = Ke(r, {
    enumerable: O(0, !1)
  })) : (R(t, ur) || vr(t, ur, O(1, {})), t[ur][n] = !0), kr(t, n, r)) : vr(t, n, r);
},
    _r = function _r(t, e) {
  D(t);
  var r = T(e),
      n = Be(r).concat(Ir(r));
  return ar(n, function (e) {
    m && !Pr.call(r, e) || Tr(t, e, r[e]);
  }), t;
},
    Pr = function Pr(t) {
  var e = P(t, !0),
      r = gr.call(this, e);
  return !(this === fr && R(mr, e) && !R(br, e)) && (!(r || !R(this, e) || !R(mr, e) || R(this, ur) && this[ur][e]) || r);
},
    Mr = function Mr(t, e) {
  var r = T(t),
      n = P(e, !0);

  if (r !== fr || !R(mr, n) || R(br, n)) {
    var i = hr(r, n);
    return !i || !R(mr, n) || R(r, ur) && r[ur][n] || (i.enumerable = !0), i;
  }
},
    Rr = function Rr(t) {
  var e = yr(T(t)),
      r = [];
  return ar(e, function (t) {
    R(mr, t) || R(it, t) || r.push(t);
  }), r;
},
    Ir = function Ir(t) {
  var e = t === fr,
      r = yr(e ? br : T(t)),
      n = [];
  return ar(r, function (t) {
    !R(mr, t) || e && !R(fr, t) || n.push(mr[t]);
  }), n;
};

if (Yt || (ht((_dr = function dr() {
  if (this instanceof _dr) throw TypeError("Symbol is not a constructor");

  var t = arguments.length && void 0 !== arguments[0] ? String(arguments[0]) : void 0,
      e = et(t),
      r = function r(t) {
    this === fr && r.call(br, t), R(this, ur) && R(this[ur], e) && (this[ur][e] = !1), kr(this, e, O(1, t));
  };

  return m && Er && kr(fr, e, {
    configurable: !0,
    set: r
  }), Ar(e, t);
}).prototype, "toString", function () {
  return lr(this).tag;
}), ht(_dr, "withoutSetter", function (t) {
  return Ar(et(t), t);
}), x.f = Pr, q.f = Tr, L.f = Mr, Rt.f = Ze.f = Rr, It.f = Ir, tr.f = function (t) {
  return Ar(Zt(t), t);
}, m && (vr(_dr.prototype, "description", {
  configurable: !0,
  get: function get() {
    return lr(this).description;
  }
}), ht(fr, "propertyIsEnumerable", Pr, {
  unsafe: !0
}))), Wt({
  global: !0,
  wrap: !0,
  forced: !Yt,
  sham: !Yt
}, {
  Symbol: _dr
}), ar(Be(Or), function (t) {
  rr(t);
}), Wt({
  target: "Symbol",
  stat: !0,
  forced: !Yt
}, {
  "for": function _for(t) {
    var e = String(t);
    if (R(wr, e)) return wr[e];

    var r = _dr(e);

    return wr[e] = r, xr[r] = e, r;
  },
  keyFor: function keyFor(t) {
    if (!jr(t)) throw TypeError(t + " is not a symbol");
    if (R(xr, t)) return xr[t];
  },
  useSetter: function useSetter() {
    Er = !0;
  },
  useSimple: function useSimple() {
    Er = !1;
  }
}), Wt({
  target: "Object",
  stat: !0,
  forced: !Yt,
  sham: !m
}, {
  create: function create(t, e) {
    return void 0 === e ? Ke(t) : _r(Ke(t), e);
  },
  defineProperty: Tr,
  defineProperties: _r,
  getOwnPropertyDescriptor: Mr
}), Wt({
  target: "Object",
  stat: !0,
  forced: !Yt
}, {
  getOwnPropertyNames: Rr,
  getOwnPropertySymbols: Ir
}), Wt({
  target: "Object",
  stat: !0,
  forced: g(function () {
    It.f(1);
  })
}, {
  getOwnPropertySymbols: function getOwnPropertySymbols(t) {
    return It.f(Ht(t));
  }
}), pr) {
  var Cr = !Yt || g(function () {
    var t = _dr();

    return "[null]" != pr([t]) || "{}" != pr({
      a: t
    }) || "{}" != pr(Object(t));
  });
  Wt({
    target: "JSON",
    stat: !0,
    forced: Cr
  }, {
    stringify: function stringify(t, e, r) {
      for (var n, i = [t], o = 1; arguments.length > o;) {
        i.push(arguments[o++]);
      }

      if (n = e, (_(e) || void 0 !== t) && !jr(t)) return $t(e) || (e = function e(t, _e2) {
        if ("function" == typeof n && (_e2 = n.call(this, t, _e2)), !jr(_e2)) return _e2;
      }), i[1] = e, pr.apply(null, i);
    }
  });
}

_dr.prototype[sr] || B(_dr.prototype, sr, _dr.prototype.valueOf), or(_dr, "Symbol"), it[ur] = !0;
var Vr = q.f,
    Nr = y.Symbol;

if (m && "function" == typeof Nr && (!("description" in Nr.prototype) || void 0 !== Nr().description)) {
  var Fr = {},
      Lr = function Lr() {
    var t = arguments.length < 1 || void 0 === arguments[0] ? void 0 : String(arguments[0]),
        e = this instanceof Lr ? new Nr(t) : void 0 === t ? Nr() : Nr(t);
    return "" === t && (Fr[e] = !0), e;
  };

  Vt(Lr, Nr);
  var Dr = Lr.prototype = Nr.prototype;
  Dr.constructor = Lr;
  var zr = Dr.toString,
      qr = "Symbol(test)" == String(Nr("test")),
      Br = /^Symbol\((.*)\)[^)]+$/;
  Vr(Dr, "description", {
    configurable: !0,
    get: function get() {
      var t = _(this) ? this.valueOf() : this,
          e = zr.call(t);
      if (R(Fr, t)) return "";
      var r = qr ? e.slice(7, -1) : e.replace(Br, "$1");
      return "" === r ? void 0 : r;
    }
  }), Wt({
    global: !0,
    forced: !0
  }, {
    Symbol: Lr
  });
}

rr("iterator");

var Ur = function Ur(t) {
  for (var e = Ht(this), r = Ot(e.length), n = arguments.length, i = kt(n > 1 ? arguments[1] : void 0, r), o = n > 2 ? arguments[2] : void 0, a = void 0 === o ? r : kt(o, r); a > i;) {
    e[i++] = t;
  }

  return e;
},
    Wr = Zt("unscopables"),
    $r = Array.prototype;

null == $r[Wr] && q.f($r, Wr, {
  configurable: !0,
  value: Ke(null)
});

var Hr = function Hr(t) {
  $r[Wr][t] = !0;
};

Wt({
  target: "Array",
  proto: !0
}, {
  fill: Ur
}), Hr("fill");
var Gr = ge.filter,
    Yr = se("filter"),
    Kr = xe("filter");
Wt({
  target: "Array",
  proto: !0,
  forced: !Yr || !Kr
}, {
  filter: function filter(t) {
    return Gr(this, t, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var Xr = ge.find,
    Qr = !0,
    Jr = xe("find");
"find" in [] && Array(1).find(function () {
  Qr = !1;
}), Wt({
  target: "Array",
  proto: !0,
  forced: Qr || !Jr
}, {
  find: function find(t) {
    return Xr(this, t, arguments.length > 1 ? arguments[1] : void 0);
  }
}), Hr("find");
var Zr = ge.findIndex,
    tn = !0,
    en = xe("findIndex");
"findIndex" in [] && Array(1).findIndex(function () {
  tn = !1;
}), Wt({
  target: "Array",
  proto: !0,
  forced: tn || !en
}, {
  findIndex: function findIndex(t) {
    return Zr(this, t, arguments.length > 1 ? arguments[1] : void 0);
  }
}), Hr("findIndex");

var rn = function rn(t, e) {
  var r = [][t];
  return !!r && g(function () {
    r.call(null, e || function () {
      throw 1;
    }, 1);
  });
},
    nn = ge.forEach,
    on = rn("forEach"),
    an = xe("forEach"),
    un = on && an ? [].forEach : function (t) {
  return nn(this, t, arguments.length > 1 ? arguments[1] : void 0);
};

Wt({
  target: "Array",
  proto: !0,
  forced: [].forEach != un
}, {
  forEach: un
});

var sn = function sn(t, e, r, n) {
  try {
    return n ? e(D(r)[0], r[1]) : e(r);
  } catch (e) {
    var i = t["return"];
    throw void 0 !== i && D(i.call(t)), e;
  }
},
    cn = {},
    ln = Zt("iterator"),
    fn = Array.prototype,
    dn = function dn(t) {
  return void 0 !== t && (cn.Array === t || fn[ln] === t);
},
    pn = {};

pn[Zt("toStringTag")] = "z";

var hn = "[object z]" === String(pn),
    vn = Zt("toStringTag"),
    yn = "Arguments" == E(function () {
  return arguments;
}()),
    gn = hn ? E : function (t) {
  var e, r, n;
  return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (r = function (t, e) {
    try {
      return t[e];
    } catch (t) {}
  }(e = Object(t), vn)) ? r : yn ? E(e) : "Object" == (n = E(e)) && "function" == typeof e.callee ? "Arguments" : n;
},
    mn = Zt("iterator"),
    bn = function bn(t) {
  if (null != t) return t[mn] || t["@@iterator"] || cn[gn(t)];
},
    wn = Zt("iterator"),
    xn = !1;

try {
  var On = 0,
      Sn = {
    next: function next() {
      return {
        done: !!On++
      };
    },
    "return": function _return() {
      xn = !0;
    }
  };
  Sn[wn] = function () {
    return this;
  }, Array.from(Sn, function () {
    throw 2;
  });
} catch (t) {}

var En = function En(t, e) {
  if (!e && !xn) return !1;
  var r = !1;

  try {
    var n = {};
    n[wn] = function () {
      return {
        next: function next() {
          return {
            done: r = !0
          };
        }
      };
    }, t(n);
  } catch (t) {}

  return r;
},
    kn = !En(function (t) {
  Array.from(t);
});

Wt({
  target: "Array",
  stat: !0,
  forced: kn
}, {
  from: function from(t) {
    var e,
        r,
        n,
        i,
        o,
        a,
        u = Ht(t),
        s = "function" == typeof this ? this : Array,
        c = arguments.length,
        l = c > 1 ? arguments[1] : void 0,
        f = void 0 !== l,
        d = bn(u),
        p = 0;
    if (f && (l = he(l, c > 2 ? arguments[2] : void 0, 2)), null == d || s == Array && dn(d)) for (r = new s(e = Ot(u.length)); e > p; p++) {
      a = f ? l(u[p], p) : u[p], Gt(r, p, a);
    } else for (o = (i = d.call(u)).next, r = new s(); !(n = o.call(i)).done; p++) {
      a = f ? sn(i, l, [n.value, p], !0) : n.value, Gt(r, p, a);
    }
    return r.length = p, r;
  }
});

var An = jt.indexOf,
    jn = [].indexOf,
    Tn = !!jn && 1 / [1].indexOf(1, -0) < 0,
    _n = rn("indexOf"),
    Pn = xe("indexOf", {
  ACCESSORS: !0,
  1: 0
});

Wt({
  target: "Array",
  proto: !0,
  forced: Tn || !_n || !Pn
}, {
  indexOf: function indexOf(t) {
    return Tn ? jn.apply(this, arguments) || 0 : An(this, t, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var Mn,
    Rn,
    In,
    Cn = !g(function () {
  function t() {}

  return t.prototype.constructor = null, Object.getPrototypeOf(new t()) !== t.prototype;
}),
    Vn = nt("IE_PROTO"),
    Nn = Object.prototype,
    Fn = Cn ? Object.getPrototypeOf : function (t) {
  return t = Ht(t), R(t, Vn) ? t[Vn] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? Nn : null;
},
    Ln = Zt("iterator"),
    Dn = !1;
[].keys && ("next" in (In = [].keys()) ? (Rn = Fn(Fn(In))) !== Object.prototype && (Mn = Rn) : Dn = !0), null == Mn && (Mn = {}), R(Mn, Ln) || B(Mn, Ln, function () {
  return this;
});

var zn = {
  IteratorPrototype: Mn,
  BUGGY_SAFARI_ITERATORS: Dn
},
    qn = zn.IteratorPrototype,
    Bn = function Bn() {
  return this;
},
    Un = Object.setPrototypeOf || ("__proto__" in {} ? function () {
  var t,
      e = !1,
      r = {};

  try {
    (t = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set).call(r, []), e = r instanceof Array;
  } catch (t) {}

  return function (r, n) {
    return D(r), function (t) {
      if (!_(t) && null !== t) throw TypeError("Can't set " + String(t) + " as a prototype");
    }(n), e ? t.call(r, n) : r.__proto__ = n, r;
  };
}() : void 0),
    Wn = zn.IteratorPrototype,
    $n = zn.BUGGY_SAFARI_ITERATORS,
    Hn = Zt("iterator"),
    Gn = function Gn() {
  return this;
},
    Yn = function Yn(t, e, r, n, i, o, a) {
  !function (t, e, r) {
    var n = e + " Iterator";
    t.prototype = Ke(qn, {
      next: O(1, r)
    }), or(t, n, !1), cn[n] = Bn;
  }(r, e, n);

  var u,
      s,
      c,
      l = function l(t) {
    if (t === i && v) return v;
    if (!$n && t in p) return p[t];

    switch (t) {
      case "keys":
      case "values":
      case "entries":
        return function () {
          return new r(this, t);
        };
    }

    return function () {
      return new r(this);
    };
  },
      f = e + " Iterator",
      d = !1,
      p = t.prototype,
      h = p[Hn] || p["@@iterator"] || i && p[i],
      v = !$n && h || l(i),
      y = "Array" == e && p.entries || h;

  if (y && (u = Fn(y.call(new t())), Wn !== Object.prototype && u.next && (Fn(u) !== Wn && (Un ? Un(u, Wn) : "function" != typeof u[Hn] && B(u, Hn, Gn)), or(u, f, !0))), "values" == i && h && "values" !== h.name && (d = !0, v = function v() {
    return h.call(this);
  }), p[Hn] !== v && B(p, Hn, v), cn[e] = v, i) if (s = {
    values: l("values"),
    keys: o ? v : l("keys"),
    entries: l("entries")
  }, a) for (c in s) {
    !$n && !d && c in p || ht(p, c, s[c]);
  } else Wt({
    target: e,
    proto: !0,
    forced: $n || d
  }, s);
  return s;
},
    Kn = pt.set,
    Xn = pt.getterFor("Array Iterator"),
    Qn = Yn(Array, "Array", function (t, e) {
  Kn(this, {
    type: "Array Iterator",
    target: T(t),
    index: 0,
    kind: e
  });
}, function () {
  var t = Xn(this),
      e = t.target,
      r = t.kind,
      n = t.index++;
  return !e || n >= e.length ? (t.target = void 0, {
    value: void 0,
    done: !0
  }) : "keys" == r ? {
    value: n,
    done: !1
  } : "values" == r ? {
    value: e[n],
    done: !1
  } : {
    value: [n, e[n]],
    done: !1
  };
}, "values");

cn.Arguments = cn.Array, Hr("keys"), Hr("values"), Hr("entries");
var Jn = [].join,
    Zn = A != Object,
    ti = rn("join", ",");
Wt({
  target: "Array",
  proto: !0,
  forced: Zn || !ti
}, {
  join: function join(t) {
    return Jn.call(T(this), void 0 === t ? "," : t);
  }
});

var ei = function ei(t) {
  return function (e, r, n, i) {
    pe(r);
    var o = Ht(e),
        a = A(o),
        u = Ot(o.length),
        s = t ? u - 1 : 0,
        c = t ? -1 : 1;
    if (n < 2) for (;;) {
      if (s in a) {
        i = a[s], s += c;
        break;
      }

      if (s += c, t ? s < 0 : u <= s) throw TypeError("Reduce of empty array with no initial value");
    }

    for (; t ? s >= 0 : u > s; s += c) {
      s in a && (i = r(i, a[s], s, o));
    }

    return i;
  };
},
    ri = {
  left: ei(!1),
  right: ei(!0)
},
    ni = ri.left,
    ii = rn("reduce"),
    oi = xe("reduce", {
  1: 0
});

Wt({
  target: "Array",
  proto: !0,
  forced: !ii || !oi
}, {
  reduce: function reduce(t) {
    return ni(this, t, arguments.length, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var ai = se("slice"),
    ui = xe("slice", {
  ACCESSORS: !0,
  0: 0,
  1: 2
}),
    si = Zt("species"),
    ci = [].slice,
    li = Math.max;
Wt({
  target: "Array",
  proto: !0,
  forced: !ai || !ui
}, {
  slice: function slice(t, e) {
    var r,
        n,
        i,
        o = T(this),
        a = Ot(o.length),
        u = kt(t, a),
        s = kt(void 0 === e ? a : e, a);
    if ($t(o) && ("function" != typeof (r = o.constructor) || r !== Array && !$t(r.prototype) ? _(r) && null === (r = r[si]) && (r = void 0) : r = void 0, r === Array || void 0 === r)) return ci.call(o, u, s);

    for (n = new (void 0 === r ? Array : r)(li(s - u, 0)), i = 0; u < s; u++, i++) {
      u in o && Gt(n, i, o[u]);
    }

    return n.length = i, n;
  }
});
var fi = ge.some,
    di = rn("some"),
    pi = xe("some");
Wt({
  target: "Array",
  proto: !0,
  forced: !di || !pi
}, {
  some: function some(t) {
    return fi(this, t, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var hi = se("splice"),
    vi = xe("splice", {
  ACCESSORS: !0,
  0: 0,
  1: 2
}),
    yi = Math.max,
    gi = Math.min;
Wt({
  target: "Array",
  proto: !0,
  forced: !hi || !vi
}, {
  splice: function splice(t, e) {
    var r,
        n,
        i,
        o,
        a,
        u,
        s = Ht(this),
        c = Ot(s.length),
        l = kt(t, c),
        f = arguments.length;
    if (0 === f ? r = n = 0 : 1 === f ? (r = 0, n = c - l) : (r = f - 2, n = gi(yi(wt(e), 0), c - l)), c + r - n > 9007199254740991) throw TypeError("Maximum allowed length exceeded");

    for (i = ee(s, n), o = 0; o < n; o++) {
      (a = l + o) in s && Gt(i, o, s[a]);
    }

    if (i.length = n, r < n) {
      for (o = l; o < c - n; o++) {
        u = o + r, (a = o + n) in s ? s[u] = s[a] : delete s[u];
      }

      for (o = c; o > c - n + r; o--) {
        delete s[o - 1];
      }
    } else if (r > n) for (o = c - n; o > l; o--) {
      u = o + r - 1, (a = o + n - 1) in s ? s[u] = s[a] : delete s[u];
    }

    for (o = 0; o < r; o++) {
      s[o + l] = arguments[o + 2];
    }

    return s.length = c - n + r, i;
  }
});
var mi = q.f,
    bi = Function.prototype,
    wi = bi.toString,
    xi = /^\s*function ([^ (]*)/;
!m || "name" in bi || mi(bi, "name", {
  configurable: !0,
  get: function get() {
    try {
      return wi.call(this).match(xi)[1];
    } catch (t) {
      return "";
    }
  }
});

var Oi = !g(function () {
  return Object.isExtensible(Object.preventExtensions({}));
}),
    Si = h(function (t) {
  var e = q.f,
      r = et("meta"),
      n = 0,
      i = Object.isExtensible || function () {
    return !0;
  },
      o = function o(t) {
    e(t, r, {
      value: {
        objectID: "O" + ++n,
        weakData: {}
      }
    });
  },
      a = t.exports = {
    REQUIRED: !1,
    fastKey: function fastKey(t, e) {
      if (!_(t)) return "symbol" == typeof t ? t : ("string" == typeof t ? "S" : "P") + t;

      if (!R(t, r)) {
        if (!i(t)) return "F";
        if (!e) return "E";
        o(t);
      }

      return t[r].objectID;
    },
    getWeakData: function getWeakData(t, e) {
      if (!R(t, r)) {
        if (!i(t)) return !0;
        if (!e) return !1;
        o(t);
      }

      return t[r].weakData;
    },
    onFreeze: function onFreeze(t) {
      return Oi && a.REQUIRED && i(t) && !R(t, r) && o(t), t;
    }
  };

  it[r] = !0;
}),
    Ei = (Si.REQUIRED, Si.fastKey, Si.getWeakData, Si.onFreeze, h(function (t) {
  var e = function e(t, _e3) {
    this.stopped = t, this.result = _e3;
  };

  (t.exports = function (t, r, n, i, o) {
    var a,
        u,
        s,
        c,
        l,
        f,
        d,
        p = he(r, n, i ? 2 : 1);
    if (o) a = t;else {
      if ("function" != typeof (u = bn(t))) throw TypeError("Target is not iterable");

      if (dn(u)) {
        for (s = 0, c = Ot(t.length); c > s; s++) {
          if ((l = i ? p(D(d = t[s])[0], d[1]) : p(t[s])) && l instanceof e) return l;
        }

        return new e(!1);
      }

      a = u.call(t);
    }

    for (f = a.next; !(d = f.call(a)).done;) {
      if ("object" == typeof (l = sn(a, p, d.value, i)) && l && l instanceof e) return l;
    }

    return new e(!1);
  }).stop = function (t) {
    return new e(!0, t);
  };
})),
    ki = function ki(t, e, r) {
  if (!(t instanceof e)) throw TypeError("Incorrect " + (r ? r + " " : "") + "invocation");
  return t;
},
    Ai = function Ai(t, e, r) {
  var n, i;
  return Un && "function" == typeof (n = e.constructor) && n !== r && _(i = n.prototype) && i !== r.prototype && Un(t, i), t;
},
    ji = function ji(t, e, r) {
  var n = -1 !== t.indexOf("Map"),
      i = -1 !== t.indexOf("Weak"),
      o = n ? "set" : "add",
      a = y[t],
      u = a && a.prototype,
      s = a,
      c = {},
      l = function l(t) {
    var e = u[t];
    ht(u, t, "add" == t ? function (t) {
      return e.call(this, 0 === t ? 0 : t), this;
    } : "delete" == t ? function (t) {
      return !(i && !_(t)) && e.call(this, 0 === t ? 0 : t);
    } : "get" == t ? function (t) {
      return i && !_(t) ? void 0 : e.call(this, 0 === t ? 0 : t);
    } : "has" == t ? function (t) {
      return !(i && !_(t)) && e.call(this, 0 === t ? 0 : t);
    } : function (t, r) {
      return e.call(this, 0 === t ? 0 : t, r), this;
    });
  };

  if (Bt(t, "function" != typeof a || !(i || u.forEach && !g(function () {
    new a().entries().next();
  })))) s = r.getConstructor(e, t, n, o), Si.REQUIRED = !0;else if (Bt(t, !0)) {
    var f = new s(),
        d = f[o](i ? {} : -0, 1) != f,
        p = g(function () {
      f.has(1);
    }),
        h = En(function (t) {
      new a(t);
    }),
        v = !i && g(function () {
      for (var t = new a(), e = 5; e--;) {
        t[o](e, e);
      }

      return !t.has(-0);
    });
    h || ((s = e(function (e, r) {
      ki(e, s, t);
      var i = Ai(new a(), e, s);
      return null != r && Ei(r, i[o], i, n), i;
    })).prototype = u, u.constructor = s), (p || v) && (l("delete"), l("has"), n && l("get")), (v || d) && l(o), i && u.clear && delete u.clear;
  }
  return c[t] = s, Wt({
    global: !0,
    forced: s != a
  }, c), or(s, t), i || r.setStrong(s, t, n), s;
},
    Ti = function Ti(t, e, r) {
  for (var n in e) {
    ht(t, n, e[n], r);
  }

  return t;
},
    _i = Zt("species"),
    Pi = function Pi(t) {
  var e = gt(t),
      r = q.f;
  m && e && !e[_i] && r(e, _i, {
    configurable: !0,
    get: function get() {
      return this;
    }
  });
},
    Mi = q.f,
    Ri = Si.fastKey,
    Ii = pt.set,
    Ci = pt.getterFor,
    Vi = {
  getConstructor: function getConstructor(t, e, r, n) {
    var i = t(function (t, o) {
      ki(t, i, e), Ii(t, {
        type: e,
        index: Ke(null),
        first: void 0,
        last: void 0,
        size: 0
      }), m || (t.size = 0), null != o && Ei(o, t[n], t, r);
    }),
        o = Ci(e),
        a = function a(t, e, r) {
      var n,
          i,
          a = o(t),
          s = u(t, e);
      return s ? s.value = r : (a.last = s = {
        index: i = Ri(e, !0),
        key: e,
        value: r,
        previous: n = a.last,
        next: void 0,
        removed: !1
      }, a.first || (a.first = s), n && (n.next = s), m ? a.size++ : t.size++, "F" !== i && (a.index[i] = s)), t;
    },
        u = function u(t, e) {
      var r,
          n = o(t),
          i = Ri(e);
      if ("F" !== i) return n.index[i];

      for (r = n.first; r; r = r.next) {
        if (r.key == e) return r;
      }
    };

    return Ti(i.prototype, {
      clear: function clear() {
        for (var t = o(this), e = t.index, r = t.first; r;) {
          r.removed = !0, r.previous && (r.previous = r.previous.next = void 0), delete e[r.index], r = r.next;
        }

        t.first = t.last = void 0, m ? t.size = 0 : this.size = 0;
      },
      "delete": function _delete(t) {
        var e = o(this),
            r = u(this, t);

        if (r) {
          var n = r.next,
              i = r.previous;
          delete e.index[r.index], r.removed = !0, i && (i.next = n), n && (n.previous = i), e.first == r && (e.first = n), e.last == r && (e.last = i), m ? e.size-- : this.size--;
        }

        return !!r;
      },
      forEach: function forEach(t) {
        for (var e, r = o(this), n = he(t, arguments.length > 1 ? arguments[1] : void 0, 3); e = e ? e.next : r.first;) {
          for (n(e.value, e.key, this); e && e.removed;) {
            e = e.previous;
          }
        }
      },
      has: function has(t) {
        return !!u(this, t);
      }
    }), Ti(i.prototype, r ? {
      get: function get(t) {
        var e = u(this, t);
        return e && e.value;
      },
      set: function set(t, e) {
        return a(this, 0 === t ? 0 : t, e);
      }
    } : {
      add: function add(t) {
        return a(this, t = 0 === t ? 0 : t, t);
      }
    }), m && Mi(i.prototype, "size", {
      get: function get() {
        return o(this).size;
      }
    }), i;
  },
  setStrong: function setStrong(t, e, r) {
    var n = e + " Iterator",
        i = Ci(e),
        o = Ci(n);
    Yn(t, e, function (t, e) {
      Ii(this, {
        type: n,
        target: t,
        state: i(t),
        kind: e,
        last: void 0
      });
    }, function () {
      for (var t = o(this), e = t.kind, r = t.last; r && r.removed;) {
        r = r.previous;
      }

      return t.target && (t.last = r = r ? r.next : t.state.first) ? "keys" == e ? {
        value: r.key,
        done: !1
      } : "values" == e ? {
        value: r.value,
        done: !1
      } : {
        value: [r.key, r.value],
        done: !1
      } : (t.target = void 0, {
        value: void 0,
        done: !0
      });
    }, r ? "entries" : "values", !r, !0), Pi(e);
  }
},
    Ni = (ji("Map", function (t) {
  return function () {
    return t(this, arguments.length ? arguments[0] : void 0);
  };
}, Vi), x.f),
    Fi = function Fi(t) {
  return function (e) {
    for (var r, n = T(e), i = Be(n), o = i.length, a = 0, u = []; o > a;) {
      r = i[a++], m && !Ni.call(n, r) || u.push(t ? [r, n[r]] : n[r]);
    }

    return u;
  };
},
    Li = {
  entries: Fi(!0),
  values: Fi(!1)
},
    Di = Li.entries;

Wt({
  target: "Object",
  stat: !0
}, {
  entries: function entries(t) {
    return Di(t);
  }
});
var zi = Si.onFreeze,
    qi = Object.freeze,
    Bi = g(function () {
  qi(1);
});
Wt({
  target: "Object",
  stat: !0,
  forced: Bi,
  sham: !Oi
}, {
  freeze: function freeze(t) {
    return qi && _(t) ? qi(zi(t)) : t;
  }
});
var Ui = g(function () {
  Be(1);
});
Wt({
  target: "Object",
  stat: !0,
  forced: Ui
}, {
  keys: function keys(t) {
    return Be(Ht(t));
  }
});
var Wi = hn ? {}.toString : function () {
  return "[object " + gn(this) + "]";
};
hn || ht(Object.prototype, "toString", Wi, {
  unsafe: !0
});
var $i = Li.values;
Wt({
  target: "Object",
  stat: !0
}, {
  values: function values(t) {
    return $i(t);
  }
});

var Hi,
    Gi,
    Yi,
    Ki = y.Promise,
    Xi = Zt("species"),
    Qi = function Qi(t, e) {
  var r,
      n = D(t).constructor;
  return void 0 === n || null == (r = D(n)[Xi]) ? e : pe(r);
},
    Ji = /(iphone|ipod|ipad).*applewebkit/i.test(re),
    Zi = y.location,
    to = y.setImmediate,
    eo = y.clearImmediate,
    ro = y.process,
    no = y.MessageChannel,
    io = y.Dispatch,
    oo = 0,
    ao = {},
    uo = function uo(t) {
  if (ao.hasOwnProperty(t)) {
    var e = ao[t];
    delete ao[t], e();
  }
},
    so = function so(t) {
  return function () {
    uo(t);
  };
},
    co = function co(t) {
  uo(t.data);
},
    lo = function lo(t) {
  y.postMessage(t + "", Zi.protocol + "//" + Zi.host);
};

to && eo || (to = function to(t) {
  for (var e = [], r = 1; arguments.length > r;) {
    e.push(arguments[r++]);
  }

  return ao[++oo] = function () {
    ("function" == typeof t ? t : Function(t)).apply(void 0, e);
  }, Hi(oo), oo;
}, eo = function eo(t) {
  delete ao[t];
}, "process" == E(ro) ? Hi = function Hi(t) {
  ro.nextTick(so(t));
} : io && io.now ? Hi = function Hi(t) {
  io.now(so(t));
} : no && !Ji ? (Yi = (Gi = new no()).port2, Gi.port1.onmessage = co, Hi = he(Yi.postMessage, Yi, 1)) : !y.addEventListener || "function" != typeof postMessage || y.importScripts || g(lo) || "file:" === Zi.protocol ? Hi = "onreadystatechange" in V("script") ? function (t) {
  We.appendChild(V("script")).onreadystatechange = function () {
    We.removeChild(this), uo(t);
  };
} : function (t) {
  setTimeout(so(t), 0);
} : (Hi = lo, y.addEventListener("message", co, !1)));
var fo,
    po,
    ho,
    vo,
    yo,
    go,
    mo,
    bo,
    wo = {
  set: to,
  clear: eo
},
    xo = L.f,
    Oo = wo.set,
    So = y.MutationObserver || y.WebKitMutationObserver,
    Eo = y.process,
    ko = y.Promise,
    Ao = "process" == E(Eo),
    jo = xo(y, "queueMicrotask"),
    To = jo && jo.value;
To || (fo = function fo() {
  var t, e;

  for (Ao && (t = Eo.domain) && t.exit(); po;) {
    e = po.fn, po = po.next;

    try {
      e();
    } catch (t) {
      throw po ? vo() : ho = void 0, t;
    }
  }

  ho = void 0, t && t.enter();
}, Ao ? vo = function vo() {
  Eo.nextTick(fo);
} : So && !Ji ? (yo = !0, go = document.createTextNode(""), new So(fo).observe(go, {
  characterData: !0
}), vo = function vo() {
  go.data = yo = !yo;
}) : ko && ko.resolve ? (mo = ko.resolve(void 0), bo = mo.then, vo = function vo() {
  bo.call(mo, fo);
}) : vo = function vo() {
  Oo.call(y, fo);
});

var _o,
    Po,
    Mo,
    Ro,
    Io = To || function (t) {
  var e = {
    fn: t,
    next: void 0
  };
  ho && (ho.next = e), po || (po = e, vo()), ho = e;
},
    Co = function Co(t) {
  var e, r;
  this.promise = new t(function (t, n) {
    if (void 0 !== e || void 0 !== r) throw TypeError("Bad Promise constructor");
    e = t, r = n;
  }), this.resolve = pe(e), this.reject = pe(r);
},
    Vo = {
  f: function f(t) {
    return new Co(t);
  }
},
    No = function No(t, e) {
  if (D(t), _(e) && e.constructor === t) return e;
  var r = Vo.f(t);
  return (0, r.resolve)(e), r.promise;
},
    Fo = function Fo(t) {
  try {
    return {
      error: !1,
      value: t()
    };
  } catch (t) {
    return {
      error: !0,
      value: t
    };
  }
},
    Lo = wo.set,
    Do = Zt("species"),
    zo = "Promise",
    qo = pt.get,
    Bo = pt.set,
    Uo = pt.getterFor(zo),
    _Wo = Ki,
    $o = y.TypeError,
    Ho = y.document,
    Go = y.process,
    Yo = gt("fetch"),
    Ko = Vo.f,
    Xo = Ko,
    Qo = "process" == E(Go),
    Jo = !!(Ho && Ho.createEvent && y.dispatchEvent),
    Zo = Bt(zo, function () {
  if (!(K(_Wo) !== String(_Wo))) {
    if (66 === ae) return !0;
    if (!Qo && "function" != typeof PromiseRejectionEvent) return !0;
  }

  if (ae >= 51 && /native code/.test(_Wo)) return !1;

  var t = _Wo.resolve(1),
      e = function e(t) {
    t(function () {}, function () {});
  };

  return (t.constructor = {})[Do] = e, !(t.then(function () {}) instanceof e);
}),
    ta = Zo || !En(function (t) {
  _Wo.all(t)["catch"](function () {});
}),
    ea = function ea(t) {
  var e;
  return !(!_(t) || "function" != typeof (e = t.then)) && e;
},
    ra = function ra(t, e, r) {
  if (!e.notified) {
    e.notified = !0;
    var n = e.reactions;
    Io(function () {
      for (var i = e.value, o = 1 == e.state, a = 0; n.length > a;) {
        var u,
            s,
            c,
            l = n[a++],
            f = o ? l.ok : l.fail,
            d = l.resolve,
            p = l.reject,
            h = l.domain;

        try {
          f ? (o || (2 === e.rejection && aa(t, e), e.rejection = 1), !0 === f ? u = i : (h && h.enter(), u = f(i), h && (h.exit(), c = !0)), u === l.promise ? p($o("Promise-chain cycle")) : (s = ea(u)) ? s.call(u, d, p) : d(u)) : p(i);
        } catch (t) {
          h && !c && h.exit(), p(t);
        }
      }

      e.reactions = [], e.notified = !1, r && !e.rejection && ia(t, e);
    });
  }
},
    na = function na(t, e, r) {
  var n, i;
  Jo ? ((n = Ho.createEvent("Event")).promise = e, n.reason = r, n.initEvent(t, !1, !0), y.dispatchEvent(n)) : n = {
    promise: e,
    reason: r
  }, (i = y["on" + t]) ? i(n) : "unhandledrejection" === t && function (t, e) {
    var r = y.console;
    r && r.error && (1 === arguments.length ? r.error(t) : r.error(t, e));
  }("Unhandled promise rejection", r);
},
    ia = function ia(t, e) {
  Lo.call(y, function () {
    var r,
        n = e.value;
    if (oa(e) && (r = Fo(function () {
      Qo ? Go.emit("unhandledRejection", n, t) : na("unhandledrejection", t, n);
    }), e.rejection = Qo || oa(e) ? 2 : 1, r.error)) throw r.value;
  });
},
    oa = function oa(t) {
  return 1 !== t.rejection && !t.parent;
},
    aa = function aa(t, e) {
  Lo.call(y, function () {
    Qo ? Go.emit("rejectionHandled", t) : na("rejectionhandled", t, e.value);
  });
},
    ua = function ua(t, e, r, n) {
  return function (i) {
    t(e, r, i, n);
  };
},
    sa = function sa(t, e, r, n) {
  e.done || (e.done = !0, n && (e = n), e.value = r, e.state = 2, ra(t, e, !0));
},
    ca = function ca(t, e, r, n) {
  if (!e.done) {
    e.done = !0, n && (e = n);

    try {
      if (t === r) throw $o("Promise can't be resolved itself");
      var i = ea(r);
      i ? Io(function () {
        var n = {
          done: !1
        };

        try {
          i.call(r, ua(ca, t, n, e), ua(sa, t, n, e));
        } catch (r) {
          sa(t, n, r, e);
        }
      }) : (e.value = r, e.state = 1, ra(t, e, !1));
    } catch (r) {
      sa(t, {
        done: !1
      }, r, e);
    }
  }
};

Zo && (_Wo = function Wo(t) {
  ki(this, _Wo, zo), pe(t), _o.call(this);
  var e = qo(this);

  try {
    t(ua(ca, this, e), ua(sa, this, e));
  } catch (t) {
    sa(this, e, t);
  }
}, (_o = function _o(t) {
  Bo(this, {
    type: zo,
    done: !1,
    notified: !1,
    parent: !1,
    reactions: [],
    rejection: !1,
    state: 0,
    value: void 0
  });
}).prototype = Ti(_Wo.prototype, {
  then: function then(t, e) {
    var r = Uo(this),
        n = Ko(Qi(this, _Wo));
    return n.ok = "function" != typeof t || t, n.fail = "function" == typeof e && e, n.domain = Qo ? Go.domain : void 0, r.parent = !0, r.reactions.push(n), 0 != r.state && ra(this, r, !1), n.promise;
  },
  "catch": function _catch(t) {
    return this.then(void 0, t);
  }
}), Po = function Po() {
  var t = new _o(),
      e = qo(t);
  this.promise = t, this.resolve = ua(ca, t, e), this.reject = ua(sa, t, e);
}, Vo.f = Ko = function Ko(t) {
  return t === _Wo || t === Mo ? new Po(t) : Xo(t);
}, "function" == typeof Ki && (Ro = Ki.prototype.then, ht(Ki.prototype, "then", function (t, e) {
  var r = this;
  return new _Wo(function (t, e) {
    Ro.call(r, t, e);
  }).then(t, e);
}, {
  unsafe: !0
}), "function" == typeof Yo && Wt({
  global: !0,
  enumerable: !0,
  forced: !0
}, {
  fetch: function fetch(t) {
    return No(_Wo, Yo.apply(y, arguments));
  }
}))), Wt({
  global: !0,
  wrap: !0,
  forced: Zo
}, {
  Promise: _Wo
}), or(_Wo, zo, !1), Pi(zo), Mo = gt(zo), Wt({
  target: zo,
  stat: !0,
  forced: Zo
}, {
  reject: function reject(t) {
    var e = Ko(this);
    return e.reject.call(void 0, t), e.promise;
  }
}), Wt({
  target: zo,
  stat: !0,
  forced: Zo
}, {
  resolve: function resolve(t) {
    return No(this, t);
  }
}), Wt({
  target: zo,
  stat: !0,
  forced: ta
}, {
  all: function all(t) {
    var e = this,
        r = Ko(e),
        n = r.resolve,
        i = r.reject,
        o = Fo(function () {
      var r = pe(e.resolve),
          o = [],
          a = 0,
          u = 1;
      Ei(t, function (t) {
        var s = a++,
            c = !1;
        o.push(void 0), u++, r.call(e, t).then(function (t) {
          c || (c = !0, o[s] = t, --u || n(o));
        }, i);
      }), --u || n(o);
    });
    return o.error && i(o.value), r.promise;
  },
  race: function race(t) {
    var e = this,
        r = Ko(e),
        n = r.reject,
        i = Fo(function () {
      var i = pe(e.resolve);
      Ei(t, function (t) {
        i.call(e, t).then(r.resolve, n);
      });
    });
    return i.error && n(i.value), r.promise;
  }
});

var la = Zt("match"),
    fa = function fa(t) {
  var e;
  return _(t) && (void 0 !== (e = t[la]) ? !!e : "RegExp" == E(t));
},
    da = function da() {
  var t = D(this),
      e = "";
  return t.global && (e += "g"), t.ignoreCase && (e += "i"), t.multiline && (e += "m"), t.dotAll && (e += "s"), t.unicode && (e += "u"), t.sticky && (e += "y"), e;
};

function pa(t, e) {
  return RegExp(t, e);
}

var ha = {
  UNSUPPORTED_Y: g(function () {
    var t = pa("a", "y");
    return t.lastIndex = 2, null != t.exec("abcd");
  }),
  BROKEN_CARET: g(function () {
    var t = pa("^r", "gy");
    return t.lastIndex = 2, null != t.exec("str");
  })
},
    va = q.f,
    ya = Rt.f,
    ga = pt.set,
    ma = Zt("match"),
    ba = y.RegExp,
    wa = ba.prototype,
    xa = /a/g,
    Oa = /a/g,
    Sa = new ba(xa) !== xa,
    Ea = ha.UNSUPPORTED_Y;

if (m && Bt("RegExp", !Sa || Ea || g(function () {
  return Oa[ma] = !1, ba(xa) != xa || ba(Oa) == Oa || "/a/i" != ba(xa, "i");
}))) {
  for (var ka = function ka(t, e) {
    var r,
        n = this instanceof ka,
        i = fa(t),
        o = void 0 === e;
    if (!n && i && t.constructor === ka && o) return t;
    Sa ? i && !o && (t = t.source) : t instanceof ka && (o && (e = da.call(t)), t = t.source), Ea && (r = !!e && e.indexOf("y") > -1) && (e = e.replace(/y/g, ""));
    var a = Ai(Sa ? new ba(t, e) : ba(t, e), n ? this : wa, ka);
    return Ea && r && ga(a, {
      sticky: r
    }), a;
  }, Aa = function Aa(t) {
    (t in ka) || va(ka, t, {
      configurable: !0,
      get: function get() {
        return ba[t];
      },
      set: function set(e) {
        ba[t] = e;
      }
    });
  }, ja = ya(ba), Ta = 0; ja.length > Ta;) {
    Aa(ja[Ta++]);
  }

  wa.constructor = ka, ka.prototype = wa, ht(y, "RegExp", ka);
}

Pi("RegExp");

var _a = RegExp.prototype.exec,
    Pa = String.prototype.replace,
    Ma = _a,
    Ra = function () {
  var t = /a/,
      e = /b*/g;
  return _a.call(t, "a"), _a.call(e, "a"), 0 !== t.lastIndex || 0 !== e.lastIndex;
}(),
    Ia = ha.UNSUPPORTED_Y || ha.BROKEN_CARET,
    Ca = void 0 !== /()??/.exec("")[1];

(Ra || Ca || Ia) && (Ma = function Ma(t) {
  var e,
      r,
      n,
      i,
      o = this,
      a = Ia && o.sticky,
      u = da.call(o),
      s = o.source,
      c = 0,
      l = t;
  return a && (-1 === (u = u.replace("y", "")).indexOf("g") && (u += "g"), l = String(t).slice(o.lastIndex), o.lastIndex > 0 && (!o.multiline || o.multiline && "\n" !== t[o.lastIndex - 1]) && (s = "(?: " + s + ")", l = " " + l, c++), r = new RegExp("^(?:" + s + ")", u)), Ca && (r = new RegExp("^" + s + "$(?!\\s)", u)), Ra && (e = o.lastIndex), n = _a.call(a ? r : o, l), a ? n ? (n.input = n.input.slice(c), n[0] = n[0].slice(c), n.index = o.lastIndex, o.lastIndex += n[0].length) : o.lastIndex = 0 : Ra && n && (o.lastIndex = o.global ? n.index + n[0].length : e), Ca && n && n.length > 1 && Pa.call(n[0], r, function () {
    for (i = 1; i < arguments.length - 2; i++) {
      void 0 === arguments[i] && (n[i] = void 0);
    }
  }), n;
});
var Va = Ma;
Wt({
  target: "RegExp",
  proto: !0,
  forced: /./.exec !== Va
}, {
  exec: Va
});
var Na = RegExp.prototype,
    Fa = Na.toString,
    La = g(function () {
  return "/a/b" != Fa.call({
    source: "a",
    flags: "b"
  });
}),
    Da = "toString" != Fa.name;
(La || Da) && ht(RegExp.prototype, "toString", function () {
  var t = D(this),
      e = String(t.source),
      r = t.flags;
  return "/" + e + "/" + String(void 0 === r && t instanceof RegExp && !("flags" in Na) ? da.call(t) : r);
}, {
  unsafe: !0
});
ji("Set", function (t) {
  return function () {
    return t(this, arguments.length ? arguments[0] : void 0);
  };
}, Vi);

var za = function za(t) {
  return function (e, r) {
    var n,
        i,
        o = String(j(e)),
        a = wt(r),
        u = o.length;
    return a < 0 || a >= u ? t ? "" : void 0 : (n = o.charCodeAt(a)) < 55296 || n > 56319 || a + 1 === u || (i = o.charCodeAt(a + 1)) < 56320 || i > 57343 ? t ? o.charAt(a) : n : t ? o.slice(a, a + 2) : i - 56320 + (n - 55296 << 10) + 65536;
  };
},
    qa = {
  codeAt: za(!1),
  charAt: za(!0)
},
    Ba = qa.charAt,
    Ua = pt.set,
    Wa = pt.getterFor("String Iterator");

Yn(String, "String", function (t) {
  Ua(this, {
    type: "String Iterator",
    string: String(t),
    index: 0
  });
}, function () {
  var t,
      e = Wa(this),
      r = e.string,
      n = e.index;
  return n >= r.length ? {
    value: void 0,
    done: !0
  } : (t = Ba(r, n), e.index += t.length, {
    value: t,
    done: !1
  });
});

var $a = Zt("species"),
    Ha = !g(function () {
  var t = /./;
  return t.exec = function () {
    var t = [];
    return t.groups = {
      a: "7"
    }, t;
  }, "7" !== "".replace(t, "$<a>");
}),
    Ga = "$0" === "a".replace(/./, "$0"),
    Ya = Zt("replace"),
    Ka = !!/./[Ya] && "" === /./[Ya]("a", "$0"),
    Xa = !g(function () {
  var t = /(?:)/,
      e = t.exec;

  t.exec = function () {
    return e.apply(this, arguments);
  };

  var r = "ab".split(t);
  return 2 !== r.length || "a" !== r[0] || "b" !== r[1];
}),
    Qa = function Qa(t, e, r, n) {
  var i = Zt(t),
      o = !g(function () {
    var e = {};
    return e[i] = function () {
      return 7;
    }, 7 != ""[t](e);
  }),
      a = o && !g(function () {
    var e = !1,
        r = /a/;
    return "split" === t && ((r = {}).constructor = {}, r.constructor[$a] = function () {
      return r;
    }, r.flags = "", r[i] = /./[i]), r.exec = function () {
      return e = !0, null;
    }, r[i](""), !e;
  });

  if (!o || !a || "replace" === t && (!Ha || !Ga || Ka) || "split" === t && !Xa) {
    var u = /./[i],
        s = r(i, ""[t], function (t, e, r, n, i) {
      return e.exec === Va ? o && !i ? {
        done: !0,
        value: u.call(e, r, n)
      } : {
        done: !0,
        value: t.call(r, e, n)
      } : {
        done: !1
      };
    }, {
      REPLACE_KEEPS_$0: Ga,
      REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: Ka
    }),
        c = s[0],
        l = s[1];
    ht(String.prototype, t, c), ht(RegExp.prototype, i, 2 == e ? function (t, e) {
      return l.call(t, this, e);
    } : function (t) {
      return l.call(t, this);
    });
  }

  n && B(RegExp.prototype[i], "sham", !0);
},
    Ja = qa.charAt,
    Za = function Za(t, e, r) {
  return e + (r ? Ja(t, e).length : 1);
},
    tu = function tu(t, e) {
  var r = t.exec;

  if ("function" == typeof r) {
    var n = r.call(t, e);
    if ("object" != typeof n) throw TypeError("RegExp exec method returned something other than an Object or null");
    return n;
  }

  if ("RegExp" !== E(t)) throw TypeError("RegExp#exec called on incompatible receiver");
  return Va.call(t, e);
};

Qa("match", 1, function (t, e, r) {
  return [function (e) {
    var r = j(this),
        n = null == e ? void 0 : e[t];
    return void 0 !== n ? n.call(e, r) : new RegExp(e)[t](String(r));
  }, function (t) {
    var n = r(e, t, this);
    if (n.done) return n.value;
    var i = D(t),
        o = String(this);
    if (!i.global) return tu(i, o);
    var a = i.unicode;
    i.lastIndex = 0;

    for (var u, s = [], c = 0; null !== (u = tu(i, o));) {
      var l = String(u[0]);
      s[c] = l, "" === l && (i.lastIndex = Za(o, Ot(i.lastIndex), a)), c++;
    }

    return 0 === c ? null : s;
  }];
});
var eu = Math.max,
    ru = Math.min,
    nu = Math.floor,
    iu = /\$([$&'`]|\d\d?|<[^>]*>)/g,
    ou = /\$([$&'`]|\d\d?)/g;
Qa("replace", 2, function (t, e, r, n) {
  var i = n.REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE,
      o = n.REPLACE_KEEPS_$0,
      a = i ? "$" : "$0";
  return [function (r, n) {
    var i = j(this),
        o = null == r ? void 0 : r[t];
    return void 0 !== o ? o.call(r, i, n) : e.call(String(i), r, n);
  }, function (t, n) {
    if (!i && o || "string" == typeof n && -1 === n.indexOf(a)) {
      var s = r(e, t, this, n);
      if (s.done) return s.value;
    }

    var c = D(t),
        l = String(this),
        f = "function" == typeof n;
    f || (n = String(n));
    var d = c.global;

    if (d) {
      var p = c.unicode;
      c.lastIndex = 0;
    }

    for (var h = [];;) {
      var v = tu(c, l);
      if (null === v) break;
      if (h.push(v), !d) break;
      "" === String(v[0]) && (c.lastIndex = Za(l, Ot(c.lastIndex), p));
    }

    for (var y, g = "", m = 0, b = 0; b < h.length; b++) {
      v = h[b];

      for (var w = String(v[0]), x = eu(ru(wt(v.index), l.length), 0), O = [], S = 1; S < v.length; S++) {
        O.push(void 0 === (y = v[S]) ? y : String(y));
      }

      var E = v.groups;

      if (f) {
        var k = [w].concat(O, x, l);
        void 0 !== E && k.push(E);
        var A = String(n.apply(void 0, k));
      } else A = u(w, l, x, O, E, n);

      x >= m && (g += l.slice(m, x) + A, m = x + w.length);
    }

    return g + l.slice(m);
  }];

  function u(t, r, n, i, o, a) {
    var u = n + t.length,
        s = i.length,
        c = ou;
    return void 0 !== o && (o = Ht(o), c = iu), e.call(a, c, function (e, a) {
      var c;

      switch (a.charAt(0)) {
        case "$":
          return "$";

        case "&":
          return t;

        case "`":
          return r.slice(0, n);

        case "'":
          return r.slice(u);

        case "<":
          c = o[a.slice(1, -1)];
          break;

        default:
          var l = +a;
          if (0 === l) return e;

          if (l > s) {
            var f = nu(l / 10);
            return 0 === f ? e : f <= s ? void 0 === i[f - 1] ? a.charAt(1) : i[f - 1] + a.charAt(1) : e;
          }

          c = i[l - 1];
      }

      return void 0 === c ? "" : c;
    });
  }
});

var au,
    uu = function uu(t) {
  if (fa(t)) throw TypeError("The method doesn't accept regular expressions");
  return t;
},
    su = Zt("match"),
    cu = L.f,
    lu = "".startsWith,
    fu = Math.min,
    du = function (t) {
  var e = /./;

  try {
    "/./"[t](e);
  } catch (r) {
    try {
      return e[su] = !1, "/./"[t](e);
    } catch (t) {}
  }

  return !1;
}("startsWith"),
    pu = !(du || (au = cu(String.prototype, "startsWith"), !au || au.writable));

Wt({
  target: "String",
  proto: !0,
  forced: !pu && !du
}, {
  startsWith: function startsWith(t) {
    var e = String(j(this));
    uu(t);
    var r = Ot(fu(arguments.length > 1 ? arguments[1] : void 0, e.length)),
        n = String(t);
    return lu ? lu.call(e, n, r) : e.slice(r, r + n.length) === n;
  }
});

var hu = "\t\n\x0B\f\r \xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF",
    vu = "[" + hu + "]",
    yu = RegExp("^" + vu + vu + "*"),
    gu = RegExp(vu + vu + "*$"),
    mu = function mu(t) {
  return function (e) {
    var r = String(j(e));
    return 1 & t && (r = r.replace(yu, "")), 2 & t && (r = r.replace(gu, "")), r;
  };
},
    bu = {
  start: mu(1),
  end: mu(2),
  trim: mu(3)
},
    wu = bu.trim;

Wt({
  target: "String",
  proto: !0,
  forced: function (t) {
    return g(function () {
      return !!hu[t]() || "​᠎" != "​᠎"[t]() || hu[t].name !== t;
    });
  }("trim")
}, {
  trim: function trim() {
    return wu(this);
  }
});

var xu = function xu() {
  for (var t, e = D(this), r = pe(e["delete"]), n = !0, i = 0, o = arguments.length; i < o; i++) {
    t = r.call(e, arguments[i]), n = n && t;
  }

  return !!n;
};

Wt({
  target: "Map",
  proto: !0,
  real: !0,
  forced: !1
}, {
  deleteAll: function deleteAll() {
    return xu.apply(this, arguments);
  }
});

var Ou = function Ou(t) {
  return Map.prototype.entries.call(t);
};

Wt({
  target: "Map",
  proto: !0,
  real: !0,
  forced: !1
}, {
  every: function every(t) {
    var e = D(this),
        r = Ou(e),
        n = he(t, arguments.length > 1 ? arguments[1] : void 0, 3);
    return !Ei(r, function (t, r) {
      if (!n(r, t, e)) return Ei.stop();
    }, void 0, !0, !0).stopped;
  }
}), Wt({
  target: "Map",
  proto: !0,
  real: !0,
  forced: !1
}, {
  filter: function filter(t) {
    var e = D(this),
        r = Ou(e),
        n = he(t, arguments.length > 1 ? arguments[1] : void 0, 3),
        i = new (Qi(e, gt("Map")))(),
        o = pe(i.set);
    return Ei(r, function (t, r) {
      n(r, t, e) && o.call(i, t, r);
    }, void 0, !0, !0), i;
  }
}), Wt({
  target: "Map",
  proto: !0,
  real: !0,
  forced: !1
}, {
  find: function find(t) {
    var e = D(this),
        r = Ou(e),
        n = he(t, arguments.length > 1 ? arguments[1] : void 0, 3);
    return Ei(r, function (t, r) {
      if (n(r, t, e)) return Ei.stop(r);
    }, void 0, !0, !0).result;
  }
}), Wt({
  target: "Map",
  proto: !0,
  real: !0,
  forced: !1
}, {
  findKey: function findKey(t) {
    var e = D(this),
        r = Ou(e),
        n = he(t, arguments.length > 1 ? arguments[1] : void 0, 3);
    return Ei(r, function (t, r) {
      if (n(r, t, e)) return Ei.stop(t);
    }, void 0, !0, !0).result;
  }
});
Wt({
  target: "Map",
  proto: !0,
  real: !0,
  forced: !1
}, {
  includes: function includes(t) {
    return Ei(Ou(D(this)), function (e, r) {
      if ((n = r) === (i = t) || n != n && i != i) return Ei.stop();
      var n, i;
    }, void 0, !0, !0).stopped;
  }
}), Wt({
  target: "Map",
  proto: !0,
  real: !0,
  forced: !1
}, {
  keyOf: function keyOf(t) {
    return Ei(Ou(D(this)), function (e, r) {
      if (r === t) return Ei.stop(e);
    }, void 0, !0, !0).result;
  }
}), Wt({
  target: "Map",
  proto: !0,
  real: !0,
  forced: !1
}, {
  mapKeys: function mapKeys(t) {
    var e = D(this),
        r = Ou(e),
        n = he(t, arguments.length > 1 ? arguments[1] : void 0, 3),
        i = new (Qi(e, gt("Map")))(),
        o = pe(i.set);
    return Ei(r, function (t, r) {
      o.call(i, n(r, t, e), r);
    }, void 0, !0, !0), i;
  }
}), Wt({
  target: "Map",
  proto: !0,
  real: !0,
  forced: !1
}, {
  mapValues: function mapValues(t) {
    var e = D(this),
        r = Ou(e),
        n = he(t, arguments.length > 1 ? arguments[1] : void 0, 3),
        i = new (Qi(e, gt("Map")))(),
        o = pe(i.set);
    return Ei(r, function (t, r) {
      o.call(i, t, n(r, t, e));
    }, void 0, !0, !0), i;
  }
}), Wt({
  target: "Map",
  proto: !0,
  real: !0,
  forced: !1
}, {
  merge: function merge(t) {
    for (var e = D(this), r = pe(e.set), n = 0; n < arguments.length;) {
      Ei(arguments[n++], r, e, !0);
    }

    return e;
  }
}), Wt({
  target: "Map",
  proto: !0,
  real: !0,
  forced: !1
}, {
  reduce: function reduce(t) {
    var e = D(this),
        r = Ou(e),
        n = arguments.length < 2,
        i = n ? void 0 : arguments[1];
    if (pe(t), Ei(r, function (r, o) {
      n ? (n = !1, i = o) : i = t(i, o, r, e);
    }, void 0, !0, !0), n) throw TypeError("Reduce of empty map with no initial value");
    return i;
  }
}), Wt({
  target: "Map",
  proto: !0,
  real: !0,
  forced: !1
}, {
  some: function some(t) {
    var e = D(this),
        r = Ou(e),
        n = he(t, arguments.length > 1 ? arguments[1] : void 0, 3);
    return Ei(r, function (t, r) {
      if (n(r, t, e)) return Ei.stop();
    }, void 0, !0, !0).stopped;
  }
}), Wt({
  target: "Map",
  proto: !0,
  real: !0,
  forced: !1
}, {
  update: function update(t, e) {
    var r = D(this),
        n = arguments.length;
    pe(e);
    var i = r.has(t);
    if (!i && n < 3) throw TypeError("Updating absent value");
    var o = i ? r.get(t) : pe(n > 2 ? arguments[2] : void 0)(t, r);
    return r.set(t, e(o, t, r)), r;
  }
});

var Su = function Su() {
  for (var t = D(this), e = pe(t.add), r = 0, n = arguments.length; r < n; r++) {
    e.call(t, arguments[r]);
  }

  return t;
};

Wt({
  target: "Set",
  proto: !0,
  real: !0,
  forced: !1
}, {
  addAll: function addAll() {
    return Su.apply(this, arguments);
  }
}), Wt({
  target: "Set",
  proto: !0,
  real: !0,
  forced: !1
}, {
  deleteAll: function deleteAll() {
    return xu.apply(this, arguments);
  }
}), Wt({
  target: "Set",
  proto: !0,
  real: !0,
  forced: !1
}, {
  difference: function difference(t) {
    var e = D(this),
        r = new (Qi(e, gt("Set")))(e),
        n = pe(r["delete"]);
    return Ei(t, function (t) {
      n.call(r, t);
    }), r;
  }
});

var Eu = function Eu(t) {
  return Set.prototype.values.call(t);
};

Wt({
  target: "Set",
  proto: !0,
  real: !0,
  forced: !1
}, {
  every: function every(t) {
    var e = D(this),
        r = Eu(e),
        n = he(t, arguments.length > 1 ? arguments[1] : void 0, 3);
    return !Ei(r, function (t) {
      if (!n(t, t, e)) return Ei.stop();
    }, void 0, !1, !0).stopped;
  }
}), Wt({
  target: "Set",
  proto: !0,
  real: !0,
  forced: !1
}, {
  filter: function filter(t) {
    var e = D(this),
        r = Eu(e),
        n = he(t, arguments.length > 1 ? arguments[1] : void 0, 3),
        i = new (Qi(e, gt("Set")))(),
        o = pe(i.add);
    return Ei(r, function (t) {
      n(t, t, e) && o.call(i, t);
    }, void 0, !1, !0), i;
  }
}), Wt({
  target: "Set",
  proto: !0,
  real: !0,
  forced: !1
}, {
  find: function find(t) {
    var e = D(this),
        r = Eu(e),
        n = he(t, arguments.length > 1 ? arguments[1] : void 0, 3);
    return Ei(r, function (t) {
      if (n(t, t, e)) return Ei.stop(t);
    }, void 0, !1, !0).result;
  }
}), Wt({
  target: "Set",
  proto: !0,
  real: !0,
  forced: !1
}, {
  intersection: function intersection(t) {
    var e = D(this),
        r = new (Qi(e, gt("Set")))(),
        n = pe(e.has),
        i = pe(r.add);
    return Ei(t, function (t) {
      n.call(e, t) && i.call(r, t);
    }), r;
  }
}), Wt({
  target: "Set",
  proto: !0,
  real: !0,
  forced: !1
}, {
  isDisjointFrom: function isDisjointFrom(t) {
    var e = D(this),
        r = pe(e.has);
    return !Ei(t, function (t) {
      if (!0 === r.call(e, t)) return Ei.stop();
    }).stopped;
  }
}), Wt({
  target: "Set",
  proto: !0,
  real: !0,
  forced: !1
}, {
  isSubsetOf: function isSubsetOf(t) {
    var e = function (t) {
      var e = bn(t);
      if ("function" != typeof e) throw TypeError(String(t) + " is not iterable");
      return D(e.call(t));
    }(this),
        r = D(t),
        n = r.has;

    return "function" != typeof n && (r = new (gt("Set"))(t), n = pe(r.has)), !Ei(e, function (t) {
      if (!1 === n.call(r, t)) return Ei.stop();
    }, void 0, !1, !0).stopped;
  }
}), Wt({
  target: "Set",
  proto: !0,
  real: !0,
  forced: !1
}, {
  isSupersetOf: function isSupersetOf(t) {
    var e = D(this),
        r = pe(e.has);
    return !Ei(t, function (t) {
      if (!1 === r.call(e, t)) return Ei.stop();
    }).stopped;
  }
}), Wt({
  target: "Set",
  proto: !0,
  real: !0,
  forced: !1
}, {
  join: function join(t) {
    var e = D(this),
        r = Eu(e),
        n = void 0 === t ? "," : String(t),
        i = [];
    return Ei(r, i.push, i, !1, !0), i.join(n);
  }
}), Wt({
  target: "Set",
  proto: !0,
  real: !0,
  forced: !1
}, {
  map: function map(t) {
    var e = D(this),
        r = Eu(e),
        n = he(t, arguments.length > 1 ? arguments[1] : void 0, 3),
        i = new (Qi(e, gt("Set")))(),
        o = pe(i.add);
    return Ei(r, function (t) {
      o.call(i, n(t, t, e));
    }, void 0, !1, !0), i;
  }
}), Wt({
  target: "Set",
  proto: !0,
  real: !0,
  forced: !1
}, {
  reduce: function reduce(t) {
    var e = D(this),
        r = Eu(e),
        n = arguments.length < 2,
        i = n ? void 0 : arguments[1];
    if (pe(t), Ei(r, function (r) {
      n ? (n = !1, i = r) : i = t(i, r, r, e);
    }, void 0, !1, !0), n) throw TypeError("Reduce of empty set with no initial value");
    return i;
  }
}), Wt({
  target: "Set",
  proto: !0,
  real: !0,
  forced: !1
}, {
  some: function some(t) {
    var e = D(this),
        r = Eu(e),
        n = he(t, arguments.length > 1 ? arguments[1] : void 0, 3);
    return Ei(r, function (t) {
      if (n(t, t, e)) return Ei.stop();
    }, void 0, !1, !0).stopped;
  }
}), Wt({
  target: "Set",
  proto: !0,
  real: !0,
  forced: !1
}, {
  symmetricDifference: function symmetricDifference(t) {
    var e = D(this),
        r = new (Qi(e, gt("Set")))(e),
        n = pe(r["delete"]),
        i = pe(r.add);
    return Ei(t, function (t) {
      n.call(r, t) || i.call(r, t);
    }), r;
  }
}), Wt({
  target: "Set",
  proto: !0,
  real: !0,
  forced: !1
}, {
  union: function union(t) {
    var e = D(this),
        r = new (Qi(e, gt("Set")))(e);
    return Ei(t, pe(r.add), r), r;
  }
});
var ku = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

for (var Au in ku) {
  var ju = y[Au],
      Tu = ju && ju.prototype;
  if (Tu && Tu.forEach !== un) try {
    B(Tu, "forEach", un);
  } catch (t) {
    Tu.forEach = un;
  }
}

var _u = Zt("iterator"),
    Pu = Zt("toStringTag"),
    Mu = Qn.values;

for (var Ru in ku) {
  var Iu = y[Ru],
      Cu = Iu && Iu.prototype;

  if (Cu) {
    if (Cu[_u] !== Mu) try {
      B(Cu, _u, Mu);
    } catch (t) {
      Cu[_u] = Mu;
    }
    if (Cu[Pu] || B(Cu, Pu, Ru), ku[Ru]) for (var Vu in Qn) {
      if (Cu[Vu] !== Qn[Vu]) try {
        B(Cu, Vu, Qn[Vu]);
      } catch (t) {
        Cu[Vu] = Qn[Vu];
      }
    }
  }
}

var Nu = Object.assign,
    Fu = Object.defineProperty,
    Lu = !Nu || g(function () {
  if (m && 1 !== Nu({
    b: 1
  }, Nu(Fu({}, "a", {
    enumerable: !0,
    get: function get() {
      Fu(this, "b", {
        value: 3,
        enumerable: !1
      });
    }
  }), {
    b: 2
  })).b) return !0;
  var t = {},
      e = {},
      r = Symbol();
  return t[r] = 7, "abcdefghijklmnopqrst".split("").forEach(function (t) {
    e[t] = t;
  }), 7 != Nu({}, t)[r] || "abcdefghijklmnopqrst" != Be(Nu({}, e)).join("");
}) ? function (t, e) {
  for (var r = Ht(t), n = arguments.length, i = 1, o = It.f, a = x.f; n > i;) {
    for (var u, s = A(arguments[i++]), c = o ? Be(s).concat(o(s)) : Be(s), l = c.length, f = 0; l > f;) {
      u = c[f++], m && !a.call(s, u) || (r[u] = s[u]);
    }
  }

  return r;
} : Nu;

function Du() {
  return (Du = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var r = arguments[e];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
      }
    }

    return t;
  }).apply(this, arguments);
}

function zu(t, e) {
  if (null == t) return {};
  var r,
      n,
      i = {},
      o = Object.keys(t);

  for (n = 0; n < o.length; n++) {
    r = o[n], e.indexOf(r) >= 0 || (i[r] = t[r]);
  }

  return i;
}

Wt({
  target: "Object",
  stat: !0,
  forced: Object.assign !== Lu
}, {
  assign: Lu
});
var qu = {
  arr: Array.isArray,
  obj: function obj(t) {
    return "[object Object]" === Object.prototype.toString.call(t);
  },
  fun: function fun(t) {
    return "function" == typeof t;
  },
  str: function str(t) {
    return "string" == typeof t;
  },
  num: function num(t) {
    return "number" == typeof t;
  },
  und: function und(t) {
    return void 0 === t;
  },
  nul: function nul(t) {
    return null === t;
  },
  set: function set(t) {
    return t instanceof Set;
  },
  map: function map(t) {
    return t instanceof Map;
  },
  equ: function equ(t, e) {
    if (ke(t) !== ke(e)) return !1;
    if (qu.str(t) || qu.num(t)) return t === e;
    if (qu.obj(t) && qu.obj(e) && Object.keys(t).length + Object.keys(e).length === 0) return !0;
    var r;

    for (r in t) {
      if (!(r in e)) return !1;
    }

    for (r in e) {
      if (t[r] !== e[r]) return !1;
    }

    return !qu.und(r) || t === e;
  }
};

function Bu(t, e) {
  return qu.und(t) || qu.nul(t) ? e : t;
}

function Uu(t) {
  return qu.und(t) ? [] : qu.arr(t) ? t : [t];
}

function Wu(t) {
  for (var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++) {
    r[n - 1] = arguments[n];
  }

  return qu.fun(t) ? t.apply(void 0, r) : t;
}

function $u(t) {
  var e = function (t) {
    return t.to, t.from, t.config, t.onStart, t.onRest, t.onFrame, t.children, t.reset, t.reverse, t.force, t.immediate, t.delay, t.attach, t.destroyed, t.interpolateTo, t.ref, t.lazy, zu(t, ["to", "from", "config", "onStart", "onRest", "onFrame", "children", "reset", "reverse", "force", "immediate", "delay", "attach", "destroyed", "interpolateTo", "ref", "lazy"]);
  }(t);

  if (qu.und(e)) return Du({
    to: e
  }, t);
  var r = Object.keys(t).reduce(function (r, n) {
    return qu.und(e[n]) ? Du({}, r, _e({}, n, t[n])) : r;
  }, {});
  return Du({
    to: e
  }, r);
}

var Hu,
    Gu,
    Yu = function () {
  function t() {
    Ae(this, t), this.payload = void 0, this.children = [];
  }

  return Te(t, [{
    key: "getAnimatedValue",
    value: function value() {
      return this.getValue();
    }
  }, {
    key: "getPayload",
    value: function value() {
      return this.payload || this;
    }
  }, {
    key: "attach",
    value: function value() {}
  }, {
    key: "detach",
    value: function value() {}
  }, {
    key: "getChildren",
    value: function value() {
      return this.children;
    }
  }, {
    key: "addChild",
    value: function value(t) {
      0 === this.children.length && this.attach(), this.children.push(t);
    }
  }, {
    key: "removeChild",
    value: function value(t) {
      var e = this.children.indexOf(t);
      this.children.splice(e, 1), 0 === this.children.length && this.detach();
    }
  }]), t;
}(),
    Ku = function (t) {
  function e() {
    var t;
    return Ae(this, e), (t = Le(this, Ce(e).apply(this, arguments))).payload = [], t.attach = function () {
      return t.payload.forEach(function (e) {
        return e instanceof Yu && e.addChild(Fe(t));
      });
    }, t.detach = function () {
      return t.payload.forEach(function (e) {
        return e instanceof Yu && e.removeChild(Fe(t));
      });
    }, t;
  }

  return Ie(e, Yu), e;
}(),
    Xu = function (t) {
  function e() {
    var t;
    return Ae(this, e), (t = Le(this, Ce(e).apply(this, arguments))).payload = {}, t.attach = function () {
      return Object.values(t.payload).forEach(function (e) {
        return e instanceof Yu && e.addChild(Fe(t));
      });
    }, t.detach = function () {
      return Object.values(t.payload).forEach(function (e) {
        return e instanceof Yu && e.removeChild(Fe(t));
      });
    }, t;
  }

  return Ie(e, Yu), Te(e, [{
    key: "getValue",
    value: function value(t) {
      void 0 === t && (t = !1);
      var e = {};

      for (var r in this.payload) {
        var n = this.payload[r];
        (!t || n instanceof Yu) && (e[r] = n instanceof Yu ? n[t ? "getAnimatedValue" : "getValue"]() : n);
      }

      return e;
    }
  }, {
    key: "getAnimatedValue",
    value: function value() {
      return this.getValue(!0);
    }
  }]), e;
}();

var Qu,
    Ju = function Ju(t) {
  return "undefined" != typeof window ? window.requestAnimationFrame(t) : -1;
};

var Zu,
    ts = function ts() {
  return Date.now();
};

var es = function (t) {
  function e(t, r) {
    var n;
    return Ae(this, e), (n = Le(this, Ce(e).call(this))).update = void 0, n.payload = t.style ? Du({}, t, {
      style: Zu(t.style)
    }) : t, n.update = r, n.attach(), n;
  }

  return Ie(e, Xu), e;
}(),
    rs = !1,
    ns = new Set(),
    is = function t() {
  if (!rs) return !1;
  var e = ts(),
      r = !0,
      n = !1,
      i = void 0;

  try {
    for (var o, a = ns[Symbol.iterator](); !(r = (o = a.next()).done); r = !0) {
      for (var u = o.value, s = !1, c = 0; c < u.configs.length; c++) {
        for (var l = u.configs[c], f = void 0, d = void 0, p = 0; p < l.animatedValues.length; p++) {
          var h = l.animatedValues[p];

          if (!h.done) {
            var v = l.fromValues[p],
                y = l.toValues[p],
                g = h.lastPosition,
                m = y instanceof Yu,
                b = Array.isArray(l.initialVelocity) ? l.initialVelocity[p] : l.initialVelocity;
            if (m && (y = y.getValue()), l.immediate) h.setValue(y), h.done = !0;else if ("string" != typeof v && "string" != typeof y) {
              if (void 0 !== l.duration) g = v + l.easing((e - h.startTime) / l.duration) * (y - v), f = e >= h.startTime + l.duration;else if (l.decay) g = v + b / (1 - .998) * (1 - Math.exp(-(1 - .998) * (e - h.startTime))), (f = Math.abs(h.lastPosition - g) < .1) && (y = g);else {
                d = void 0 !== h.lastTime ? h.lastTime : e, b = void 0 !== h.lastVelocity ? h.lastVelocity : l.initialVelocity, e > d + 64 && (d = e);

                for (var w = Math.floor(e - d), x = 0; x < w; ++x) {
                  g += 1 * (b += 1 * ((-l.tension * (g - y) + -l.friction * b) / l.mass) / 1e3) / 1e3;
                }

                var O = !(!l.clamp || 0 === l.tension) && (v < y ? g > y : g < y),
                    S = Math.abs(b) <= l.precision,
                    E = 0 === l.tension || Math.abs(y - g) <= l.precision;
                f = O || S && E, h.lastVelocity = b, h.lastTime = e;
              }
              m && !l.toValues[p].done && (f = !1), f ? (h.value !== y && (g = y), h.done = !0) : s = !0, h.setValue(g), h.lastPosition = g;
            } else h.setValue(y), h.done = !0;
          }
        }

        u.props.onFrame && (u.values[l.name] = l.interpolation.getValue());
      }

      u.props.onFrame && u.props.onFrame(u.values), s || (ns["delete"](u), u.stop(!0));
    }
  } catch (t) {
    n = !0, i = t;
  } finally {
    try {
      r || null == a["return"] || a["return"]();
    } finally {
      if (n) throw i;
    }
  }

  return ns.size ? Ju(t) : rs = !1, rs;
};

function os(t, e, r) {
  if ("function" == typeof t) return t;
  if (Array.isArray(t)) return os({
    range: t,
    output: e,
    extrapolate: r
  });
  if (Qu && "string" == typeof t.output[0]) return Qu(t);

  var n = t,
      i = n.output,
      o = n.range || [0, 1],
      a = n.extrapolateLeft || n.extrapolate || "extend",
      u = n.extrapolateRight || n.extrapolate || "extend",
      s = n.easing || function (t) {
    return t;
  };

  return function (t) {
    var e = function (t, e) {
      for (var r = 1; r < e.length - 1 && !(e[r] >= t); ++r) {
        ;
      }

      return r - 1;
    }(t, o);

    return function (t, e, r, n, i, o, a, u, s) {
      var c = s ? s(t) : t;

      if (c < e) {
        if ("identity" === a) return c;
        "clamp" === a && (c = e);
      }

      if (c > r) {
        if ("identity" === u) return c;
        "clamp" === u && (c = r);
      }

      if (n === i) return n;
      if (e === r) return t <= e ? n : i;
      e === -1 / 0 ? c = -c : r === 1 / 0 ? c -= e : c = (c - e) / (r - e);
      c = o(c), n === -1 / 0 ? c = -c : i === 1 / 0 ? c += n : c = c * (i - n) + n;
      return c;
    }(t, o[e], o[e + 1], i[e], i[e + 1], s, a, u, n.map);
  };
}

var as = function (t) {
  function e(t, r, n, i) {
    var o;
    return Ae(this, e), (o = Le(this, Ce(e).call(this))).calc = void 0, o.payload = t instanceof Ku && !(t instanceof e) ? t.getPayload() : Array.isArray(t) ? t : [t], o.calc = os(r, n, i), o;
  }

  return Ie(e, Ku), Te(e, [{
    key: "getValue",
    value: function value() {
      return this.calc.apply(this, ze(this.payload.map(function (t) {
        return t.getValue();
      })));
    }
  }, {
    key: "updateConfig",
    value: function value(t, e, r) {
      this.calc = os(t, e, r);
    }
  }, {
    key: "interpolate",
    value: function value(t, r, n) {
      return new e(this, t, r, n);
    }
  }]), e;
}();

var us = function (t) {
  function e(t) {
    var r, n;
    return Ae(this, e), r = Le(this, Ce(e).call(this)), n = Fe(r), r.animatedStyles = new Set(), r.value = void 0, r.startPosition = void 0, r.lastPosition = void 0, r.lastVelocity = void 0, r.startTime = void 0, r.lastTime = void 0, r.done = !1, r.setValue = function (t, e) {
      void 0 === e && (e = !0), n.value = t, e && n.flush();
    }, r.value = t, r.startPosition = t, r.lastPosition = t, r;
  }

  return Ie(e, Yu), Te(e, [{
    key: "flush",
    value: function value() {
      0 === this.animatedStyles.size && function t(e, r) {
        "update" in e ? r.add(e) : e.getChildren().forEach(function (e) {
          return t(e, r);
        });
      }(this, this.animatedStyles), this.animatedStyles.forEach(function (t) {
        return t.update();
      });
    }
  }, {
    key: "clearStyles",
    value: function value() {
      this.animatedStyles.clear();
    }
  }, {
    key: "getValue",
    value: function value() {
      return this.value;
    }
  }, {
    key: "interpolate",
    value: function value(t, e, r) {
      return new as(this, t, e, r);
    }
  }]), e;
}(),
    ss = function (t) {
  function e(t) {
    var r;
    return Ae(this, e), (r = Le(this, Ce(e).call(this))).payload = t.map(function (t) {
      return new us(t);
    }), r;
  }

  return Ie(e, Ku), Te(e, [{
    key: "setValue",
    value: function value(t, e) {
      var r = this;
      void 0 === e && (e = !0), Array.isArray(t) ? t.length === this.payload.length && t.forEach(function (t, n) {
        return r.payload[n].setValue(t, e);
      }) : this.payload.forEach(function (r) {
        return r.setValue(t, e);
      });
    }
  }, {
    key: "getValue",
    value: function value() {
      return this.payload.map(function (t) {
        return t.getValue();
      });
    }
  }, {
    key: "interpolate",
    value: function value(t, e) {
      return new as(this, t, e);
    }
  }]), e;
}(),
    cs = 0,
    ls = function () {
  function t() {
    var e = this;
    Ae(this, t), this.id = void 0, this.idle = !0, this.hasChanged = !1, this.guid = 0, this.local = 0, this.props = {}, this.merged = {}, this.animations = {}, this.interpolations = {}, this.values = {}, this.configs = [], this.listeners = [], this.queue = [], this.localQueue = void 0, this.getValues = function () {
      return e.interpolations;
    }, this.id = cs++;
  }

  return Te(t, [{
    key: "update",
    value: function value(t) {
      if (!t) return this;
      var e = $u(t),
          r = e.delay,
          n = void 0 === r ? 0 : r,
          i = e.to,
          o = zu(e, ["delay", "to"]);
      if (qu.arr(i) || qu.fun(i)) this.queue.push(Du({}, o, {
        delay: n,
        to: i
      }));else if (i) {
        var a = {};
        Object.entries(i).forEach(function (t) {
          var e = t[0],
              r = Du({
            to: _e({}, e, t[1]),
            delay: Wu(n, e)
          }, o),
              i = a[r.delay] && a[r.delay].to;
          a[r.delay] = Du({}, a[r.delay], r, {
            to: Du({}, i, r.to)
          });
        }), this.queue = Object.values(a);
      }
      return this.queue = this.queue.sort(function (t, e) {
        return t.delay - e.delay;
      }), this.diff(o), this;
    }
  }, {
    key: "start",
    value: function value(t) {
      var e,
          r = this;

      if (this.queue.length) {
        this.idle = !1, this.localQueue && this.localQueue.forEach(function (t) {
          var e = t.from,
              n = void 0 === e ? {} : e,
              i = t.to,
              o = void 0 === i ? {} : i;
          qu.obj(n) && (r.merged = Du({}, n, r.merged)), qu.obj(o) && (r.merged = Du({}, r.merged, o));
        });
        var n = this.local = ++this.guid,
            i = this.localQueue = this.queue;
        this.queue = [], i.forEach(function (e, o) {
          var a = e.delay,
              u = zu(e, ["delay"]),
              s = function s(e) {
            o === i.length - 1 && n === r.guid && e && (r.idle = !0, r.props.onRest && r.props.onRest(r.merged)), t && t();
          },
              c = qu.arr(u.to) || qu.fun(u.to);

          a ? setTimeout(function () {
            n === r.guid && (c ? r.runAsync(u, s) : r.diff(u).start(s));
          }, a) : c ? r.runAsync(u, s) : r.diff(u).start(s);
        });
      } else qu.fun(t) && this.listeners.push(t), this.props.onStart && this.props.onStart(), e = this, ns.has(e) || ns.add(e), rs || (rs = !0, Ju(is));

      return this;
    }
  }, {
    key: "stop",
    value: function value(t) {
      return this.listeners.forEach(function (e) {
        return e(t);
      }), this.listeners = [], this;
    }
  }, {
    key: "pause",
    value: function value(t) {
      var e;
      return this.stop(!0), t && (e = this, ns.has(e) && ns["delete"](e)), this;
    }
  }, {
    key: "runAsync",
    value: function value(t, e) {
      var r = this,
          n = this,
          i = (t.delay, zu(t, ["delay"])),
          o = this.local,
          a = Promise.resolve(void 0);
      if (qu.arr(i.to)) for (var u = function u(t) {
        var e = t,
            n = Du({}, i, $u(i.to[e]));
        qu.arr(n.config) && (n.config = n.config[e]), a = a.then(function () {
          if (o === r.guid) return new Promise(function (t) {
            return r.diff(n).start(t);
          });
        });
      }, s = 0; s < i.to.length; s++) {
        u(s);
      } else if (qu.fun(i.to)) {
        var c,
            l = 0;
        a = a.then(function () {
          return i.to(function (t) {
            var e = Du({}, i, $u(t));
            if (qu.arr(e.config) && (e.config = e.config[l]), l++, o === r.guid) return c = new Promise(function (t) {
              return r.diff(e).start(t);
            });
          }, function (t) {
            return void 0 === t && (t = !0), n.stop(t);
          }).then(function () {
            return c;
          });
        });
      }
      a.then(e);
    }
  }, {
    key: "diff",
    value: function value(t) {
      var e = this;
      this.props = Du({}, this.props, t);
      var r = this.props,
          n = r.from,
          i = void 0 === n ? {} : n,
          o = r.to,
          a = void 0 === o ? {} : o,
          u = r.config,
          s = void 0 === u ? {} : u,
          c = r.reverse,
          l = r.attach,
          f = r.reset,
          d = r.immediate;

      if (c) {
        var p = [a, i];
        i = p[0], a = p[1];
      }

      this.merged = Du({}, i, this.merged, a), this.hasChanged = !1;
      var h = l && l(this);
      if (this.animations = Object.entries(this.merged).reduce(function (t, r) {
        var n = r[0],
            o = r[1],
            a = t[n] || {},
            u = qu.num(o),
            c = qu.str(o) && !o.startsWith("#") && !/\d/.test(o) && !Gu[o],
            l = qu.arr(o),
            p = !u && !l && !c,
            v = qu.und(i[n]) ? o : i[n],
            y = u || l ? o : c ? o : 1,
            g = Wu(s, n);
        h && (y = h.animations[n].parent);
        var m,
            b = a.parent,
            w = a.interpolation,
            x = Uu(h ? y.getPayload() : y),
            O = o;
        p && (O = Qu({
          range: [0, 1],
          output: [o, o]
        })(1));
        var S = w && w.getValue(),
            E = !qu.und(b) && a.animatedValues.some(function (t) {
          return !t.done;
        }),
            k = !qu.equ(O, S),
            A = !qu.equ(O, a.previous),
            j = !qu.equ(g, a.config);

        if (f || A && k || j) {
          if (u || c) b = w = a.parent || new us(v);else if (l) b = w = a.parent || new ss(v);else if (p) {
            var T = a.interpolation && a.interpolation.calc(a.parent.value);
            T = void 0 === T || f ? v : T, a.parent ? (b = a.parent).setValue(0, !1) : b = new us(0);
            var _ = {
              output: [T, o]
            };
            a.interpolation ? (w = a.interpolation, a.interpolation.updateConfig(_)) : w = b.interpolate(_);
          }
          return x = Uu(h ? y.getPayload() : y), m = Uu(b.getPayload()), f && !p && b.setValue(v, !1), e.hasChanged = !0, m.forEach(function (t) {
            t.startPosition = t.value, t.lastPosition = t.value, t.lastVelocity = E ? t.lastVelocity : void 0, t.lastTime = E ? t.lastTime : void 0, t.startTime = ts(), t.done = !1, t.animatedStyles.clear();
          }), Wu(d, n) && b.setValue(p ? y : o, !1), Du({}, t, _e({}, n, Du({}, a, {
            name: n,
            parent: b,
            interpolation: w,
            animatedValues: m,
            toValues: x,
            previous: O,
            config: g,
            fromValues: Uu(b.getValue()),
            immediate: Wu(d, n),
            initialVelocity: Bu(g.velocity, 0),
            clamp: Bu(g.clamp, !1),
            precision: Bu(g.precision, .01),
            tension: Bu(g.tension, 170),
            friction: Bu(g.friction, 26),
            mass: Bu(g.mass, 1),
            duration: g.duration,
            easing: Bu(g.easing, function (t) {
              return t;
            }),
            decay: g.decay
          })));
        }

        return k ? t : (p && (b.setValue(1, !1), w.updateConfig({
          output: [O, O]
        })), b.done = !0, e.hasChanged = !0, Du({}, t, _e({}, n, Du({}, t[n], {
          previous: O
        }))));
      }, this.animations), this.hasChanged) for (var v in this.configs = Object.values(this.animations), this.values = {}, this.interpolations = {}, this.animations) {
        this.interpolations[v] = this.animations[v].interpolation, this.values[v] = this.animations[v].interpolation.getValue();
      }
      return this;
    }
  }, {
    key: "destroy",
    value: function value() {
      this.stop(), this.props = {}, this.merged = {}, this.animations = {}, this.interpolations = {}, this.values = {}, this.configs = [], this.local = 0;
    }
  }]), t;
}(),
    fs = function (t) {
  function e(t) {
    var r;
    return Ae(this, e), void 0 === t && (t = {}), r = Le(this, Ce(e).call(this)), !t.transform || t.transform instanceof Yu || (t = Hu.transform(t)), r.payload = t, r;
  }

  return Ie(e, Xu), e;
}(),
    ds = {
  transparent: 0,
  aliceblue: 4042850303,
  antiquewhite: 4209760255,
  aqua: 16777215,
  aquamarine: 2147472639,
  azure: 4043309055,
  beige: 4126530815,
  bisque: 4293182719,
  black: 255,
  blanchedalmond: 4293643775,
  blue: 65535,
  blueviolet: 2318131967,
  brown: 2771004159,
  burlywood: 3736635391,
  burntsienna: 3934150143,
  cadetblue: 1604231423,
  chartreuse: 2147418367,
  chocolate: 3530104575,
  coral: 4286533887,
  cornflowerblue: 1687547391,
  cornsilk: 4294499583,
  crimson: 3692313855,
  cyan: 16777215,
  darkblue: 35839,
  darkcyan: 9145343,
  darkgoldenrod: 3095792639,
  darkgray: 2846468607,
  darkgreen: 6553855,
  darkgrey: 2846468607,
  darkkhaki: 3182914559,
  darkmagenta: 2332068863,
  darkolivegreen: 1433087999,
  darkorange: 4287365375,
  darkorchid: 2570243327,
  darkred: 2332033279,
  darksalmon: 3918953215,
  darkseagreen: 2411499519,
  darkslateblue: 1211993087,
  darkslategray: 793726975,
  darkslategrey: 793726975,
  darkturquoise: 13554175,
  darkviolet: 2483082239,
  deeppink: 4279538687,
  deepskyblue: 12582911,
  dimgray: 1768516095,
  dimgrey: 1768516095,
  dodgerblue: 512819199,
  firebrick: 2988581631,
  floralwhite: 4294635775,
  forestgreen: 579543807,
  fuchsia: 4278255615,
  gainsboro: 3705462015,
  ghostwhite: 4177068031,
  gold: 4292280575,
  goldenrod: 3668254975,
  gray: 2155905279,
  green: 8388863,
  greenyellow: 2919182335,
  grey: 2155905279,
  honeydew: 4043305215,
  hotpink: 4285117695,
  indianred: 3445382399,
  indigo: 1258324735,
  ivory: 4294963455,
  khaki: 4041641215,
  lavender: 3873897215,
  lavenderblush: 4293981695,
  lawngreen: 2096890111,
  lemonchiffon: 4294626815,
  lightblue: 2916673279,
  lightcoral: 4034953471,
  lightcyan: 3774873599,
  lightgoldenrodyellow: 4210742015,
  lightgray: 3553874943,
  lightgreen: 2431553791,
  lightgrey: 3553874943,
  lightpink: 4290167295,
  lightsalmon: 4288707327,
  lightseagreen: 548580095,
  lightskyblue: 2278488831,
  lightslategray: 2005441023,
  lightslategrey: 2005441023,
  lightsteelblue: 2965692159,
  lightyellow: 4294959359,
  lime: 16711935,
  limegreen: 852308735,
  linen: 4210091775,
  magenta: 4278255615,
  maroon: 2147483903,
  mediumaquamarine: 1724754687,
  mediumblue: 52735,
  mediumorchid: 3126187007,
  mediumpurple: 2473647103,
  mediumseagreen: 1018393087,
  mediumslateblue: 2070474495,
  mediumspringgreen: 16423679,
  mediumturquoise: 1221709055,
  mediumvioletred: 3340076543,
  midnightblue: 421097727,
  mintcream: 4127193855,
  mistyrose: 4293190143,
  moccasin: 4293178879,
  navajowhite: 4292783615,
  navy: 33023,
  oldlace: 4260751103,
  olive: 2155872511,
  olivedrab: 1804477439,
  orange: 4289003775,
  orangered: 4282712319,
  orchid: 3664828159,
  palegoldenrod: 4008225535,
  palegreen: 2566625535,
  paleturquoise: 2951671551,
  palevioletred: 3681588223,
  papayawhip: 4293907967,
  peachpuff: 4292524543,
  peru: 3448061951,
  pink: 4290825215,
  plum: 3718307327,
  powderblue: 2967529215,
  purple: 2147516671,
  rebeccapurple: 1714657791,
  red: 4278190335,
  rosybrown: 3163525119,
  royalblue: 1097458175,
  saddlebrown: 2336560127,
  salmon: 4202722047,
  sandybrown: 4104413439,
  seagreen: 780883967,
  seashell: 4294307583,
  sienna: 2689740287,
  silver: 3233857791,
  skyblue: 2278484991,
  slateblue: 1784335871,
  slategray: 1887473919,
  slategrey: 1887473919,
  snow: 4294638335,
  springgreen: 16744447,
  steelblue: 1182971135,
  tan: 3535047935,
  teal: 8421631,
  thistle: 3636451583,
  tomato: 4284696575,
  turquoise: 1088475391,
  violet: 4001558271,
  wheat: 4125012991,
  white: 4294967295,
  whitesmoke: 4126537215,
  yellow: 4294902015,
  yellowgreen: 2597139199
},
    ps = "[-+]?\\d*\\.?\\d+",
    hs = ps + "%";

function vs() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++) {
    e[r] = arguments[r];
  }

  return "\\(\\s*(" + e.join(")\\s*,\\s*(") + ")\\s*\\)";
}

var ys = new RegExp("rgb" + vs(ps, ps, ps)),
    gs = new RegExp("rgba" + vs(ps, ps, ps, ps)),
    ms = new RegExp("hsl" + vs(ps, hs, hs)),
    bs = new RegExp("hsla" + vs(ps, hs, hs, ps)),
    ws = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    xs = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    Os = /^#([0-9a-fA-F]{6})$/,
    Ss = /^#([0-9a-fA-F]{8})$/;

function Es(t, e, r) {
  return r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? t + 6 * (e - t) * r : r < .5 ? e : r < 2 / 3 ? t + (e - t) * (2 / 3 - r) * 6 : t;
}

function ks(t, e, r) {
  var n = r < .5 ? r * (1 + e) : r + e - r * e,
      i = 2 * r - n,
      o = Es(i, n, t + 1 / 3),
      a = Es(i, n, t),
      u = Es(i, n, t - 1 / 3);
  return Math.round(255 * o) << 24 | Math.round(255 * a) << 16 | Math.round(255 * u) << 8;
}

function As(t) {
  var e = parseInt(t, 10);
  return e < 0 ? 0 : e > 255 ? 255 : e;
}

function js(t) {
  return (parseFloat(t) % 360 + 360) % 360 / 360;
}

function Ts(t) {
  var e = parseFloat(t);
  return e < 0 ? 0 : e > 1 ? 255 : Math.round(255 * e);
}

function _s(t) {
  var e = parseFloat(t);
  return e < 0 ? 0 : e > 100 ? 1 : e / 100;
}

function Ps(t) {
  var e = function (t) {
    var e;
    return "number" == typeof t ? t >>> 0 === t && t >= 0 && t <= 4294967295 ? t : null : (e = Os.exec(t)) ? parseInt(e[1] + "ff", 16) >>> 0 : ds.hasOwnProperty(t) ? ds[t] : (e = ys.exec(t)) ? (As(e[1]) << 24 | As(e[2]) << 16 | As(e[3]) << 8 | 255) >>> 0 : (e = gs.exec(t)) ? (As(e[1]) << 24 | As(e[2]) << 16 | As(e[3]) << 8 | Ts(e[4])) >>> 0 : (e = ws.exec(t)) ? parseInt(e[1] + e[1] + e[2] + e[2] + e[3] + e[3] + "ff", 16) >>> 0 : (e = Ss.exec(t)) ? parseInt(e[1], 16) >>> 0 : (e = xs.exec(t)) ? parseInt(e[1] + e[1] + e[2] + e[2] + e[3] + e[3] + e[4] + e[4], 16) >>> 0 : (e = ms.exec(t)) ? (255 | ks(js(e[1]), _s(e[2]), _s(e[3]))) >>> 0 : (e = bs.exec(t)) ? (ks(js(e[1]), _s(e[2]), _s(e[3])) | Ts(e[4])) >>> 0 : null;
  }(t);

  if (null === e) return t;
  var r = (16711680 & (e = e || 0)) >>> 16,
      n = (65280 & e) >>> 8,
      i = (255 & e) / 255;
  return "rgba(".concat((4278190080 & e) >>> 24, ", ").concat(r, ", ").concat(n, ", ").concat(i, ")");
}

var Ms = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,
    Rs = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi,
    Is = new RegExp("(".concat(Object.keys(ds).join("|"), ")"), "g"),
    Cs = {
  animationIterationCount: !0,
  borderImageOutset: !0,
  borderImageSlice: !0,
  borderImageWidth: !0,
  boxFlex: !0,
  boxFlexGroup: !0,
  boxOrdinalGroup: !0,
  columnCount: !0,
  columns: !0,
  flex: !0,
  flexGrow: !0,
  flexPositive: !0,
  flexShrink: !0,
  flexNegative: !0,
  flexOrder: !0,
  gridRow: !0,
  gridRowEnd: !0,
  gridRowSpan: !0,
  gridRowStart: !0,
  gridColumn: !0,
  gridColumnEnd: !0,
  gridColumnSpan: !0,
  gridColumnStart: !0,
  fontWeight: !0,
  lineClamp: !0,
  lineHeight: !0,
  opacity: !0,
  order: !0,
  orphans: !0,
  tabSize: !0,
  widows: !0,
  zIndex: !0,
  zoom: !0,
  fillOpacity: !0,
  floodOpacity: !0,
  stopOpacity: !0,
  strokeDasharray: !0,
  strokeDashoffset: !0,
  strokeMiterlimit: !0,
  strokeOpacity: !0,
  strokeWidth: !0
},
    Vs = ["Webkit", "Ms", "Moz", "O"];

function Ns(t, e, r) {
  return null == e || "boolean" == typeof e || "" === e ? "" : r || "number" != typeof e || 0 === e || Cs.hasOwnProperty(t) && Cs[t] ? ("" + e).trim() : e + "px";
}

Cs = Object.keys(Cs).reduce(function (t, e) {
  return Vs.forEach(function (r) {
    return t[function (t, e) {
      return t + e.charAt(0).toUpperCase() + e.substring(1);
    }(r, e)] = t[e];
  }), t;
}, Cs);
var Fs = {};
Zu = function Zu(t) {
  return new fs(t);
}, Qu = function Qu(t) {
  var e = t.output.map(function (t) {
    return t.replace(Rs, Ps);
  }).map(function (t) {
    return t.replace(Is, Ps);
  }),
      r = e[0].match(Ms).map(function () {
    return [];
  });
  e.forEach(function (t) {
    t.match(Ms).forEach(function (t, e) {
      return r[e].push(+t);
    });
  });
  var n = e[0].match(Ms).map(function (e, n) {
    return os(Du({}, t, {
      output: r[n]
    }));
  });
  return function (t) {
    var r = 0;
    return e[0].replace(Ms, function () {
      return n[r++](t);
    }).replace(/rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi, function (t, e, r, n, i) {
      return "rgba(".concat(Math.round(e), ", ").concat(Math.round(r), ", ").concat(Math.round(n), ", ").concat(i, ")");
    });
  };
}, Gu = ds, function (t, e) {
  Hu = {
    fn: t,
    transform: e
  };
}(function (t, e) {
  if (!t.nodeType || void 0 === t.setAttribute) return !1;
  var r = e.style,
      n = e.children,
      i = e.scrollTop,
      o = e.scrollLeft,
      a = zu(e, ["style", "children", "scrollTop", "scrollLeft"]),
      u = "filter" === t.nodeName || t.parentNode && "filter" === t.parentNode.nodeName;

  for (var s in void 0 !== i && (t.scrollTop = i), void 0 !== o && (t.scrollLeft = o), void 0 !== n && (t.textContent = n), r) {
    if (r.hasOwnProperty(s)) {
      var c = 0 === s.indexOf("--"),
          l = Ns(s, r[s], c);
      "float" === s && (s = "cssFloat"), c ? t.style.setProperty(s, l) : t.style[s] = l;
    }
  }

  for (var f in a) {
    var d = u ? f : Fs[f] || (Fs[f] = f.replace(/([A-Z])/g, function (t) {
      return "-" + t.toLowerCase();
    }));
    void 0 !== t.getAttribute(d) && t.setAttribute(d, a[f]);
  }
}, function (t) {
  return t;
});

var Ls,
    Ds,
    zs = (Ls = function Ls(r) {
  return o(function (o, s) {
    var c = function () {
      var t = u(!1)[1];
      return a(function () {
        return t(function (t) {
          return !t;
        });
      }, []);
    }(),
        l = e(!0),
        f = e(null),
        d = e(null),
        p = a(function (t) {
      var e = f.current;
      f.current = new es(t, function () {
        var t = !1;
        d.current && (t = Hu.fn(d.current, f.current.getAnimatedValue())), d.current && !1 !== t || c();
      }), e && e.detach();
    }, []);

    i(function () {
      return function () {
        l.current = !1, f.current && f.current.detach();
      };
    }, []), n(s, function () {
      return function (t) {
        return t.current;
      }(d);
    }), p(o);
    var h,
        v = f.current.getValue(),
        y = (v.scrollTop, v.scrollLeft, zu(v, ["scrollTop", "scrollLeft"])),
        g = (h = r, !qu.fun(h) || h.prototype instanceof t.Component ? function (t) {
      return d.current = function (t, e) {
        return e && (qu.fun(e) ? e(t) : qu.obj(e) && (e.current = t)), t;
      }(t, s);
    } : void 0);
    return t.createElement(r, Du({}, y, {
      ref: g
    }));
  });
}, void 0 === (Ds = !1) && (Ds = !0), function (t) {
  return (qu.arr(t) ? t : Object.keys(t)).reduce(function (t, e) {
    var r = Ds ? e[0].toLowerCase() + e.substring(1) : e;
    return t[r] = Ls(r), t;
  }, Ls);
})(["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"]),
    qs = function qs(t) {
  return "translate(".concat(t, ", 0)");
},
    Bs = function Bs(t) {
  return "translate(0, ".concat(t, ")");
},
    Us = function Us(t) {
  return function (e) {
    return +t(e);
  };
},
    Ws = function Ws(t) {
  var e = Math.max(0, t.bandwidth() - 1) / 2;
  return t.round() && (e = Math.round(e)), function (r) {
    return +t(r) + e;
  };
},
    $s = function $s(o) {
  var a = o.orientation,
      u = o.scale,
      s = o.tickArguments,
      c = void 0 === s ? [] : s,
      l = o.tickSizeInner,
      f = void 0 === l ? 6 : l,
      d = o.tickSizeOuter,
      p = void 0 === d ? 6 : d,
      h = o.tickPadding,
      v = void 0 === h ? 3 : h,
      y = o.tickValues,
      g = void 0 === y ? null : y,
      m = o.tickFormat,
      b = void 0 === m ? null : m,
      w = Ne(o, ["orientation", "scale", "tickArguments", "tickSizeInner", "tickSizeOuter", "tickPadding", "tickValues", "tickFormat"]),
      x = "left" === a || "right" === a,
      O = "top" === a || "left" === a ? -1 : 1,
      S = "top" === a || "bottom" === a ? qs : Bs,
      E = (u.bandwidth ? Ws : Us)(u.copy()),
      k = x ? "x" : "y",
      A = Math.max(f, 0) + v,
      j = null == b ? u.tickFormat ? u.tickFormat.apply(u, c) : function (t) {
    return t;
  } : b,
      T = u.range(),
      _ = +T[0] + .5,
      P = +T[T.length - 1] + .5,
      M = null == g ? u.ticks ? u.ticks.apply(u, c) : u.domain() : g,
      R = function (t, o) {
    var a = e(!1),
        u = e(),
        s = qu.fun(o),
        c = r(function () {
      var e;
      return u.current && (u.current.map(function (t) {
        return t.destroy();
      }), u.current = void 0), [new Array(t).fill().map(function (t, r) {
        var n = new ls(),
            i = s ? Wu(o, r, n) : o[r];
        return 0 === r && (e = i.ref), n.update(i), e || n.start(), n;
      }), e];
    }, [t]),
        l = c[0],
        f = c[1];
    u.current = l;
    n(f, function () {
      return {
        start: function start() {
          return Promise.all(u.current.map(function (t) {
            return new Promise(function (e) {
              return t.start(e);
            });
          }));
        },
        stop: function stop(t) {
          return u.current.forEach(function (e) {
            return e.stop(t);
          });
        },

        get controllers() {
          return u.current;
        }

      };
    });
    var d = r(function () {
      return function (t) {
        return u.current.map(function (e, r) {
          e.update(s ? Wu(t, r, e) : t[r]), f || e.start();
        });
      };
    }, [t]);
    i(function () {
      a.current ? s || d(o) : f || u.current.forEach(function (t) {
        return t.start();
      });
    }), i(function () {
      return a.current = !0, function () {
        return u.current.forEach(function (t) {
          return t.destroy();
        });
      };
    }, []);
    var p = u.current.map(function (t) {
      return t.getValues();
    });
    return s ? [p, d, function (t) {
      return u.current.forEach(function (e) {
        return e.pause(t);
      });
    }] : p;
  }(M.length, M.map(function (t) {
    return {
      opacity: 1,
      transform: S(E(t))
    };
  }));

  return t.createElement("g", Pe({
    fill: "none",
    fontSize: 10,
    fontFamily: "sans-serif",
    textAnchor: "right" === a ? "start" : "left" === a ? "end" : "middle"
  }, w), t.createElement("path", {
    className: "domain",
    stroke: "currentColor",
    d: x ? p ? "M".concat(O * p, ",").concat(_, "H0.5V").concat(P, "H").concat(O * p) : "M05,".concat(_, "V").concat(P) : p ? "M".concat(_, ",").concat(O * p, "V0.5H").concat(P, "V").concat(O * p) : "M".concat(_, ",0.5H").concat(P)
  }), M.map(function (e, r) {
    return t.createElement(zs.g, {
      key: e,
      className: "tick",
      opacity: R[r].opacity,
      transform: R[r].transform
    }, t.createElement(zs.line, Pe({
      stroke: "currentColor"
    }, _e({}, "".concat(k, "2"), O * f))), t.createElement(zs.text, Pe({
      fill: "currentColor",
      dy: "top" === a ? "0em" : "bottom" === a ? "0.71em" : "0.32em"
    }, _e({}, k, O * A)), j(e)));
  }));
};

$s.displayName = "Axis";
var Hs = t.memo($s);

var Gs = function Gs(t) {
  var e = ke(t);
  return null != t && ("object" == e || "function" == e);
},
    Ys = "object" == ke(d) && d && d.Object === Object && d,
    Ks = "object" == ("undefined" == typeof self ? "undefined" : ke(self)) && self && self.Object === Object && self,
    Xs = Ys || Ks || Function("return this")(),
    Qs = function Qs() {
  return Xs.Date.now();
},
    Js = Xs.Symbol,
    Zs = Object.prototype,
    tc = Zs.hasOwnProperty,
    ec = Zs.toString,
    rc = Js ? Js.toStringTag : void 0;

var nc = function nc(t) {
  var e = tc.call(t, rc),
      r = t[rc];

  try {
    t[rc] = void 0;
    var n = !0;
  } catch (t) {}

  var i = ec.call(t);
  return n && (e ? t[rc] = r : delete t[rc]), i;
},
    ic = Object.prototype.toString;

var oc = function oc(t) {
  return ic.call(t);
},
    ac = Js ? Js.toStringTag : void 0;

var uc = function uc(t) {
  return null == t ? void 0 === t ? "[object Undefined]" : "[object Null]" : ac && ac in Object(t) ? nc(t) : oc(t);
};

var sc = function sc(t) {
  return null != t && "object" == ke(t);
};

var cc = function cc(t) {
  return "symbol" == ke(t) || sc(t) && "[object Symbol]" == uc(t);
},
    lc = /^\s+|\s+$/g,
    fc = /^[-+]0x[0-9a-f]+$/i,
    dc = /^0b[01]+$/i,
    pc = /^0o[0-7]+$/i,
    hc = parseInt;

var vc = function vc(t) {
  if ("number" == typeof t) return t;
  if (cc(t)) return NaN;

  if (Gs(t)) {
    var e = "function" == typeof t.valueOf ? t.valueOf() : t;
    t = Gs(e) ? e + "" : e;
  }

  if ("string" != typeof t) return 0 === t ? t : +t;
  t = t.replace(lc, "");
  var r = dc.test(t);
  return r || pc.test(t) ? hc(t.slice(2), r ? 2 : 8) : fc.test(t) ? NaN : +t;
},
    yc = Math.max,
    gc = Math.min;

var mc,
    bc = function bc(t, e, r) {
  var n,
      i,
      o,
      a,
      u,
      s,
      c = 0,
      l = !1,
      f = !1,
      d = !0;
  if ("function" != typeof t) throw new TypeError("Expected a function");

  function p(e) {
    var r = n,
        o = i;
    return n = i = void 0, c = e, a = t.apply(o, r);
  }

  function h(t) {
    return c = t, u = setTimeout(y, e), l ? p(t) : a;
  }

  function v(t) {
    var r = t - s;
    return void 0 === s || r >= e || r < 0 || f && t - c >= o;
  }

  function y() {
    var t = Qs();
    if (v(t)) return g(t);
    u = setTimeout(y, function (t) {
      var r = e - (t - s);
      return f ? gc(r, o - (t - c)) : r;
    }(t));
  }

  function g(t) {
    return u = void 0, d && n ? p(t) : (n = i = void 0, a);
  }

  function m() {
    var t = Qs(),
        r = v(t);

    if (n = arguments, i = this, s = t, r) {
      if (void 0 === u) return h(s);
      if (f) return clearTimeout(u), u = setTimeout(y, e), p(s);
    }

    return void 0 === u && (u = setTimeout(y, e)), a;
  }

  return e = vc(e) || 0, Gs(r) && (l = !!r.leading, o = (f = "maxWait" in r) ? yc(vc(r.maxWait) || 0, e) : o, d = "trailing" in r ? !!r.trailing : d), m.cancel = function () {
    void 0 !== u && clearTimeout(u), c = 0, n = s = i = u = void 0;
  }, m.flush = function () {
    return void 0 === u ? a : g(Qs());
  }, m;
},
    wc = [],
    xc = "ResizeObserver loop completed with undelivered notifications.";

!function (t) {
  t.BORDER_BOX = "border-box", t.CONTENT_BOX = "content-box", t.DEVICE_PIXEL_CONTENT_BOX = "device-pixel-content-box";
}(mc || (mc = {}));

var Oc,
    Sc = function () {
  function t(t, e, r, n) {
    return this.x = t, this.y = e, this.width = r, this.height = n, this.top = this.y, this.left = this.x, this.bottom = this.top + this.height, this.right = this.left + this.width, Object.freeze(this);
  }

  return t.fromRect = function (e) {
    return new t(e.x, e.y, e.width, e.height);
  }, t;
}(),
    Ec = function Ec(t) {
  return t instanceof SVGElement && "getBBox" in t;
},
    kc = function kc(t) {
  if (Ec(t)) {
    var e = t.getBBox(),
        r = e.width,
        n = e.height;
    return !r && !n;
  }

  var i = t,
      o = i.offsetWidth,
      a = i.offsetHeight;
  return !(o || a || t.getClientRects().length);
},
    Ac = "undefined" != typeof window ? window : {},
    jc = new Map(),
    Tc = /auto|scroll/,
    _c = /^tb|vertical/,
    Pc = /msie|trident/i.test(Ac.navigator && Ac.navigator.userAgent),
    Mc = function Mc(t) {
  return parseFloat(t || "0");
},
    Rc = function Rc(t, e, r) {
  return void 0 === t && (t = 0), void 0 === e && (e = 0), void 0 === r && (r = !1), Object.freeze({
    inlineSize: (r ? e : t) || 0,
    blockSize: (r ? t : e) || 0
  });
},
    Ic = Object.freeze({
  devicePixelContentBoxSize: Rc(),
  borderBoxSize: Rc(),
  contentBoxSize: Rc(),
  contentRect: new Sc(0, 0, 0, 0)
}),
    Cc = function Cc(t) {
  if (jc.has(t)) return jc.get(t);
  if (kc(t)) return jc.set(t, Ic), Ic;

  var e = getComputedStyle(t),
      r = Ec(t) && t.ownerSVGElement && t.getBBox(),
      n = !Pc && "border-box" === e.boxSizing,
      i = _c.test(e.writingMode || ""),
      o = !r && Tc.test(e.overflowY || ""),
      a = !r && Tc.test(e.overflowX || ""),
      u = r ? 0 : Mc(e.paddingTop),
      s = r ? 0 : Mc(e.paddingRight),
      c = r ? 0 : Mc(e.paddingBottom),
      l = r ? 0 : Mc(e.paddingLeft),
      f = r ? 0 : Mc(e.borderTopWidth),
      d = r ? 0 : Mc(e.borderRightWidth),
      p = r ? 0 : Mc(e.borderBottomWidth),
      h = l + s,
      v = u + c,
      y = (r ? 0 : Mc(e.borderLeftWidth)) + d,
      g = f + p,
      m = a ? t.offsetHeight - g - t.clientHeight : 0,
      b = o ? t.offsetWidth - y - t.clientWidth : 0,
      w = n ? h + y : 0,
      x = n ? v + g : 0,
      O = r ? r.width : Mc(e.width) - w - b,
      S = r ? r.height : Mc(e.height) - x - m,
      E = O + h + b + y,
      k = S + v + m + g,
      A = Object.freeze({
    devicePixelContentBoxSize: Rc(Math.round(O * devicePixelRatio), Math.round(S * devicePixelRatio), i),
    borderBoxSize: Rc(E, k, i),
    contentBoxSize: Rc(O, S, i),
    contentRect: new Sc(l, u, O, S)
  });

  return jc.set(t, A), A;
},
    Vc = function Vc(t, e) {
  var r = Cc(t),
      n = r.borderBoxSize,
      i = r.contentBoxSize,
      o = r.devicePixelContentBoxSize;

  switch (e) {
    case mc.DEVICE_PIXEL_CONTENT_BOX:
      return o;

    case mc.BORDER_BOX:
      return n;

    default:
      return i;
  }
},
    Nc = function Nc(t) {
  var e = Cc(t);
  this.target = t, this.contentRect = e.contentRect, this.borderBoxSize = [e.borderBoxSize], this.contentBoxSize = [e.contentBoxSize], this.devicePixelContentBoxSize = [e.devicePixelContentBoxSize];
},
    Fc = function Fc(t) {
  if (kc(t)) return 1 / 0;

  for (var e = 0, r = t.parentNode; r;) {
    e += 1, r = r.parentNode;
  }

  return e;
},
    Lc = function Lc() {
  var t = 1 / 0,
      e = [];
  wc.forEach(function (r) {
    if (0 !== r.activeTargets.length) {
      var n = [];
      r.activeTargets.forEach(function (e) {
        var r = new Nc(e.target),
            i = Fc(e.target);
        n.push(r), e.lastReportedSize = Vc(e.target, e.observedBox), i < t && (t = i);
      }), e.push(function () {
        r.callback.call(r.observer, n, r.observer);
      }), r.activeTargets.splice(0, r.activeTargets.length);
    }
  });

  for (var r = 0, n = e; r < n.length; r++) {
    (0, n[r])();
  }

  return t;
},
    Dc = function Dc(t) {
  jc.clear(), wc.forEach(function (e) {
    e.activeTargets.splice(0, e.activeTargets.length), e.skippedTargets.splice(0, e.skippedTargets.length), e.observationTargets.forEach(function (r) {
      r.isActive() && (Fc(r.target) > t ? e.activeTargets.push(r) : e.skippedTargets.push(r));
    });
  });
},
    zc = function zc() {
  var t,
      e = 0;

  for (Dc(e); wc.some(function (t) {
    return t.activeTargets.length > 0;
  });) {
    e = Lc(), Dc(e);
  }

  return wc.some(function (t) {
    return t.skippedTargets.length > 0;
  }) && ("function" == typeof ErrorEvent ? t = new ErrorEvent("error", {
    message: xc
  }) : ((t = document.createEvent("Event")).initEvent("error", !1, !1), t.message = xc), window.dispatchEvent(t)), e > 0;
},
    qc = [],
    Bc = function Bc(t) {
  if (!Oc) {
    var e = document.createTextNode("");
    new MutationObserver(function () {
      return qc.splice(0).forEach(function (t) {
        return t();
      });
    }).observe(e, {
      characterData: !0
    }), Oc = function Oc() {
      e.textContent = "";
    };
  }

  qc.push(t), Oc();
},
    Uc = 0,
    Wc = {
  attributes: !0,
  characterData: !0,
  childList: !0,
  subtree: !0
},
    $c = ["resize", "load", "transitionend", "animationend", "animationstart", "animationiteration", "keyup", "keydown", "mouseup", "mousedown", "mouseover", "mouseout", "blur", "focus"],
    Hc = !1,
    Gc = new (function () {
  function t() {
    var t = this;
    this.stopped = !0, this.listener = function () {
      return t.schedule();
    };
  }

  return t.prototype.run = function (t) {
    var e,
        r = this;
    Hc || (Hc = !0, e = function e() {
      var e = !1;

      try {
        e = zc();
      } finally {
        if (Hc = !1, !Uc) return;
        e ? r.run(60) : t ? r.run(t - 1) : r.start();
      }
    }, Bc(function () {
      requestAnimationFrame(e);
    }));
  }, t.prototype.schedule = function () {
    this.stop(), this.run(12);
  }, t.prototype.observe = function () {
    var t = this,
        e = function e() {
      return t.observer && t.observer.observe(document.body, Wc);
    };

    document.body ? e() : Ac.addEventListener("DOMContentLoaded", e);
  }, t.prototype.start = function () {
    var t = this;
    this.stopped && (this.stopped = !1, this.observer = new MutationObserver(this.listener), this.observe(), $c.forEach(function (e) {
      return Ac.addEventListener(e, t.listener, !0);
    }));
  }, t.prototype.stop = function () {
    var t = this;
    this.stopped || (this.observer && this.observer.disconnect(), $c.forEach(function (e) {
      return Ac.removeEventListener(e, t.listener, !0);
    }), this.stopped = !0);
  }, t;
}())(),
    Yc = function Yc(t) {
  !Uc && t > 0 && Gc.start(), !(Uc += t) && Gc.stop();
},
    Kc = function () {
  function t(t, e) {
    this.target = t, this.observedBox = e || mc.CONTENT_BOX, this.lastReportedSize = {
      inlineSize: 0,
      blockSize: 0
    };
  }

  return t.prototype.isActive = function () {
    var t = Vc(this.target, this.observedBox);
    return function (t) {
      return !Ec(t) && !function (t) {
        switch (t.tagName) {
          case "INPUT":
            if ("image" !== t.type) break;

          case "VIDEO":
          case "AUDIO":
          case "EMBED":
          case "OBJECT":
          case "CANVAS":
          case "IFRAME":
          case "IMG":
            return !0;
        }

        return !1;
      }(t) && "inline" === getComputedStyle(t).display;
    }(this.target) && (this.lastReportedSize = t), this.lastReportedSize.inlineSize !== t.inlineSize || this.lastReportedSize.blockSize !== t.blockSize;
  }, t;
}(),
    Xc = function Xc(t, e) {
  this.activeTargets = [], this.skippedTargets = [], this.observationTargets = [], this.observer = t, this.callback = e;
},
    Qc = new Map(),
    Jc = function Jc(t, e) {
  for (var r = 0; r < t.length; r += 1) {
    if (t[r].target === e) return r;
  }

  return -1;
},
    Zc = function () {
  function t() {}

  return t.connect = function (t, e) {
    var r = new Xc(t, e);
    wc.push(r), Qc.set(t, r);
  }, t.observe = function (t, e, r) {
    if (Qc.has(t)) {
      var n = Qc.get(t);
      Jc(n.observationTargets, e) < 0 && (n.observationTargets.push(new Kc(e, r && r.box)), Yc(1), Gc.schedule());
    }
  }, t.unobserve = function (t, e) {
    if (Qc.has(t)) {
      var r = Qc.get(t),
          n = Jc(r.observationTargets, e);
      n >= 0 && (r.observationTargets.splice(n, 1), Yc(-1));
    }
  }, t.disconnect = function (t) {
    if (Qc.has(t)) {
      var e = Qc.get(t);
      wc.splice(wc.indexOf(e), 1), Qc["delete"](t), Yc(-e.observationTargets.length);
    }
  }, t;
}(),
    tl = function () {
  function t(t) {
    if (0 === arguments.length) throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
    if ("function" != typeof t) throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
    Zc.connect(this, t);
  }

  return t.prototype.observe = function (t, e) {
    if (0 === arguments.length) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (t instanceof Element == !1) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
    Zc.observe(this, t, e);
  }, t.prototype.unobserve = function (t) {
    if (0 === arguments.length) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (t instanceof Element == !1) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
    Zc.unobserve(this, t);
  }, t.prototype.disconnect = function () {
    Zc.disconnect(this);
  }, t.toString = function () {
    return "function ResizeObserver () { [polyfill code] }";
  }, t;
}(),
    el = s({}),
    rl = function rl(r) {
  var n = r.children,
      i = r.margin,
      o = r.width,
      a = r.height,
      u = Ne(r, ["children", "margin", "width", "height"]),
      s = e(null),
      c = o - i.left - i.right,
      l = a - i.top - i.bottom;
  return c <= 0 || l <= 0 ? null : t.createElement(el.Provider, {
    value: {
      transform: "translate(".concat(i.left, ", ").concat(i.top, ")"),
      chartWidth: c,
      chartHeight: l,
      margin: i,
      getBoundingClientRect: function getBoundingClientRect() {
        return s.current ? s.current.getBoundingClientRect() : {};
      }
    }
  }, t.createElement("svg", Pe({
    width: o,
    height: a,
    ref: s
  }, u), t.createElement("g", {
    transform: "translate(".concat(i.left, ", ").concat(i.top, ")")
  }, t.createElement(el.Consumer, null, function (t) {
    return n(t);
  }))));
};

rl.displayName = "Plot", rl.defaultProps = {
  margin: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }
};

var nl = function nl(r) {
  var n = e(null),
      o = De(u({
    width: 0,
    height: 0
  }), 2),
      a = o[0],
      s = o[1],
      c = e();
  i(function () {
    var t = bc(function () {
      n.current && s({
        width: n.current.offsetWidth,
        height: n.current.offsetHeight
      });
    }, 300),
        e = new tl(function (e, r) {
      c.current = r, t();
    });
    return t(), e.observe(n.current), function () {
      c.current && c.current.disconnect();
    };
  }, []);
  var l = Object.keys(r).reduce(function (t, e) {
    return void 0 !== r[e] && (t[e] = r[e]), t;
  }, {});
  return t.createElement("div", {
    ref: n,
    style: {
      height: "100%",
      width: "100%"
    }
  }, t.createElement(rl, Pe({
    width: a.width,
    height: a.height
  }, l)));
};

nl.displayName = "FlexPlot", nl.propTypes = rl.propTypes;

var il = t.memo(nl),
    ol = function ol(t) {
  return t.reduce(function (t, e) {
    var r = e[0],
        n = e[1];
    return t[r] = n, t;
  }, {});
},
    al = "undefined" != typeof window && window.document && window.document.createElement ? c : i;

function ul(t) {
  var e = t.getBoundingClientRect();
  return {
    width: e.width,
    height: e.height,
    top: e.top,
    right: e.right,
    bottom: e.bottom,
    left: e.left,
    x: e.left,
    y: e.top
  };
}

function sl(t) {
  if ("[object Window]" !== {}.toString.call(t)) {
    var e = t.ownerDocument;
    return e ? e.defaultView : window;
  }

  return t;
}

function cl(t) {
  var e = sl(t);
  return {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}

function ll(t) {
  return t instanceof sl(t).Element;
}

function fl(t) {
  return t instanceof sl(t).HTMLElement;
}

function dl(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}

function pl(t) {
  return sl(t).getComputedStyle(t);
}

function hl(t) {
  return parseFloat(t) || 0;
}

function vl(t) {
  var e = fl(t) ? pl(t) : {};
  return {
    top: hl(e.borderTopWidth),
    right: hl(e.borderRightWidth),
    bottom: hl(e.borderBottomWidth),
    left: hl(e.borderLeftWidth)
  };
}

function yl(t, e, r) {
  void 0 === r && (r = !1);
  var n = ul(t),
      i = {
    scrollLeft: 0,
    scrollTop: 0
  },
      o = {
    x: 0,
    y: 0
  };
  return r || ("body" !== dl(e) && (i = function (t) {
    return t !== sl(t) && fl(t) ? {
      scrollLeft: (e = t).scrollLeft,
      scrollTop: e.scrollTop
    } : cl(t);
    var e;
  }(e)), fl(e) && (o = function (t) {
    var e = ul(t),
        r = vl(t);
    return {
      x: e.x + r.left,
      y: e.y + r.top
    };
  }(e))), {
    x: n.left + i.scrollLeft - o.x,
    y: n.top + i.scrollTop - o.y,
    width: n.width,
    height: n.height
  };
}

function gl(t) {
  return {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: t.offsetWidth,
    height: t.offsetHeight
  };
}

function ml(t) {
  return "html" === dl(t) ? t : t.parentNode || t.host || document.ownerDocument || document.documentElement;
}

function bl(t, e) {
  void 0 === e && (e = []);

  var r = function t(e) {
    if (["html", "body", "#document"].indexOf(dl(e)) >= 0) return e.ownerDocument.body;

    if (fl(e)) {
      var r = pl(e),
          n = r.overflow,
          i = r.overflowX,
          o = r.overflowY;
      if (/auto|scroll|overlay|hidden/.test(n + o + i)) return e;
    }

    return t(ml(e));
  }(t),
      n = "body" === dl(r),
      i = n ? sl(r) : r,
      o = e.concat(i);

  return n ? o : o.concat(bl(ml(i)));
}

function wl(t) {
  return ["table", "td", "th"].indexOf(dl(t)) >= 0;
}

function xl(t) {
  var e;
  return !fl(t) || !(e = t.offsetParent) || void 0 !== window.InstallTrigger && "fixed" === pl(e).position ? null : e;
}

function Ol(t) {
  for (var e = sl(t), r = xl(t); r && wl(r);) {
    r = xl(r);
  }

  return r && "body" === dl(r) && "static" === pl(r).position ? e : r || e;
}

var Sl = "top",
    El = "bottom",
    kl = "right",
    Al = "left",
    jl = [Sl, El, kl, Al],
    Tl = jl.reduce(function (t, e) {
  return t.concat([e + "-start", e + "-end"]);
}, []),
    _l = [].concat(jl, ["auto"]).reduce(function (t, e) {
  return t.concat([e, e + "-start", e + "-end"]);
}, []),
    Pl = ["beforeRead", "read", "afterRead", "beforeMain", "main", "afterMain", "beforeWrite", "write", "afterWrite"];

function Ml(t) {
  var e = new Map(),
      r = new Set(),
      n = [];
  return t.forEach(function (t) {
    e.set(t.name, t);
  }), t.forEach(function (t) {
    r.has(t.name) || function t(i) {
      r.add(i.name), [].concat(i.requires || [], i.requiresIfExists || []).forEach(function (n) {
        if (!r.has(n)) {
          var i = e.get(n);
          i && t(i);
        }
      }), n.push(i);
    }(t);
  }), n;
}

function Rl(t) {
  var e;
  return function () {
    return e || (e = new Promise(function (r) {
      Promise.resolve().then(function () {
        e = void 0, r(t());
      });
    })), e;
  };
}

function Il(t) {
  for (var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++) {
    r[n - 1] = arguments[n];
  }

  return [].concat(r).reduce(function (t, e) {
    return t.replace(/%s/, e);
  }, t);
}

var Cl = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s',
    Vl = ["name", "enabled", "phase", "fn", "effect", "requires", "options"];

function Nl(t, e) {
  var r = new Set();
  return t.filter(function (t) {
    var n = e(t);
    if (!r.has(n)) return r.add(n), !0;
  });
}

var Fl = [].push,
    Ll = Math.min,
    Dl = !g(function () {
  return !RegExp(4294967295, "y");
});

function zl(t) {
  return t.split("-")[0];
}

Qa("split", 2, function (t, e, r) {
  var n;
  return n = "c" == "abbc".split(/(b)*/)[1] || 4 != "test".split(/(?:)/, -1).length || 2 != "ab".split(/(?:ab)*/).length || 4 != ".".split(/(.?)(.?)/).length || ".".split(/()()/).length > 1 || "".split(/.?/).length ? function (t, r) {
    var n = String(j(this)),
        i = void 0 === r ? 4294967295 : r >>> 0;
    if (0 === i) return [];
    if (void 0 === t) return [n];
    if (!fa(t)) return e.call(n, t, i);

    for (var o, a, u, s = [], c = (t.ignoreCase ? "i" : "") + (t.multiline ? "m" : "") + (t.unicode ? "u" : "") + (t.sticky ? "y" : ""), l = 0, f = new RegExp(t.source, c + "g"); (o = Va.call(f, n)) && !((a = f.lastIndex) > l && (s.push(n.slice(l, o.index)), o.length > 1 && o.index < n.length && Fl.apply(s, o.slice(1)), u = o[0].length, l = a, s.length >= i));) {
      f.lastIndex === o.index && f.lastIndex++;
    }

    return l === n.length ? !u && f.test("") || s.push("") : s.push(n.slice(l)), s.length > i ? s.slice(0, i) : s;
  } : "0".split(void 0, 0).length ? function (t, r) {
    return void 0 === t && 0 === r ? [] : e.call(this, t, r);
  } : e, [function (e, r) {
    var i = j(this),
        o = null == e ? void 0 : e[t];
    return void 0 !== o ? o.call(e, i, r) : n.call(String(i), e, r);
  }, function (t, i) {
    var o = r(n, t, this, i, n !== e);
    if (o.done) return o.value;
    var a = D(t),
        u = String(this),
        s = Qi(a, RegExp),
        c = a.unicode,
        l = (a.ignoreCase ? "i" : "") + (a.multiline ? "m" : "") + (a.unicode ? "u" : "") + (Dl ? "y" : "g"),
        f = new s(Dl ? a : "^(?:" + a.source + ")", l),
        d = void 0 === i ? 4294967295 : i >>> 0;
    if (0 === d) return [];
    if (0 === u.length) return null === tu(f, u) ? [u] : [];

    for (var p = 0, h = 0, v = []; h < u.length;) {
      f.lastIndex = Dl ? h : 0;
      var y,
          g = tu(f, Dl ? u : u.slice(h));
      if (null === g || (y = Ll(Ot(f.lastIndex + (Dl ? 0 : h)), u.length)) === p) h = Za(u, h, c);else {
        if (v.push(u.slice(p, h)), v.length === d) return v;

        for (var m = 1; m <= g.length - 1; m++) {
          if (v.push(g[m]), v.length === d) return v;
        }

        h = p = y;
      }
    }

    return v.push(u.slice(p)), v;
  }];
}, !Dl);
var ql = "Popper: Invalid reference or popper argument provided to Popper, they must be either a valid DOM element, virtual element, or a jQuery-wrapped DOM element.",
    Bl = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};

function Ul() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++) {
    e[r] = arguments[r];
  }

  return !e.some(function (t) {
    return !(t && "function" == typeof t.getBoundingClientRect);
  });
}

function Wl(t) {
  void 0 === t && (t = {});
  var e = t,
      r = e.defaultModifiers,
      n = void 0 === r ? [] : r,
      i = e.defaultOptions,
      o = void 0 === i ? Bl : i;
  return function (t, e, r) {
    void 0 === r && (r = o);
    var i = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Bl, {}, o),
      modifiersData: {},
      elements: {
        reference: t,
        popper: e
      },
      attributes: {},
      styles: {}
    },
        a = [],
        u = !1,
        s = {
      state: i,
      setOptions: function setOptions(r) {
        c(), i.options = Object.assign({}, o, {}, i.options, {}, r), i.scrollParents = {
          reference: ll(t) ? bl(t) : [],
          popper: bl(e)
        };

        var u = function (t) {
          var e = Ml(t);
          return Pl.reduce(function (t, r) {
            return t.concat(e.filter(function (t) {
              return t.phase === r;
            }));
          }, []);
        }([].concat(i.options.modifiers.filter(function (t) {
          return !n.find(function (e) {
            return e.name === t.name;
          });
        }), n.map(function (t) {
          return Object.assign({}, t, {}, i.options.modifiers.find(function (e) {
            return e.name === t.name;
          }));
        })));

        if ("production" !== process.env.NODE_ENV) {
          if (function (t) {
            t.forEach(function (e) {
              Object.keys(e).forEach(function (r) {
                switch (r) {
                  case "name":
                    "string" != typeof e.name && console.error(Il(Cl, String(e.name), '"name"', '"string"', '"' + String(e.name) + '"'));
                    break;

                  case "enabled":
                    "boolean" != typeof e.enabled && console.error(Il(Cl, e.name, '"enabled"', '"boolean"', '"' + String(e.enabled) + '"'));

                  case "phase":
                    Pl.indexOf(e.phase) < 0 && console.error(Il(Cl, e.name, '"phase"', "either " + Pl.join(", "), '"' + String(e.phase) + '"'));
                    break;

                  case "fn":
                    "function" != typeof e.fn && console.error(Il(Cl, e.name, '"fn"', '"function"', '"' + String(e.fn) + '"'));
                    break;

                  case "effect":
                    "function" != typeof e.effect && console.error(Il(Cl, e.name, '"effect"', '"function"', '"' + String(e.fn) + '"'));
                    break;

                  case "requires":
                    Array.isArray(e.requires) || console.error(Il(Cl, e.name, '"requires"', '"array"', '"' + String(e.requires) + '"'));
                    break;

                  case "requiresIfExists":
                    Array.isArray(e.requiresIfExists) || console.error(Il(Cl, e.name, '"requiresIfExists"', '"array"', '"' + String(e.requiresIfExists) + '"'));
                    break;

                  case "options":
                  case "data":
                    break;

                  default:
                    console.error('PopperJS: an invalid property has been provided to the "' + e.name + '" modifier, valid properties are ' + Vl.map(function (t) {
                      return '"' + t + '"';
                    }).join(", ") + '; but "' + r + '" was provided.');
                }

                e.requires && e.requires.forEach(function (r) {
                  null == t.find(function (t) {
                    return t.name === r;
                  }) && console.error(Il('Popper: modifier "%s" requires "%s", but "%s" modifier is not available', String(e.name), r, r));
                });
              });
            });
          }(Nl([].concat(u, i.options.modifiers), function (t) {
            return t.name;
          })), "auto" === zl(i.options.placement)) u.find(function (t) {
            return "flip" === t.name;
          }) || console.error(['Popper: "auto" placements require the "flip" modifier be', "present and enabled to work."].join(" "));
          var l = pl(e);
          [l.marginTop, l.marginRight, l.marginBottom, l.marginLeft].some(function (t) {
            return parseFloat(t);
          }) && console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', "between the popper and its reference element or boundary.", "To replicate margin, use the `offset` modifier, as well as", "the `padding` option in the `preventOverflow` and `flip`", "modifiers."].join(" "));
        }

        return i.orderedModifiers = u.filter(function (t) {
          return t.enabled;
        }), i.orderedModifiers.forEach(function (t) {
          var e = t.name,
              r = t.options,
              n = void 0 === r ? {} : r,
              o = t.effect;

          if ("function" == typeof o) {
            var u = o({
              state: i,
              name: e,
              instance: s,
              options: n
            });
            a.push(u || function () {});
          }
        }), s.update();
      },
      forceUpdate: function forceUpdate() {
        if (!u) {
          var t = i.elements,
              e = t.reference,
              r = t.popper;

          if (Ul(e, r)) {
            i.rects = {
              reference: yl(e, Ol(r), "fixed" === i.options.strategy),
              popper: gl(r)
            }, i.reset = !1, i.placement = i.options.placement, i.orderedModifiers.forEach(function (t) {
              return i.modifiersData[t.name] = Object.assign({}, t.data);
            });

            for (var n = 0, o = 0; o < i.orderedModifiers.length; o++) {
              if ("production" !== process.env.NODE_ENV && (n += 1) > 100) {
                console.error("Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.");
                break;
              }

              if (!0 !== i.reset) {
                var a = i.orderedModifiers[o],
                    c = a.fn,
                    l = a.options,
                    f = void 0 === l ? {} : l,
                    d = a.name;
                "function" == typeof c && (i = c({
                  state: i,
                  options: f,
                  name: d,
                  instance: s
                }) || i);
              } else i.reset = !1, o = -1;
            }
          } else "production" !== process.env.NODE_ENV && console.error(ql);
        }
      },
      update: Rl(function () {
        return new Promise(function (t) {
          s.forceUpdate(), t(i);
        });
      }),
      destroy: function destroy() {
        c(), u = !0;
      }
    };
    if (!Ul(t, e)) return "production" !== process.env.NODE_ENV && console.error(ql), s;

    function c() {
      a.forEach(function (t) {
        return t();
      }), a = [];
    }

    return s.setOptions(r).then(function (t) {
      !u && r.onFirstUpdate && r.onFirstUpdate(t);
    }), s;
  };
}

var $l = {
  passive: !0
};
var Hl = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function fn() {},
  effect: function effect(t) {
    var e = t.state,
        r = t.instance,
        n = t.options,
        i = n.scroll,
        o = void 0 === i || i,
        a = n.resize,
        u = void 0 === a || a,
        s = sl(e.elements.popper),
        c = [].concat(e.scrollParents.reference, e.scrollParents.popper);
    return o && c.forEach(function (t) {
      t.addEventListener("scroll", r.update, $l);
    }), u && s.addEventListener("resize", r.update, $l), function () {
      o && c.forEach(function (t) {
        t.removeEventListener("scroll", r.update, $l);
      }), u && s.removeEventListener("resize", r.update, $l);
    };
  },
  data: {}
};

function Gl(t) {
  return t.split("-")[1];
}

function Yl(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}

function Kl(t) {
  var e,
      r = t.reference,
      n = t.element,
      i = t.placement,
      o = i ? zl(i) : null,
      a = i ? Gl(i) : null,
      u = r.x + r.width / 2 - n.width / 2,
      s = r.y + r.height / 2 - n.height / 2;

  switch (o) {
    case Sl:
      e = {
        x: u,
        y: r.y - n.height
      };
      break;

    case El:
      e = {
        x: u,
        y: r.y + r.height
      };
      break;

    case kl:
      e = {
        x: r.x + r.width,
        y: s
      };
      break;

    case Al:
      e = {
        x: r.x - n.width,
        y: s
      };
      break;

    default:
      e = {
        x: r.x,
        y: r.y
      };
  }

  var c = o ? Yl(o) : null;

  if (null != c) {
    var l = "y" === c ? "height" : "width";

    switch (a) {
      case "start":
        e[c] = Math.floor(e[c]) - Math.floor(r[l] / 2 - n[l] / 2);
        break;

      case "end":
        e[c] = Math.floor(e[c]) + Math.ceil(r[l] / 2 - n[l] / 2);
    }
  }

  return e;
}

var Xl = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: function fn(t) {
    var e = t.state,
        r = t.name;
    e.modifiersData[r] = Kl({
      reference: e.rects.reference,
      element: e.rects.popper,
      strategy: "absolute",
      placement: e.placement
    });
  },
  data: {}
};

function Ql(t) {
  return t.ownerDocument.documentElement;
}

var Jl = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};

function Zl(t) {
  var e,
      r = t.popper,
      n = t.popperRect,
      i = t.placement,
      o = t.offsets,
      a = t.position,
      u = t.gpuAcceleration,
      s = t.adaptive,
      c = function (t) {
    var e = t.x,
        r = t.y,
        n = window.devicePixelRatio || 1;
    return {
      x: Math.round(e * n) / n || 0,
      y: Math.round(r * n) / n || 0
    };
  }(o),
      l = c.x,
      f = c.y,
      d = o.hasOwnProperty("x"),
      p = o.hasOwnProperty("y"),
      h = Al,
      v = Sl;

  if (s) {
    var y = Ol(r);
    y === sl(r) && (y = Ql(r)), i === Sl && (v = El, f -= y.clientHeight - n.height, f *= u ? 1 : -1), i === Al && (h = kl, l -= y.clientWidth - n.width, l *= u ? 1 : -1);
  }

  var g,
      m = Object.assign({
    position: a
  }, s && Jl);
  return u ? Object.assign({}, m, ((g = {})[v] = p ? "0" : "", g[h] = d ? "0" : "", g.transform = (window.devicePixelRatio || 1) < 2 ? "translate(" + l + "px, " + f + "px)" : "translate3d(" + l + "px, " + f + "px, 0)", g)) : Object.assign({}, m, ((e = {})[v] = p ? f + "px" : "", e[h] = d ? l + "px" : "", e.transform = "", e));
}

var tf = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: function fn(t) {
    var e = t.state,
        r = t.options,
        n = r.gpuAcceleration,
        i = void 0 === n || n,
        o = r.adaptive,
        a = void 0 === o || o,
        u = {
      placement: zl(e.placement),
      popper: e.elements.popper,
      popperRect: e.rects.popper,
      gpuAcceleration: i
    };
    e.styles.popper = Object.assign({}, e.styles.popper, {}, Zl(Object.assign({}, u, {
      offsets: e.modifiersData.popperOffsets,
      position: e.options.strategy,
      adaptive: a
    }))), null != e.modifiersData.arrow && (e.styles.arrow = Object.assign({}, e.styles.arrow, {}, Zl(Object.assign({}, u, {
      offsets: e.modifiersData.arrow,
      position: "absolute",
      adaptive: !1
    })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
      "data-popper-placement": e.placement
    });
  },
  data: {}
};
var ef = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: function fn(t) {
    var e = t.state;
    Object.keys(e.elements).forEach(function (t) {
      var r = e.styles[t] || {},
          n = e.attributes[t] || {},
          i = e.elements[t];
      fl(i) && dl(i) && (Object.assign(i.style, r), Object.keys(n).forEach(function (t) {
        var e = n[t];
        !1 === e ? i.removeAttribute(t) : i.setAttribute(t, !0 === e ? "" : e);
      }));
    });
  },
  effect: function effect(t) {
    var e = t.state,
        r = {
      position: "absolute",
      left: "0",
      top: "0",
      margin: "0"
    };
    return Object.assign(e.elements.popper.style, r), function () {
      Object.keys(e.elements).forEach(function (t) {
        var n = e.elements[t],
            i = Object.keys(e.styles.hasOwnProperty(t) ? Object.assign({}, e.styles[t]) : r),
            o = e.attributes[t] || {},
            a = i.reduce(function (t, e) {
          var r;
          return Object.assign({}, t, ((r = {})[String(e)] = "", r));
        }, {});
        fl(n) && dl(n) && (Object.assign(n.style, a), Object.keys(o).forEach(function (t) {
          return n.removeAttribute(t);
        }));
      });
    };
  },
  requires: ["computeStyles"]
};
var rf = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: function fn(t) {
    var e = t.state,
        r = t.options,
        n = t.name,
        i = r.offset,
        o = void 0 === i ? [0, 0] : i,
        a = _l.reduce(function (t, r) {
      return t[r] = function (t, e, r) {
        var n = zl(t),
            i = [Al, Sl].indexOf(n) >= 0 ? -1 : 1,
            o = "function" == typeof r ? r(Object.assign({}, e, {
          placement: t
        })) : r,
            a = o[0],
            u = o[1];
        return a = a || 0, u = (u || 0) * i, [Al, kl].indexOf(n) >= 0 ? {
          x: u,
          y: a
        } : {
          x: a,
          y: u
        };
      }(r, e.rects, o), t;
    }, {}),
        u = a[e.placement],
        s = u.x,
        c = u.y;

    e.modifiersData.popperOffsets.x += s, e.modifiersData.popperOffsets.y += c, e.modifiersData[n] = a;
  }
},
    nf = ge.every,
    of = rn("every"),
    af = xe("every");
Wt({
  target: "Array",
  proto: !0,
  forced: !of || !af
}, {
  every: function every(t) {
    return nf(this, t, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var uf = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};

function sf(t) {
  return t.replace(/left|right|bottom|top/g, function (t) {
    return uf[t];
  });
}

var cf = {
  start: "end",
  end: "start"
};

function lf(t) {
  return t.replace(/start|end/g, function (t) {
    return cf[t];
  });
}

function ff(t, e) {
  var r = Boolean(e.getRootNode && e.getRootNode().host);
  if (t.contains(e)) return !0;

  if (r) {
    var n = e;

    do {
      if (n && t.isSameNode(n)) return !0;
      n = n.parentNode || n.host;
    } while (n);
  }

  return !1;
}

function df(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}

function pf(t, e) {
  return "viewport" === e ? df(function (t) {
    var e = sl(t);
    return {
      width: e.innerWidth,
      height: e.innerHeight,
      x: 0,
      y: 0
    };
  }(t)) : fl(e) ? ul(e) : df(function (t) {
    var e = sl(t),
        r = cl(t),
        n = yl(Ql(t), e);
    return n.height = Math.max(n.height, e.innerHeight), n.width = Math.max(n.width, e.innerWidth), n.x = -r.scrollLeft, n.y = -r.scrollTop, n;
  }(Ql(t)));
}

function hf(t, e, r) {
  var n = "clippingParents" === e ? function (t) {
    var e = bl(t),
        r = ["absolute", "fixed"].indexOf(pl(t).position) >= 0 && fl(t) ? Ol(t) : t;
    return ll(r) ? e.filter(function (t) {
      return ll(t) && ff(t, r);
    }) : [];
  }(t) : [].concat(e),
      i = [].concat(n, [r]),
      o = i[0],
      a = i.reduce(function (e, r) {
    var n = pf(t, r),
        i = function (t) {
      var e = vl(t),
          r = sl(t),
          n = t.offsetWidth - t.clientWidth - e.right,
          i = t.offsetHeight - t.clientHeight - e.bottom;
      return "html" === dl(t) && (n = r.innerWidth - t.clientWidth, i = r.innerHeight - t.clientHeight), {
        top: e.top,
        right: n,
        bottom: i,
        left: e.left
      };
    }(fl(r) ? r : Ql(t));

    return e.top = Math.max(n.top + i.top, e.top), e.right = Math.min(n.right - i.right, e.right), e.bottom = Math.min(n.bottom - i.bottom, e.bottom), e.left = Math.max(n.left + i.left, e.left), e;
  }, pf(t, o));
  return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}

function vf(t) {
  return Object.assign({}, {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }, {}, t);
}

function yf(t, e) {
  return e.reduce(function (e, r) {
    return e[r] = t, e;
  }, {});
}

function gf(t, e) {
  void 0 === e && (e = {});
  var r = e,
      n = r.placement,
      i = void 0 === n ? t.placement : n,
      o = r.boundary,
      a = void 0 === o ? "clippingParents" : o,
      u = r.rootBoundary,
      s = void 0 === u ? "viewport" : u,
      c = r.elementContext,
      l = void 0 === c ? "popper" : c,
      f = r.altBoundary,
      d = void 0 !== f && f,
      p = r.padding,
      h = void 0 === p ? 0 : p,
      v = vf("number" != typeof h ? h : yf(h, jl)),
      y = "popper" === l ? "reference" : "popper",
      g = t.elements.reference,
      m = t.rects.popper,
      b = t.elements[d ? y : l],
      w = hf(ll(b) ? b : Ql(t.elements.popper), a, s),
      x = ul(g),
      O = Kl({
    reference: x,
    element: m,
    strategy: "absolute",
    placement: i
  }),
      S = df(Object.assign({}, m, {}, O)),
      E = "popper" === l ? S : x,
      k = {
    top: w.top - E.top + v.top,
    bottom: E.bottom - w.bottom + v.bottom,
    left: w.left - E.left + v.left,
    right: E.right - w.right + v.right
  },
      A = t.modifiersData.offset;

  if ("popper" === l && A) {
    var j = A[i];
    Object.keys(k).forEach(function (t) {
      var e = [kl, El].indexOf(t) >= 0 ? 1 : -1,
          r = [Sl, El].indexOf(t) >= 0 ? "y" : "x";
      k[t] += j[r] * e;
    });
  }

  return k;
}

function mf(t, e, r) {
  return Math.max(t, Math.min(e, r));
}

function bf(t, e, r) {
  return void 0 === r && (r = {
    x: 0,
    y: 0
  }), {
    top: t.top - e.height - r.y,
    right: t.right - e.width + r.x,
    bottom: t.bottom - e.height + r.y,
    left: t.left - e.width - r.x
  };
}

function wf(t) {
  return [Sl, kl, El, Al].some(function (e) {
    return t[e] >= 0;
  });
}

var xf = Wl({
  defaultModifiers: [Hl, Xl, tf, ef, rf, {
    name: "flip",
    enabled: !0,
    phase: "main",
    fn: function fn(t) {
      var e = t.state,
          r = t.options,
          n = t.name;

      if (!e.modifiersData[n]._skip) {
        for (var i = r.fallbackPlacements, o = r.padding, a = r.boundary, u = r.rootBoundary, s = r.flipVariations, c = void 0 === s || s, l = e.options.placement, f = zl(l), d = i || (f === l ? [sf(l)] : function (t) {
          if ("auto" === zl(t)) return [];
          var e = sf(t);
          return [lf(t), e, lf(e)];
        }(l)), p = Nl([l].concat(d).reduce(function (t, r) {
          return "auto" === zl(r) ? t.concat(function (t, e) {
            void 0 === e && (e = {});
            var r = e,
                n = r.placement,
                i = r.boundary,
                o = r.rootBoundary,
                a = r.padding,
                u = r.flipVariations,
                s = Gl(n),
                c = (s ? u ? Tl : Tl.filter(function (t) {
              return Gl(t) === s;
            }) : jl).reduce(function (e, r) {
              return e[r] = gf(t, {
                placement: r,
                boundary: i,
                rootBoundary: o,
                padding: a
              })[zl(r)], e;
            }, {});
            return Object.keys(c).sort(function (t, e) {
              return c[t] - c[e];
            });
          }(e, {
            placement: r,
            boundary: a,
            rootBoundary: u,
            padding: o,
            flipVariations: c
          })) : t.concat(r);
        }, []), function (t) {
          return t;
        }), h = e.rects.reference, v = e.rects.popper, y = new Map(), g = !0, m = p[0], b = 0; b < p.length; b++) {
          var w = p[b],
              x = zl(w),
              O = "start" === Gl(w),
              S = [Sl, El].indexOf(x) >= 0,
              E = S ? "width" : "height",
              k = gf(e, {
            placement: w,
            boundary: a,
            rootBoundary: u,
            padding: o
          }),
              A = S ? O ? kl : Al : O ? El : Sl;
          h[E] > v[E] && (A = sf(A));
          var j = sf(A),
              T = [k[x] <= 0, k[A] <= 0, k[j] <= 0];

          if (T.every(function (t) {
            return t;
          })) {
            m = w, g = !1;
            break;
          }

          y.set(w, T);
        }

        if (g) for (var _ = function _(t) {
          var e = p.find(function (e) {
            var r = y.get(e);
            if (r) return r.slice(0, t).every(function (t) {
              return t;
            });
          });
          if (e) return m = e, "break";
        }, P = c ? 3 : 1; P > 0; P--) {
          if ("break" === _(P)) break;
        }
        e.placement !== m && (e.modifiersData[n]._skip = !0, e.placement = m, e.reset = !0);
      }
    },
    requiresIfExists: ["offset"],
    data: {
      _skip: !1
    }
  }, {
    name: "preventOverflow",
    enabled: !0,
    phase: "main",
    fn: function fn(t) {
      var e = t.state,
          r = t.options,
          n = t.name,
          i = r.mainAxis,
          o = void 0 === i || i,
          a = r.altAxis,
          u = void 0 !== a && a,
          s = r.boundary,
          c = r.rootBoundary,
          l = r.padding,
          f = r.tether,
          d = void 0 === f || f,
          p = r.tetherOffset,
          h = void 0 === p ? 0 : p,
          v = gf(e, {
        boundary: s,
        rootBoundary: c,
        padding: l
      }),
          y = zl(e.placement),
          g = Gl(e.placement),
          m = !g,
          b = Yl(y),
          w = "x" === b ? "y" : "x",
          x = e.modifiersData.popperOffsets,
          O = e.rects.reference,
          S = e.rects.popper,
          E = "function" == typeof h ? h(Object.assign({}, e.rects, {
        placement: e.placement
      })) : h,
          k = {
        x: 0,
        y: 0
      };

      if (o) {
        var A = "y" === b ? Sl : Al,
            j = "y" === b ? El : kl,
            T = "y" === b ? "height" : "width",
            _ = x[b],
            P = x[b] + v[A],
            M = x[b] - v[j],
            R = d ? -S[T] / 2 : 0,
            I = "start" === g ? O[T] : S[T],
            C = "start" === g ? -S[T] : -O[T],
            V = e.elements.arrow,
            N = d && V ? gl(V) : {
          width: 0,
          height: 0
        },
            F = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        },
            L = F[A],
            D = F[j],
            z = mf(0, Math.abs(O[T] - N[T]), N[T]),
            q = m ? O[T] / 2 - R - z - L - E : I - z - L - E,
            B = m ? -O[T] / 2 + R + z + D + E : C + z + D + E,
            U = e.modifiersData.offset ? e.modifiersData.offset[e.placement][b] : 0,
            W = e.modifiersData.popperOffsets[b] + q - U,
            $ = e.modifiersData.popperOffsets[b] + B - U,
            H = mf(d ? Math.min(P, W) : P, _, d ? Math.max(M, $) : M);
        e.modifiersData.popperOffsets[b] = H, k[b] = H - _;
      }

      if (u) {
        var G = "x" === b ? Sl : Al,
            Y = "x" === b ? El : kl,
            K = x[w],
            X = mf(K + v[G], K, K - v[Y]);
        e.modifiersData.popperOffsets[w] = X, k[w] = X - K;
      }

      e.modifiersData[n] = k;
    },
    requiresIfExists: ["offset"]
  }, {
    name: "arrow",
    enabled: !0,
    phase: "main",
    fn: function fn(t) {
      var e,
          r = t.state,
          n = t.name,
          i = r.elements.arrow,
          o = r.modifiersData.popperOffsets,
          a = zl(r.placement),
          u = Yl(a),
          s = [Al, kl].indexOf(a) >= 0 ? "height" : "width";

      if (i) {
        var c = r.modifiersData[n + "#persistent"].padding,
            l = gl(i),
            f = "y" === u ? Sl : Al,
            d = "y" === u ? El : kl,
            p = (r.rects.reference[s] + r.rects.reference[u] - o[u] - r.rects.popper[s]) / 2 - (o[u] - r.rects.reference[u]) / 2,
            h = mf(c[f], r.rects.popper[s] / 2 - l[s] / 2 + p, r.rects.popper[s] - l[s] - c[d]),
            v = u;
        r.modifiersData[n] = ((e = {})[v] = h, e);
      }
    },
    effect: function effect(t) {
      var e = t.state,
          r = t.options,
          n = t.name,
          i = r.element,
          o = void 0 === i ? "[data-popper-arrow]" : i,
          a = r.padding,
          u = void 0 === a ? 0 : a;
      ("string" != typeof o || (o = e.elements.popper.querySelector(o))) && (ff(e.elements.popper, o) ? (e.elements.arrow = o, e.modifiersData[n + "#persistent"] = {
        padding: vf("number" != typeof u ? u : yf(u, jl))
      }) : "production" !== process.env.NODE_ENV && console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', "element."].join(" ")));
    },
    requires: ["popperOffsets"],
    requiresIfExists: ["preventOverflow"]
  }, {
    name: "hide",
    enabled: !0,
    phase: "main",
    requiresIfExists: ["preventOverflow"],
    fn: function fn(t) {
      var e = t.state,
          r = t.name,
          n = e.rects.reference,
          i = e.rects.popper,
          o = e.modifiersData.preventOverflow,
          a = gf(e, {
        elementContext: "reference"
      }),
          u = gf(e, {
        altBoundary: !0
      }),
          s = bf(a, n),
          c = bf(u, i, o),
          l = wf(s),
          f = wf(c);
      e.modifiersData[r] = {
        referenceClippingOffsets: s,
        popperEscapeOffsets: c,
        isReferenceHidden: l,
        hasPopperEscaped: f
      }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
        "data-popper-reference-hidden": l,
        "data-popper-escaped": f
      });
    }
  }]
}),
    Of = "undefined" != typeof ArrayBuffer && "undefined" != typeof DataView,
    Sf = function Sf(t) {
  if (void 0 === t) return 0;
  var e = wt(t),
      r = Ot(e);
  if (e !== r) throw RangeError("Wrong length or index");
  return r;
},
    Ef = Math.abs,
    kf = Math.pow,
    Af = Math.floor,
    jf = Math.log,
    Tf = Math.LN2,
    _f = function _f(t, e, r) {
  var n,
      i,
      o,
      a = new Array(r),
      u = 8 * r - e - 1,
      s = (1 << u) - 1,
      c = s >> 1,
      l = 23 === e ? kf(2, -24) - kf(2, -77) : 0,
      f = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0,
      d = 0;

  for ((t = Ef(t)) != t || t === 1 / 0 ? (i = t != t ? 1 : 0, n = s) : (n = Af(jf(t) / Tf), t * (o = kf(2, -n)) < 1 && (n--, o *= 2), (t += n + c >= 1 ? l / o : l * kf(2, 1 - c)) * o >= 2 && (n++, o /= 2), n + c >= s ? (i = 0, n = s) : n + c >= 1 ? (i = (t * o - 1) * kf(2, e), n += c) : (i = t * kf(2, c - 1) * kf(2, e), n = 0)); e >= 8; a[d++] = 255 & i, i /= 256, e -= 8) {
    ;
  }

  for (n = n << e | i, u += e; u > 0; a[d++] = 255 & n, n /= 256, u -= 8) {
    ;
  }

  return a[--d] |= 128 * f, a;
},
    Pf = function Pf(t, e) {
  var r,
      n = t.length,
      i = 8 * n - e - 1,
      o = (1 << i) - 1,
      a = o >> 1,
      u = i - 7,
      s = n - 1,
      c = t[s--],
      l = 127 & c;

  for (c >>= 7; u > 0; l = 256 * l + t[s], s--, u -= 8) {
    ;
  }

  for (r = l & (1 << -u) - 1, l >>= -u, u += e; u > 0; r = 256 * r + t[s], s--, u -= 8) {
    ;
  }

  if (0 === l) l = 1 - a;else {
    if (l === o) return r ? NaN : c ? -1 / 0 : 1 / 0;
    r += kf(2, e), l -= a;
  }
  return (c ? -1 : 1) * r * kf(2, l - e);
},
    Mf = Rt.f,
    Rf = q.f,
    If = pt.get,
    Cf = pt.set,
    Vf = y.ArrayBuffer,
    _Nf2 = Vf,
    _Ff = y.DataView,
    Lf = _Ff && _Ff.prototype,
    Df = Object.prototype,
    zf = y.RangeError,
    qf = _f,
    Bf = Pf,
    Uf = function Uf(t) {
  return [255 & t];
},
    Wf = function Wf(t) {
  return [255 & t, t >> 8 & 255];
},
    $f = function $f(t) {
  return [255 & t, t >> 8 & 255, t >> 16 & 255, t >> 24 & 255];
},
    Hf = function Hf(t) {
  return t[3] << 24 | t[2] << 16 | t[1] << 8 | t[0];
},
    Gf = function Gf(t) {
  return qf(t, 23, 4);
},
    Yf = function Yf(t) {
  return qf(t, 52, 8);
},
    Kf = function Kf(t, e) {
  Rf(t.prototype, e, {
    get: function get() {
      return If(this)[e];
    }
  });
},
    Xf = function Xf(t, e, r, n) {
  var i = Sf(r),
      o = If(t);
  if (i + e > o.byteLength) throw zf("Wrong index");
  var a = If(o.buffer).bytes,
      u = i + o.byteOffset,
      s = a.slice(u, u + e);
  return n ? s : s.reverse();
},
    Qf = function Qf(t, e, r, n, i, o) {
  var a = Sf(r),
      u = If(t);
  if (a + e > u.byteLength) throw zf("Wrong index");

  for (var s = If(u.buffer).bytes, c = a + u.byteOffset, l = n(+i), f = 0; f < e; f++) {
    s[c + f] = l[o ? f : e - f - 1];
  }
};

if (Of) {
  if (!g(function () {
    Vf(1);
  }) || !g(function () {
    new Vf(-1);
  }) || g(function () {
    return new Vf(), new Vf(1.5), new Vf(NaN), "ArrayBuffer" != Vf.name;
  })) {
    for (var Jf, Zf = (_Nf2 = function Nf(t) {
      return ki(this, _Nf2), new Vf(Sf(t));
    }).prototype = Vf.prototype, td = Mf(Vf), ed = 0; td.length > ed;) {
      (Jf = td[ed++]) in _Nf2 || B(_Nf2, Jf, Vf[Jf]);
    }

    Zf.constructor = _Nf2;
  }

  Un && Fn(Lf) !== Df && Un(Lf, Df);
  var rd = new _Ff(new _Nf2(2)),
      nd = Lf.setInt8;
  rd.setInt8(0, 2147483648), rd.setInt8(1, 2147483649), !rd.getInt8(0) && rd.getInt8(1) || Ti(Lf, {
    setInt8: function setInt8(t, e) {
      nd.call(this, t, e << 24 >> 24);
    },
    setUint8: function setUint8(t, e) {
      nd.call(this, t, e << 24 >> 24);
    }
  }, {
    unsafe: !0
  });
} else _Nf2 = function _Nf(t) {
  ki(this, _Nf2, "ArrayBuffer");
  var e = Sf(t);
  Cf(this, {
    bytes: Ur.call(new Array(e), 0),
    byteLength: e
  }), m || (this.byteLength = e);
}, _Ff = function Ff(t, e, r) {
  ki(this, _Ff, "DataView"), ki(t, _Nf2, "DataView");
  var n = If(t).byteLength,
      i = wt(e);
  if (i < 0 || i > n) throw zf("Wrong offset");
  if (i + (r = void 0 === r ? n - i : Ot(r)) > n) throw zf("Wrong length");
  Cf(this, {
    buffer: t,
    byteLength: r,
    byteOffset: i
  }), m || (this.buffer = t, this.byteLength = r, this.byteOffset = i);
}, m && (Kf(_Nf2, "byteLength"), Kf(_Ff, "buffer"), Kf(_Ff, "byteLength"), Kf(_Ff, "byteOffset")), Ti(_Ff.prototype, {
  getInt8: function getInt8(t) {
    return Xf(this, 1, t)[0] << 24 >> 24;
  },
  getUint8: function getUint8(t) {
    return Xf(this, 1, t)[0];
  },
  getInt16: function getInt16(t) {
    var e = Xf(this, 2, t, arguments.length > 1 ? arguments[1] : void 0);
    return (e[1] << 8 | e[0]) << 16 >> 16;
  },
  getUint16: function getUint16(t) {
    var e = Xf(this, 2, t, arguments.length > 1 ? arguments[1] : void 0);
    return e[1] << 8 | e[0];
  },
  getInt32: function getInt32(t) {
    return Hf(Xf(this, 4, t, arguments.length > 1 ? arguments[1] : void 0));
  },
  getUint32: function getUint32(t) {
    return Hf(Xf(this, 4, t, arguments.length > 1 ? arguments[1] : void 0)) >>> 0;
  },
  getFloat32: function getFloat32(t) {
    return Bf(Xf(this, 4, t, arguments.length > 1 ? arguments[1] : void 0), 23);
  },
  getFloat64: function getFloat64(t) {
    return Bf(Xf(this, 8, t, arguments.length > 1 ? arguments[1] : void 0), 52);
  },
  setInt8: function setInt8(t, e) {
    Qf(this, 1, t, Uf, e);
  },
  setUint8: function setUint8(t, e) {
    Qf(this, 1, t, Uf, e);
  },
  setInt16: function setInt16(t, e) {
    Qf(this, 2, t, Wf, e, arguments.length > 2 ? arguments[2] : void 0);
  },
  setUint16: function setUint16(t, e) {
    Qf(this, 2, t, Wf, e, arguments.length > 2 ? arguments[2] : void 0);
  },
  setInt32: function setInt32(t, e) {
    Qf(this, 4, t, $f, e, arguments.length > 2 ? arguments[2] : void 0);
  },
  setUint32: function setUint32(t, e) {
    Qf(this, 4, t, $f, e, arguments.length > 2 ? arguments[2] : void 0);
  },
  setFloat32: function setFloat32(t, e) {
    Qf(this, 4, t, Gf, e, arguments.length > 2 ? arguments[2] : void 0);
  },
  setFloat64: function setFloat64(t, e) {
    Qf(this, 8, t, Yf, e, arguments.length > 2 ? arguments[2] : void 0);
  }
});

or(_Nf2, "ArrayBuffer"), or(_Ff, "DataView");
var id = {
  ArrayBuffer: _Nf2,
  DataView: _Ff
},
    od = id.ArrayBuffer,
    ad = y.ArrayBuffer;
Wt({
  global: !0,
  forced: ad !== od
}, {
  ArrayBuffer: od
}), Pi("ArrayBuffer"), m && ("g" != /./g.flags || ha.UNSUPPORTED_Y) && q.f(RegExp.prototype, "flags", {
  configurable: !0,
  get: da
});
var ud = "undefined" != typeof Element,
    sd = "function" == typeof Map,
    cd = "function" == typeof Set,
    ld = "function" == typeof ArrayBuffer;

var fd = function fd(t, e) {
  try {
    return function t(e, r) {
      if (e === r) return !0;

      if (e && r && "object" == ke(e) && "object" == ke(r)) {
        if (e.constructor !== r.constructor) return !1;
        var n, i, o, a;

        if (Array.isArray(e)) {
          if ((n = e.length) != r.length) return !1;

          for (i = n; 0 != i--;) {
            if (!t(e[i], r[i])) return !1;
          }

          return !0;
        }

        if (sd && e instanceof Map && r instanceof Map) {
          if (e.size !== r.size) return !1;

          for (a = e.entries(); !(i = a.next()).done;) {
            if (!r.has(i.value[0])) return !1;
          }

          for (a = e.entries(); !(i = a.next()).done;) {
            if (!t(i.value[1], r.get(i.value[0]))) return !1;
          }

          return !0;
        }

        if (cd && e instanceof Set && r instanceof Set) {
          if (e.size !== r.size) return !1;

          for (a = e.entries(); !(i = a.next()).done;) {
            if (!r.has(i.value[0])) return !1;
          }

          return !0;
        }

        if (ld && ArrayBuffer.isView(e) && ArrayBuffer.isView(r)) {
          if ((n = e.length) != r.length) return !1;

          for (i = n; 0 != i--;) {
            if (e[i] !== r[i]) return !1;
          }

          return !0;
        }

        if (e.constructor === RegExp) return e.source === r.source && e.flags === r.flags;
        if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === r.valueOf();
        if (e.toString !== Object.prototype.toString) return e.toString() === r.toString();
        if ((n = (o = Object.keys(e)).length) !== Object.keys(r).length) return !1;

        for (i = n; 0 != i--;) {
          if (!Object.prototype.hasOwnProperty.call(r, o[i])) return !1;
        }

        if (ud && e instanceof Element) return !1;

        for (i = n; 0 != i--;) {
          if (!("_owner" === o[i] && e.$$typeof || t(e[o[i]], r[o[i]]))) return !1;
        }

        return !0;
      }

      return e != e && r != r;
    }(t, e);
  } catch (t) {
    if ((t.message || "").match(/stack|recursion/i)) return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw t;
  }
},
    dd = [],
    pd = function pd(n) {
  var i = n.x1,
      o = n.y1,
      a = n.x2,
      s = n.y2,
      c = n.children,
      l = void 0 === c ? null : c,
      d = n.refStyle,
      p = void 0 === d ? {} : d,
      h = n.hintStyle,
      v = void 0 === h ? {} : h,
      y = n.portalParent,
      g = void 0 === y ? document.querySelector("body") : y,
      m = n.placement,
      b = void 0 === m ? "right-start" : m,
      w = n.modifiers,
      x = void 0 === w ? [] : w,
      O = De(t.useState(null), 2),
      S = O[0],
      E = O[1],
      k = De(t.useState(null), 2),
      A = k[0],
      j = k[1],
      T = function (t, n, i) {
    void 0 === i && (i = {});
    var o = e(null),
        a = {
      onFirstUpdate: i.onFirstUpdate,
      placement: i.placement || "bottom",
      strategy: i.strategy || "absolute",
      modifiers: i.modifiers || dd
    },
        s = u({
      styles: {
        popper: {
          position: a.strategy || "absolute",
          left: "0",
          top: "0"
        }
      },
      attributes: {}
    }),
        c = s[0],
        l = s[1],
        f = r(function () {
      return {
        name: "updateState",
        enabled: !0,
        phase: "write",
        fn: function fn(t) {
          var e = t.state,
              r = Object.keys(e.elements);
          l({
            styles: ol(r.map(function (t) {
              return [t, e.styles[t] || {}];
            })),
            attributes: ol(r.map(function (t) {
              return [t, e.attributes[t]];
            }))
          });
        },
        requires: ["computeStyles"]
      };
    }, [l]),
        d = r(function () {
      var t = {
        onFirstUpdate: a.onFirstUpdate,
        placement: a.placement || "bottom",
        strategy: a.strategy || "absolute",
        modifiers: [].concat(a.modifiers, [f, {
          name: "applyStyles",
          enabled: !1
        }])
      };
      return fd(o.current, t) ? o.current || t : (o.current = t, t);
    }, [a.onFirstUpdate, a.placement, a.strategy, a.modifiers, f]),
        p = e(),
        h = r(function () {
      return i.createPopper || xf;
    }, [i.createPopper]);
    return al(function () {
      var e = null;
      return null != t && null != n && (e = h(t, n, d), p.current = e), function () {
        null != e && e.destroy(), p.current = null;
      };
    }, [t, n, h]), al(function () {
      p.current && p.current.setOptions(d);
    }, [d]), {
      state: p.current ? p.current.state : null,
      styles: c.styles,
      attributes: c.attributes,
      update: p.current ? p.current.update : null,
      forceUpdate: p.current ? p.current.forceUpdate : null
    };
  }(S, A, {
    placement: b,
    modifiers: x
  }),
      _ = T.styles,
      P = T.attributes;

  return t.createElement(t.Fragment, null, t.createElement("line", {
    ref: E,
    x1: i,
    y1: o,
    x2: a,
    y2: s,
    style: Re({
      stroke: "white",
      pointerEvents: "none"
    }, p)
  }), f.createPortal(t.createElement("div", Pe({
    ref: j,
    style: Re({
      pointerEvents: "none"
    }, _.popper, {}, v),
    key: i
  }, P.popper), l), g));
};

pd.displayName = "Hint";
var hd = t.memo(pd);

var vd = function vd(t, e) {
  if (null == t) return {};
  var r,
      n,
      i = {},
      o = Object.keys(t);

  for (n = 0; n < o.length; n++) {
    r = o[n], e.indexOf(r) >= 0 || (i[r] = t[r]);
  }

  return i;
};

var yd = function yd(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
};

var gd = function gd(t) {
  if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
},
    md = h(function (t) {
  function e() {
    return t.exports = e = Object.assign || function (t) {
      for (var e = 1; e < arguments.length; e++) {
        var r = arguments[e];

        for (var n in r) {
          Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
        }
      }

      return t;
    }, e.apply(this, arguments);
  }

  t.exports = e;
}),
    bd = h(function (e, r) {
  function n(t) {
    return t && "object" === ke(t) && "default" in t ? t["default"] : t;
  }

  Object.defineProperty(r, "__esModule", {
    value: !0
  });

  var i = n(vd),
      o = n(yd),
      a = n(gd),
      u = n(md),
      s = n(t),
      c = n(f),
      l = void 0,
      d = void 0,
      p = [],
      h = function h(t) {
    return "undefined" != typeof window && window.requestAnimationFrame(t);
  },
      v = function v(t) {
    return "undefined" != typeof window && window.cancelAnimationFrame(t);
  },
      y = void 0,
      g = function g() {
    return Date.now();
  },
      m = void 0,
      b = void 0,
      w = function w(t, e) {
    return d = {
      fn: t,
      transform: e
    };
  },
      x = function x(t) {
    return p = t;
  },
      O = function O(t) {
    return l = t;
  },
      S = function S(t) {
    return y = t;
  },
      E = function E(t) {
    return m = t;
  },
      k = function k(t) {
    return b = t;
  },
      A = Object.freeze({
    get bugfixes() {
      return l;
    },

    get applyAnimatedValues() {
      return d;
    },

    get colorNames() {
      return p;
    },

    get requestFrame() {
      return h;
    },

    get cancelFrame() {
      return v;
    },

    get interpolation() {
      return y;
    },

    get now() {
      return g;
    },

    get defaultElement() {
      return m;
    },

    get createAnimatedStyle() {
      return b;
    },

    injectApplyAnimatedValues: w,
    injectColorNames: x,
    injectBugfixes: O,
    injectInterpolation: S,
    injectFrame: function injectFrame(t, e) {
      var r;
      return h = (r = [t, e])[0], v = r[1], r;
    },
    injectNow: function injectNow(t) {
      return g = t;
    },
    injectDefaultElement: E,
    injectCreateAnimatedStyle: k
  }),
      j = function () {
    function t() {}

    var e = t.prototype;
    return e.attach = function () {}, e.detach = function () {}, e.getValue = function () {}, e.getAnimatedValue = function () {
      return this.getValue();
    }, e.addChild = function (t) {}, e.removeChild = function (t) {}, e.getChildren = function () {
      return [];
    }, t;
  }(),
      T = function T(t) {
    return Object.keys(t).map(function (e) {
      return t[e];
    });
  },
      _ = function (t) {
    function e() {
      for (var e, r = arguments.length, n = new Array(r), i = 0; i < r; i++) {
        n[i] = arguments[i];
      }

      return (e = t.call.apply(t, [this].concat(n)) || this).children = [], e.getChildren = function () {
        return e.children;
      }, e.getPayload = function (t) {
        return void 0 === t && (t = void 0), void 0 !== t && e.payload ? e.payload[t] : e.payload || a(e);
      }, e;
    }

    o(e, t);
    var r = e.prototype;
    return r.addChild = function (t) {
      0 === this.children.length && this.attach(), this.children.push(t);
    }, r.removeChild = function (t) {
      var e = this.children.indexOf(t);
      this.children.splice(e, 1), 0 === this.children.length && this.detach();
    }, e;
  }(j),
      P = function (t) {
    function e() {
      for (var e, r = arguments.length, n = new Array(r), i = 0; i < r; i++) {
        n[i] = arguments[i];
      }

      return (e = t.call.apply(t, [this].concat(n)) || this).payload = [], e.getAnimatedValue = function () {
        return e.getValue();
      }, e.attach = function () {
        return e.payload.forEach(function (t) {
          return t instanceof j && t.addChild(a(e));
        });
      }, e.detach = function () {
        return e.payload.forEach(function (t) {
          return t instanceof j && t.removeChild(a(e));
        });
      }, e;
    }

    return o(e, t), e;
  }(_),
      M = function (t) {
    function e() {
      for (var e, r = arguments.length, n = new Array(r), i = 0; i < r; i++) {
        n[i] = arguments[i];
      }

      return (e = t.call.apply(t, [this].concat(n)) || this).payload = {}, e.getAnimatedValue = function () {
        return e.getValue(!0);
      }, e.attach = function () {
        return T(e.payload).forEach(function (t) {
          return t instanceof j && t.addChild(a(e));
        });
      }, e.detach = function () {
        return T(e.payload).forEach(function (t) {
          return t instanceof j && t.removeChild(a(e));
        });
      }, e;
    }

    return o(e, t), e.prototype.getValue = function (t) {
      void 0 === t && (t = !1);
      var e = {};

      for (var r in this.payload) {
        var n = this.payload[r];
        (!t || n instanceof j) && (e[r] = n instanceof j ? n[t ? "getAnimatedValue" : "getValue"]() : n);
      }

      return e;
    }, e;
  }(_),
      R = function (t) {
    function e(e) {
      var r;
      return r = t.call(this) || this, !(e = e || {}).transform || e.transform instanceof j || (e = d.transform(e)), r.payload = e, r;
    }

    return o(e, t), e;
  }(M),
      I = {
    transparent: 0,
    aliceblue: 4042850303,
    antiquewhite: 4209760255,
    aqua: 16777215,
    aquamarine: 2147472639,
    azure: 4043309055,
    beige: 4126530815,
    bisque: 4293182719,
    black: 255,
    blanchedalmond: 4293643775,
    blue: 65535,
    blueviolet: 2318131967,
    brown: 2771004159,
    burlywood: 3736635391,
    burntsienna: 3934150143,
    cadetblue: 1604231423,
    chartreuse: 2147418367,
    chocolate: 3530104575,
    coral: 4286533887,
    cornflowerblue: 1687547391,
    cornsilk: 4294499583,
    crimson: 3692313855,
    cyan: 16777215,
    darkblue: 35839,
    darkcyan: 9145343,
    darkgoldenrod: 3095792639,
    darkgray: 2846468607,
    darkgreen: 6553855,
    darkgrey: 2846468607,
    darkkhaki: 3182914559,
    darkmagenta: 2332068863,
    darkolivegreen: 1433087999,
    darkorange: 4287365375,
    darkorchid: 2570243327,
    darkred: 2332033279,
    darksalmon: 3918953215,
    darkseagreen: 2411499519,
    darkslateblue: 1211993087,
    darkslategray: 793726975,
    darkslategrey: 793726975,
    darkturquoise: 13554175,
    darkviolet: 2483082239,
    deeppink: 4279538687,
    deepskyblue: 12582911,
    dimgray: 1768516095,
    dimgrey: 1768516095,
    dodgerblue: 512819199,
    firebrick: 2988581631,
    floralwhite: 4294635775,
    forestgreen: 579543807,
    fuchsia: 4278255615,
    gainsboro: 3705462015,
    ghostwhite: 4177068031,
    gold: 4292280575,
    goldenrod: 3668254975,
    gray: 2155905279,
    green: 8388863,
    greenyellow: 2919182335,
    grey: 2155905279,
    honeydew: 4043305215,
    hotpink: 4285117695,
    indianred: 3445382399,
    indigo: 1258324735,
    ivory: 4294963455,
    khaki: 4041641215,
    lavender: 3873897215,
    lavenderblush: 4293981695,
    lawngreen: 2096890111,
    lemonchiffon: 4294626815,
    lightblue: 2916673279,
    lightcoral: 4034953471,
    lightcyan: 3774873599,
    lightgoldenrodyellow: 4210742015,
    lightgray: 3553874943,
    lightgreen: 2431553791,
    lightgrey: 3553874943,
    lightpink: 4290167295,
    lightsalmon: 4288707327,
    lightseagreen: 548580095,
    lightskyblue: 2278488831,
    lightslategray: 2005441023,
    lightslategrey: 2005441023,
    lightsteelblue: 2965692159,
    lightyellow: 4294959359,
    lime: 16711935,
    limegreen: 852308735,
    linen: 4210091775,
    magenta: 4278255615,
    maroon: 2147483903,
    mediumaquamarine: 1724754687,
    mediumblue: 52735,
    mediumorchid: 3126187007,
    mediumpurple: 2473647103,
    mediumseagreen: 1018393087,
    mediumslateblue: 2070474495,
    mediumspringgreen: 16423679,
    mediumturquoise: 1221709055,
    mediumvioletred: 3340076543,
    midnightblue: 421097727,
    mintcream: 4127193855,
    mistyrose: 4293190143,
    moccasin: 4293178879,
    navajowhite: 4292783615,
    navy: 33023,
    oldlace: 4260751103,
    olive: 2155872511,
    olivedrab: 1804477439,
    orange: 4289003775,
    orangered: 4282712319,
    orchid: 3664828159,
    palegoldenrod: 4008225535,
    palegreen: 2566625535,
    paleturquoise: 2951671551,
    palevioletred: 3681588223,
    papayawhip: 4293907967,
    peachpuff: 4292524543,
    peru: 3448061951,
    pink: 4290825215,
    plum: 3718307327,
    powderblue: 2967529215,
    purple: 2147516671,
    rebeccapurple: 1714657791,
    red: 4278190335,
    rosybrown: 3163525119,
    royalblue: 1097458175,
    saddlebrown: 2336560127,
    salmon: 4202722047,
    sandybrown: 4104413439,
    seagreen: 780883967,
    seashell: 4294307583,
    sienna: 2689740287,
    silver: 3233857791,
    skyblue: 2278484991,
    slateblue: 1784335871,
    slategray: 1887473919,
    slategrey: 1887473919,
    snow: 4294638335,
    springgreen: 16744447,
    steelblue: 1182971135,
    tan: 3535047935,
    teal: 8421631,
    thistle: 3636451583,
    tomato: 4284696575,
    turquoise: 1088475391,
    violet: 4001558271,
    wheat: 4125012991,
    white: 4294967295,
    whitesmoke: 4126537215,
    yellow: 4294902015,
    yellowgreen: 2597139199
  },
      C = function () {
    function t() {}

    return t.create = function (e, r, n) {
      if ("function" == typeof e) return e;
      if (y && e.output && "string" == typeof e.output[0]) return y(e);
      if (Array.isArray(e)) return t.create({
        range: e,
        output: r,
        extrapolate: n || "extend"
      });

      var i = e.output,
          o = e.range || [0, 1],
          a = e.easing || function (t) {
        return t;
      },
          u = "extend",
          s = e.map;

      void 0 !== e.extrapolateLeft ? u = e.extrapolateLeft : void 0 !== e.extrapolate && (u = e.extrapolate);
      var c = "extend";
      return void 0 !== e.extrapolateRight ? c = e.extrapolateRight : void 0 !== e.extrapolate && (c = e.extrapolate), function (t) {
        var e = function (t, e) {
          for (var r = 1; r < e.length - 1 && !(e[r] >= t); ++r) {
            ;
          }

          return r - 1;
        }(t, o);

        return function (t, e, r, n, i, o, a, u, s) {
          var c = s ? s(t) : t;

          if (c < e) {
            if ("identity" === a) return c;
            "clamp" === a && (c = e);
          }

          if (c > r) {
            if ("identity" === u) return c;
            "clamp" === u && (c = r);
          }

          if (n === i) return n;
          if (e === r) return t <= e ? n : i;
          e === -1 / 0 ? c = -c : r === 1 / 0 ? c -= e : c = (c - e) / (r - e);
          c = o(c), n === -1 / 0 ? c = -c : i === 1 / 0 ? c += n : c = c * (i - n) + n;
          return c;
        }(t, o[e], o[e + 1], i[e], i[e + 1], a, u, c, s);
      };
    }, t;
  }();

  var V = "[-+]?\\d*\\.?\\d+",
      N = V + "%";

  function F() {
    return "\\(\\s*(" + Array.prototype.slice.call(arguments).join(")\\s*,\\s*(") + ")\\s*\\)";
  }

  var L = new RegExp("rgb" + F(V, V, V)),
      D = new RegExp("rgba" + F(V, V, V, V)),
      z = new RegExp("hsl" + F(V, N, N)),
      q = new RegExp("hsla" + F(V, N, N, V)),
      B = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
      U = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
      W = /^#([0-9a-fA-F]{6})$/,
      $ = /^#([0-9a-fA-F]{8})$/;

  function H(t, e, r) {
    return r < 0 && (r += 1), r > 1 && (r -= 1), r < 1 / 6 ? t + 6 * (e - t) * r : r < .5 ? e : r < 2 / 3 ? t + (e - t) * (2 / 3 - r) * 6 : t;
  }

  function G(t, e, r) {
    var n = r < .5 ? r * (1 + e) : r + e - r * e,
        i = 2 * r - n,
        o = H(i, n, t + 1 / 3),
        a = H(i, n, t),
        u = H(i, n, t - 1 / 3);
    return Math.round(255 * o) << 24 | Math.round(255 * a) << 16 | Math.round(255 * u) << 8;
  }

  function Y(t) {
    var e = parseInt(t, 10);
    return e < 0 ? 0 : e > 255 ? 255 : e;
  }

  function K(t) {
    return (parseFloat(t) % 360 + 360) % 360 / 360;
  }

  function X(t) {
    var e = parseFloat(t);
    return e < 0 ? 0 : e > 1 ? 255 : Math.round(255 * e);
  }

  function Q(t) {
    var e = parseFloat(t);
    return e < 0 ? 0 : e > 100 ? 1 : e / 100;
  }

  function J(t) {
    var e = function (t) {
      var e;
      return "number" == typeof t ? t >>> 0 === t && t >= 0 && t <= 4294967295 ? t : null : (e = W.exec(t)) ? parseInt(e[1] + "ff", 16) >>> 0 : I.hasOwnProperty(t) ? I[t] : (e = L.exec(t)) ? (Y(e[1]) << 24 | Y(e[2]) << 16 | Y(e[3]) << 8 | 255) >>> 0 : (e = D.exec(t)) ? (Y(e[1]) << 24 | Y(e[2]) << 16 | Y(e[3]) << 8 | X(e[4])) >>> 0 : (e = B.exec(t)) ? parseInt(e[1] + e[1] + e[2] + e[2] + e[3] + e[3] + "ff", 16) >>> 0 : (e = $.exec(t)) ? parseInt(e[1], 16) >>> 0 : (e = U.exec(t)) ? parseInt(e[1] + e[1] + e[2] + e[2] + e[3] + e[3] + e[4] + e[4], 16) >>> 0 : (e = z.exec(t)) ? (255 | G(K(e[1]), Q(e[2]), Q(e[3]))) >>> 0 : (e = q.exec(t)) ? (G(K(e[1]), Q(e[2]), Q(e[3])) | X(e[4])) >>> 0 : null;
    }(t);

    return null === e ? t : "rgba(" + ((4278190080 & (e = e || 0)) >>> 24) + ", " + ((16711680 & e) >>> 16) + ", " + ((65280 & e) >>> 8) + ", " + (255 & e) / 255 + ")";
  }

  var Z = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,
      tt = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi,
      et = new RegExp("(" + Object.keys(I).join("|") + ")", "g");

  var rt = function (t) {
    function e(r, n, i) {
      var o;
      return (o = t.call(this) || this).getValue = function () {
        var t;
        return (t = o).calc.apply(t, o.payload.map(function (t) {
          return t.getValue();
        }));
      }, o.updateConfig = function (t, e) {
        return o.calc = C.create(t, e);
      }, o.interpolate = function (t, r) {
        return new e(a(o), t, r);
      }, o.payload = r instanceof P && !r.updateConfig ? r.payload : Array.isArray(r) ? r : [r], o.calc = C.create(n, i), o;
    }

    return o(e, t), e;
  }(P);

  var nt = function (t) {
    function e(e) {
      var r;
      return (r = t.call(this) || this).setValue = function (t, e) {
        void 0 === e && (e = !0), r.value = t, e && r.flush();
      }, r.getValue = function () {
        return r.value;
      }, r.updateStyles = function () {
        return function t(e, r) {
          "function" == typeof e.update ? r.add(e) : e.getChildren().forEach(function (e) {
            return t(e, r);
          });
        }(a(r), r.animatedStyles);
      }, r.updateValue = function (t) {
        return r.flush(r.value = t);
      }, r.interpolate = function (t, e) {
        return new rt(a(r), t, e);
      }, r.value = e, r.animatedStyles = new Set(), r.done = !1, r.startPosition = e, r.lastPosition = e, r.lastVelocity = void 0, r.lastTime = void 0, r.controller = void 0, r;
    }

    o(e, t);
    var r = e.prototype;
    return r.flush = function () {
      0 === this.animatedStyles.size && this.updateStyles(), this.animatedStyles.forEach(function (t) {
        return t.update();
      });
    }, r.prepare = function (t) {
      void 0 === this.controller && (this.controller = t), this.controller === t && (this.startPosition = this.value, this.lastPosition = this.value, this.lastVelocity = t.isActive ? this.lastVelocity : void 0, this.lastTime = t.isActive ? this.lastTime : void 0, this.done = !1, this.animatedStyles.clear());
    }, e;
  }(_),
      it = function (t) {
    function e(e) {
      var r;
      return (r = t.call(this) || this).setValue = function (t, e) {
        void 0 === e && (e = !0), Array.isArray(t) ? t.length === r.payload.length && t.forEach(function (t, n) {
          return r.payload[n].setValue(t, e);
        }) : r.payload.forEach(function (n, i) {
          return r.payload[i].setValue(t, e);
        });
      }, r.getValue = function () {
        return r.payload.map(function (t) {
          return t.getValue();
        });
      }, r.interpolate = function (t, e) {
        return new rt(a(r), t, e);
      }, r.payload = e.map(function (t) {
        return new nt(t);
      }), r;
    }

    return o(e, t), e;
  }(P);

  function ot(t, e) {
    return null == t ? e : t;
  }

  function at(t) {
    return void 0 !== t ? Array.isArray(t) ? t : [t] : [];
  }

  function ut(t, e) {
    if (ke(t) !== ke(e)) return !1;
    if ("string" == typeof t || "number" == typeof t) return t === e;
    var r;

    for (r in t) {
      if (!(r in e)) return !1;
    }

    for (r in e) {
      if (t[r] !== e[r]) return !1;
    }

    return void 0 !== r || t === e;
  }

  function st(t) {
    for (var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++) {
      r[n - 1] = arguments[n];
    }

    return "function" == typeof t ? t.apply(void 0, r) : t;
  }

  function ct(t) {
    return Object.keys(t).map(function (e) {
      return t[e];
    });
  }

  function lt(t) {
    var e = function (t) {
      return t.to, t.from, t.config, t["native"], t.onStart, t.onRest, t.onFrame, t.children, t.reset, t.reverse, t.force, t.immediate, t.impl, t.inject, t.delay, t.attach, t.destroyed, t.interpolateTo, t.autoStart, t.ref, i(t, ["to", "from", "config", "native", "onStart", "onRest", "onFrame", "children", "reset", "reverse", "force", "immediate", "impl", "inject", "delay", "attach", "destroyed", "interpolateTo", "autoStart", "ref"]);
    }(t),
        r = Object.keys(t).reduce(function (r, n) {
      var i;
      return void 0 !== e[n] ? r : u({}, r, ((i = {})[n] = t[n], i));
    }, {});

    return u({
      to: e
    }, r);
  }

  function ft(t, e) {
    var r,
        n = e[0],
        i = e[1];
    return u({}, t, ((r = {})[n] = new (Array.isArray(i) ? it : nt)(i), r));
  }

  function dt(t) {
    var e = t.from,
        r = t.to,
        n = t["native"],
        i = Object.entries(u({}, e, r));
    return n ? i.reduce(ft, {}) : u({}, e, r);
  }

  function pt(t, e) {
    return e && ("function" == typeof e ? e(t) : "object" === ke(e) && (e.current = t)), t;
  }

  var ht = function ht(t) {
    return "auto" === t;
  };

  var vt = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  },
      yt = ["Webkit", "Ms", "Moz", "O"];

  function gt(t, e, r) {
    return null == e || "boolean" == typeof e || "" === e ? "" : r || "number" != typeof e || 0 === e || vt.hasOwnProperty(t) && vt[t] ? ("" + e).trim() : e + "px";
  }

  vt = Object.keys(vt).reduce(function (t, e) {
    return yt.forEach(function (r) {
      return t[function (t, e) {
        return t + e.charAt(0).toUpperCase() + e.substring(1);
      }(r, e)] = t[e];
    }), t;
  }, vt);
  var mt = {};
  k(function (t) {
    return new R(t);
  }), E("div"), S(function (t) {
    var e = t.output.map(function (t) {
      return t.replace(tt, J);
    }).map(function (t) {
      return t.replace(et, J);
    }),
        r = e[0].match(Z).map(function () {
      return [];
    });
    e.forEach(function (t) {
      t.match(Z).forEach(function (t, e) {
        return r[e].push(+t);
      });
    });
    var n = e[0].match(Z).map(function (e, n) {
      return C.create(u({}, t, {
        output: r[n]
      }));
    });
    return function (t) {
      var r = 0;
      return e[0].replace(Z, function () {
        return n[r++](t);
      }).replace(/rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi, function (t, e, r, n, i) {
        return "rgba(" + Math.round(e) + ", " + Math.round(r) + ", " + Math.round(n) + ", " + i + ")";
      });
    };
  }), x(I), O(function (t, e) {
    var r = t.from,
        n = t.to,
        i = t.children;

    if (ct(n).some(ht) || ct(r).some(ht)) {
      var o = i(dt(t));

      if (o) {
        Array.isArray(o) && (o = {
          type: "div",
          props: {
            children: o
          }
        });
        var a = o.props.style;
        return s.createElement(o.type, u({
          key: o.key ? o.key : void 0
        }, o.props, {
          style: u({}, a, {
            position: "absolute",
            visibility: "hidden"
          }),
          ref: function ref(i) {
            if (i) {
              var o,
                  a,
                  s = c.findDOMNode(i),
                  l = getComputedStyle(s);
              if ("border-box" === l.boxSizing) o = s.offsetWidth, a = s.offsetHeight;else {
                var f = parseFloat(l.paddingLeft || 0) + parseFloat(l.paddingRight || 0),
                    d = parseFloat(l.paddingTop || 0) + parseFloat(l.paddingBottom || 0),
                    p = parseFloat(l.borderLeftWidth || 0) + parseFloat(l.borderRightWidth || 0),
                    h = parseFloat(l.borderTopWidth || 0) + parseFloat(l.borderBottomWidth || 0);
                o = s.offsetWidth - f - p, a = s.offsetHeight - d - h;
              }

              var v = function (t, e) {
                return function (r, n) {
                  var i,
                      o = n[0],
                      a = n[1];
                  return u({}, r, ((i = {})[o] = "auto" === a ? ~o.indexOf("height") ? e : t : a, i));
                };
              }(o, a);

              e(u({}, t, {
                from: Object.entries(r).reduce(v, r),
                to: Object.entries(n).reduce(v, n)
              }));
            }
          }
        }));
      }
    }
  }), w(function (t, e) {
    if (!t.nodeType || void 0 === t.setAttribute) return !1;
    var r = e.style,
        n = e.children,
        o = e.scrollTop,
        a = e.scrollLeft,
        u = i(e, ["style", "children", "scrollTop", "scrollLeft"]);

    for (var s in void 0 !== o && (t.scrollTop = o), void 0 !== a && (t.scrollLeft = a), void 0 !== n && (t.textContent = n), r) {
      if (r.hasOwnProperty(s)) {
        var c = 0 === s.indexOf("--"),
            l = gt(s, r[s], c);
        "float" === s && (s = "cssFloat"), c ? t.style.setProperty(s, l) : t.style[s] = l;
      }
    }

    for (var f in u) {
      var d = mt[f] || (mt[f] = f.replace(/([A-Z])/g, function (t) {
        return "-" + t.toLowerCase();
      }));
      void 0 !== t.getAttribute(d) && t.setAttribute(d, u[f]);
    }
  }, function (t) {
    return t;
  });

  var bt = !1,
      wt = new Set(),
      xt = function t() {
    var e = g(),
        r = wt,
        n = Array.isArray(r),
        i = 0;

    for (r = n ? r : r[Symbol.iterator]();;) {
      var o;

      if (n) {
        if (i >= r.length) break;
        o = r[i++];
      } else {
        if ((i = r.next()).done) break;
        o = i.value;
      }

      for (var a = o, u = !0, s = !0, c = 0; c < a.configs.length; c++) {
        for (var l = a.configs[c], f = void 0, d = void 0, p = 0; p < l.animatedValues.length; p++) {
          var v = l.animatedValues[p];

          if (!v.done) {
            var y = l.fromValues[p],
                m = l.toValues[p],
                b = v.lastPosition,
                w = m instanceof j,
                x = Array.isArray(l.initialVelocity) ? l.initialVelocity[p] : l.initialVelocity;
            if (w && (m = m.getValue()), l.immediate || !w && !l.decay && y === m) v.updateValue(m), v.done = !0;else if (l.delay && e - a.startTime < l.delay) u = !1;else if (s = !1, "string" != typeof y && "string" != typeof m) {
              if (void 0 !== l.duration) b = y + l.easing((e - a.startTime - l.delay) / l.duration) * (m - y), f = e >= a.startTime + l.delay + l.duration;else if (l.decay) b = y + x / (1 - .998) * (1 - Math.exp(-(1 - .998) * (e - a.startTime))), (f = Math.abs(v.lastPosition - b) < .1) && (m = b);else {
                d = void 0 !== v.lastTime ? v.lastTime : e, x = void 0 !== v.lastVelocity ? v.lastVelocity : l.initialVelocity, e > d + 64 && (d = e);

                for (var O = Math.floor(e - d), S = 0; S < O; ++S) {
                  b += 1 * (x += 1 * ((-l.tension * (b - m) + -l.friction * x) / l.mass) / 1e3) / 1e3;
                }

                var E = !(!l.clamp || 0 === l.tension) && (y < m ? b > m : b < m),
                    k = Math.abs(x) <= l.precision,
                    A = 0 === l.tension || Math.abs(m - b) <= l.precision;
                f = E || k && A, v.lastVelocity = x, v.lastTime = e;
              }
              w && !l.toValues[p].done && (f = !1), f ? (v.value !== m && (b = m), v.done = !0) : u = !1, v.updateValue(b), v.lastPosition = b;
            } else v.updateValue(m), v.done = !0;
          }
        }

        !a.props.onFrame && a.props["native"] || (a.animatedProps[l.name] = l.interpolation.getValue());
      }

      !a.props.onFrame && a.props["native"] || (!a.props["native"] && a.onUpdate && a.onUpdate(), a.props.onFrame && a.props.onFrame(a.animatedProps)), u && (wt["delete"](a), a.debouncedOnEnd({
        finished: !0,
        noChange: s
      }));
    }

    wt.size ? h(t) : bt = !1;
  },
      Ot = function Ot(t) {
    wt.has(t) && wt["delete"](t);
  },
      St = function () {
    function t(t, e) {
      var r = this;
      void 0 === e && (e = {
        "native": !0,
        interpolateTo: !0,
        autoStart: !0
      }), this.getValues = function () {
        return r.props["native"] ? r.interpolations : r.animatedProps;
      }, this.dependents = new Set(), this.isActive = !1, this.hasChanged = !1, this.props = {}, this.merged = {}, this.animations = {}, this.interpolations = {}, this.animatedProps = {}, this.configs = [], this.frame = void 0, this.startTime = void 0, this.lastTime = void 0, this.update(u({}, t, e));
    }

    var e = t.prototype;
    return e.update = function (t) {
      var e = this;
      this.props = u({}, this.props, t);
      var r = this.props.interpolateTo ? lt(this.props) : this.props,
          n = r.from,
          i = void 0 === n ? {} : n,
          o = r.to,
          a = void 0 === o ? {} : o,
          s = r.config,
          c = void 0 === s ? {} : s,
          l = r.delay,
          f = void 0 === l ? 0 : l,
          d = r.reverse,
          h = r.attach,
          v = r.reset,
          y = r.immediate,
          g = r.autoStart,
          m = r.ref;

      if (d) {
        var b = [a, i];
        i = b[0], a = b[1];
      }

      this.hasChanged = !1;
      var w = h && h(this),
          x = v ? {} : this.merged;
      if (this.merged = u({}, i, x, a), this.animations = Object.entries(this.merged).reduce(function (t, r, n) {
        var o,
            a,
            s,
            l = r[0],
            d = r[1],
            h = !v && t[l] || {},
            g = "number" == typeof d,
            m = "string" == typeof d && !d.startsWith("#") && !/\d/.test(d) && !p[d],
            b = !g && !m && Array.isArray(d),
            x = void 0 !== i[l] ? i[l] : d,
            O = g || b ? d : m ? d : 1,
            S = st(c, l);
        if (w && (O = w.animations[l].parent), void 0 === S.decay && ut(h.changes, d)) return t;
        if (e.hasChanged = !0, g || m) a = s = h.parent || new nt(x);else if (b) a = s = h.parent || new it(x);else {
          var E = h.interpolation && h.interpolation.calc(h.parent.value);
          h.parent ? (a = h.parent).setValue(0, !1) : a = new nt(0);
          var k = {
            output: [void 0 !== E ? E : x, d]
          };
          h.interpolation ? (s = h.interpolation, h.interpolation.updateConfig(k)) : s = a.interpolate(k);
        }
        st(y, l) && a.setValue(d, !1);
        var A = at(a.getPayload());
        return A.forEach(function (t) {
          return t.prepare(e);
        }), u({}, t, ((o = {})[l] = u({}, h, {
          name: l,
          parent: a,
          interpolation: s,
          animatedValues: A,
          changes: d,
          fromValues: at(a.getValue()),
          toValues: at(w ? O.getPayload() : O),
          immediate: st(y, l),
          delay: ot(S.delay, f || 0),
          initialVelocity: ot(S.velocity, 0),
          clamp: ot(S.clamp, !1),
          precision: ot(S.precision, .01),
          tension: ot(S.tension, 170),
          friction: ot(S.friction, 26),
          mass: ot(S.mass, 1),
          duration: S.duration,
          easing: ot(S.easing, function (t) {
            return t;
          }),
          decay: S.decay
        }), o));
      }, this.animations), this.hasChanged) for (var O in this.configs = ct(this.animations), this.animatedProps = {}, this.interpolations = {}, this.animations) {
        this.interpolations[O] = this.animations[O].interpolation, this.animatedProps[O] = this.animations[O].interpolation.getValue();
      }

      for (var S = arguments.length, E = new Array(S > 1 ? S - 1 : 0), k = 1; k < S; k++) {
        E[k - 1] = arguments[k];
      }

      m || !g && !E.length || this.start.apply(this, E);
      var A = E[0],
          j = E[1];
      return this.onEnd = "function" == typeof A && A, this.onUpdate = j, this.getValues();
    }, e.start = function (t, e) {
      var r,
          n = this;
      return this.startTime = g(), this.isActive && this.stop(), this.isActive = !0, this.onEnd = "function" == typeof t && t, this.onUpdate = e, this.props.onStart && this.props.onStart(), r = this, wt.has(r) || (wt.add(r), bt || h(xt), bt = !0), new Promise(function (t) {
        return n.resolve = t;
      });
    }, e.stop = function (t) {
      void 0 === t && (t = !1), t && ct(this.animations).forEach(function (t) {
        return t.changes = void 0;
      }), this.debouncedOnEnd({
        finished: t
      });
    }, e.destroy = function () {
      Ot(this), this.props = {}, this.merged = {}, this.animations = {}, this.interpolations = {}, this.animatedProps = {}, this.configs = [];
    }, e.debouncedOnEnd = function (t) {
      Ot(this), this.isActive = !1;
      var e = this.onEnd;
      this.onEnd = null, e && e(t), this.resolve && this.resolve(), this.resolve = null;
    }, t;
  }(),
      Et = function (t) {
    function e(e, r) {
      var n;
      return n = t.call(this) || this, e.style && (e = u({}, e, {
        style: b(e.style)
      })), n.payload = e, n.update = r, n.attach(), n;
    }

    return o(e, t), e;
  }(M);

  function kt(t) {
    var e = function (e) {
      function r(t) {
        var r;
        return (r = e.call(this) || this).callback = function () {
          r.node && !1 === d.fn(r.node, r.propsAnimated.getAnimatedValue(), a(r)) && r.forceUpdate();
        }, r.attachProps(t), r;
      }

      o(r, e);
      var n = r.prototype;
      return n.componentWillUnmount = function () {
        this.propsAnimated && this.propsAnimated.detach();
      }, n.setNativeProps = function (t) {
        !1 === d.fn(this.node, t, this) && this.forceUpdate();
      }, n.attachProps = function (t) {
        t.forwardRef;
        var e = i(t, ["forwardRef"]),
            r = this.propsAnimated;
        this.propsAnimated = new Et(e, this.callback), r && r.detach();
      }, n.shouldComponentUpdate = function (t) {
        var e = t.style,
            r = i(t, ["style"]),
            n = this.props,
            o = n.style;
        return (!ut(i(n, ["style"]), r) || !ut(o, e)) && (this.attachProps(t), !0);
      }, n.render = function () {
        var e = this,
            r = this.propsAnimated.getValue(),
            n = (r.scrollTop, r.scrollLeft, i(r, ["scrollTop", "scrollLeft"]));
        return s.createElement(t, u({}, n, {
          ref: function ref(t) {
            return e.node = pt(t, e.props.forwardRef);
          }
        }));
      }, r;
    }(s.Component);

    return s.forwardRef(function (t, r) {
      return s.createElement(e, u({}, t, {
        forwardRef: r
      }));
    });
  }

  var At = {
    "default": {
      tension: 170,
      friction: 26
    },
    gentle: {
      tension: 120,
      friction: 14
    },
    wobbly: {
      tension: 180,
      friction: 12
    },
    stiff: {
      tension: 210,
      friction: 20
    },
    slow: {
      tension: 280,
      friction: 60
    },
    molasses: {
      tension: 280,
      friction: 120
    }
  },
      jt = function (t) {
    function e() {
      for (var e, r = arguments.length, n = new Array(r), i = 0; i < r; i++) {
        n[i] = arguments[i];
      }

      return (e = t.call.apply(t, [this].concat(n)) || this).state = {
        lastProps: {
          from: {},
          to: {}
        },
        propsChanged: !1,
        internal: !1
      }, e.controller = new St(null, null), e.didUpdate = !1, e.didInject = !1, e.finished = !0, e.start = function () {
        e.finished = !1;
        var t = e.mounted;
        e.controller.start(function (r) {
          return e.finish(u({}, r, {
            wasMounted: t
          }));
        }, e.update);
      }, e.stop = function () {
        return e.controller.stop(!0);
      }, e.update = function () {
        return e.mounted && e.setState({
          internal: !0
        });
      }, e.finish = function (t) {
        var r = t.finished,
            n = t.noChange,
            i = t.wasMounted;
        e.finished = !0, e.mounted && r && (!e.props.onRest || !i && n || e.props.onRest(e.controller.merged), e.mounted && e.didInject && (e.afterInject = dt(e.props), e.setState({
          internal: !0
        })), e.mounted && (e.didInject || e.props.after) && e.setState({
          internal: !0
        }), e.didInject = !1);
      }, e;
    }

    o(e, t);
    var r = e.prototype;
    return r.componentDidMount = function () {
      this.componentDidUpdate(), this.mounted = !0;
    }, r.componentWillUnmount = function () {
      this.mounted = !1, this.stop();
    }, e.getDerivedStateFromProps = function (t, e) {
      var r = e.internal,
          n = e.lastProps,
          i = t.from,
          o = t.to,
          a = t.reset,
          u = t.force;
      return {
        propsChanged: !ut(o, n.to) || !ut(i, n.from) || a && !r || u && !r,
        lastProps: t,
        internal: !1
      };
    }, r.render = function () {
      var t = this,
          e = this.props.children,
          r = this.state.propsChanged;

      if (this.props.inject && r && !this.injectProps) {
        var n = this.props.inject(this.props, function (e) {
          t.injectProps = e, t.setState({
            internal: !0
          });
        });
        if (n) return n;
      }

      (this.injectProps || r) && (this.didInject = !1, this.injectProps ? (this.controller.update(this.injectProps), this.didInject = !0) : r && this.controller.update(this.props), this.didUpdate = !0, this.afterInject = void 0, this.injectProps = void 0);
      var i = u({}, this.controller.getValues(), this.afterInject);
      return this.finished && (i = u({}, i, this.props.after)), Object.keys(i).length ? e(i) : null;
    }, r.componentDidUpdate = function () {
      this.didUpdate && this.start(), this.didUpdate = !1;
    }, e;
  }(s.Component);

  jt.defaultProps = {
    from: {},
    to: {},
    config: At["default"],
    "native": !1,
    immediate: !1,
    reset: !1,
    force: !1,
    inject: l
  };

  var Tt = function (t) {
    function e() {
      for (var e, r = arguments.length, n = new Array(r), i = 0; i < r; i++) {
        n[i] = arguments[i];
      }

      return (e = t.call.apply(t, [this].concat(n)) || this).first = !0, e.instances = new Set(), e.hook = function (t, r, n, i) {
        return e.instances.add(t), (i ? r === n - 1 : 0 === r) ? void 0 : Array.from(e.instances)[i ? r + 1 : r - 1];
      }, e;
    }

    o(e, t);
    var r = e.prototype;
    return r.render = function () {
      var t = this,
          e = this.props,
          r = e.items,
          n = e.children,
          o = e.from,
          a = void 0 === o ? {} : o,
          c = e.initial,
          l = e.reverse,
          f = e.keys,
          d = e.delay,
          p = e.onRest,
          h = i(e, ["items", "children", "from", "initial", "reverse", "keys", "delay", "onRest"]),
          v = at(r);
      return at(v).map(function (e, r) {
        return s.createElement(jt, u({
          onRest: 0 === r ? p : null,
          key: "function" == typeof f ? f(e) : at(f)[r],
          from: t.first && void 0 !== c ? c || {} : a
        }, h, {
          delay: 0 === r && d || void 0,
          attach: function attach(e) {
            return t.hook(e, r, v.length, l);
          },
          children: function children(t) {
            var i = n(e, r);
            return i ? i(t) : null;
          }
        }));
      });
    }, r.componentDidUpdate = function (t) {
      this.first = !1, t.items !== this.props.items && this.instances.clear();
    }, e;
  }(s.PureComponent);

  Tt.defaultProps = {
    keys: function keys(t) {
      return t;
    }
  };

  var _t = function (t) {
    function e() {
      for (var e, r = arguments.length, n = new Array(r), i = 0; i < r; i++) {
        n[i] = arguments[i];
      }

      return (e = t.call.apply(t, [this].concat(n)) || this).guid = 0, e.state = {
        props: {},
        resolve: function resolve() {
          return null;
        },
        last: !0,
        index: 0
      }, e.next = function (t, r, n) {
        return void 0 === r && (r = !0), void 0 === n && (n = 0), e.running = !0, new Promise(function (i) {
          e.mounted && e.setState(function (e) {
            return {
              props: t,
              resolve: i,
              last: r,
              index: n
            };
          }, function () {
            return e.running = !1;
          });
        });
      }, e;
    }

    o(e, t);
    var r = e.prototype;
    return r.componentDidMount = function () {
      this.mounted = !0, this.componentDidUpdate({});
    }, r.componentWillUnmount = function () {
      this.mounted = !1;
    }, r.componentDidUpdate = function (t) {
      var e = this,
          r = this.props,
          n = r.states,
          i = r.filter,
          o = r.state;
      (t.state !== this.props.state || this.props.reset && !this.running || !ut(n[o], t.states[t.state])) && n && o && n[o] && function () {
        var t = ++e.guid,
            r = n[o];
        if (r) if (Array.isArray(r)) for (var a = Promise.resolve(), u = function u(n) {
          var o = n,
              u = r[o],
              s = o === r.length - 1;
          a = a.then(function () {
            return t === e.guid && e.next(i(u), s, o);
          });
        }, s = 0; s < r.length; s++) {
          u(s);
        } else if ("function" == typeof r) {
          var c = 0;
          r(function (r, n) {
            return void 0 === n && (n = !1), t === e.guid && e.next(i(r), n, c++);
          }, function () {
            return h(function () {
              return e.instance && e.instance.stop();
            });
          }, e.props);
        } else e.next(i(n[o]));
      }();
    }, r.render = function () {
      var t = this,
          e = this.state,
          r = e.props,
          n = e.resolve,
          o = e.last,
          a = e.index;
      if (!r || 0 === Object.keys(r).length) return null;
      var c = this.props,
          l = (c.state, c.filter, c.states, c.config),
          f = c.primitive,
          d = c.onRest,
          p = c.forwardRef,
          h = i(c, ["state", "filter", "states", "config", "primitive", "onRest", "forwardRef"]);
      return Array.isArray(l) && (l = l[a]), s.createElement(f, u({
        ref: function ref(e) {
          return t.instance = pt(e, p);
        },
        config: l
      }, h, r, {
        onRest: function onRest(t) {
          n(t), d && o && d(t);
        }
      }));
    }, e;
  }(s.PureComponent);

  _t.defaultProps = {
    state: "__default"
  };
  var Pt = s.forwardRef(function (t, e) {
    return s.createElement(_t, u({}, t, {
      forwardRef: e
    }));
  });
  Pt.create = function (t) {
    return function (e, r) {
      var n;
      return void 0 === r && (r = function r(t) {
        return t;
      }), ("function" == typeof e || Array.isArray(e)) && ((n = {}).__default = e, e = n), function (n) {
        return s.createElement(_t, u({
          primitive: t,
          states: e,
          filter: r
        }, n));
      };
    };
  }, Pt.Spring = function (t) {
    return Pt.create(jt)(t, lt);
  }, Pt.Trail = function (t) {
    return Pt.create(Tt)(t, lt);
  };

  var Mt = 0,
      Rt = function Rt(t) {
    var e = t.items,
        r = t.keys,
        n = i(t, ["items", "keys"]);
    return e = at(void 0 !== e ? e : null), r = "function" == typeof r ? e.map(r) : at(r), u({
      items: e,
      keys: r.map(function (t) {
        return String(t);
      })
    }, n);
  },
      It = function (t) {
    o(r, t);
    var e = r.prototype;

    function r(e) {
      var r;
      return (r = t.call(this, e) || this).destroyItem = function (t, e, n) {
        return function (i) {
          var o = r.props,
              a = o.onRest,
              u = o.onDestroyed;
          r.mounted && (u && u(t), r.setState(function (t) {
            return {
              deleted: t.deleted.filter(function (t) {
                return t.key !== e;
              })
            };
          }), a && a(t, n, i));
        };
      }, r.state = {
        first: !0,
        transitions: [],
        current: {},
        deleted: [],
        prevProps: e
      }, r;
    }

    return e.componentDidMount = function () {
      this.mounted = !0;
    }, e.componentWillUnmount = function () {
      this.mounted = !1;
    }, r.getDerivedStateFromProps = function (t, e) {
      var r = e.first,
          n = e.prevProps,
          o = i(e, ["first", "prevProps"]),
          a = Rt(t),
          s = a.items,
          c = a.keys,
          l = a.initial,
          f = a.from,
          d = a.enter,
          p = a.leave,
          h = a.update,
          v = a.trail,
          y = void 0 === v ? 0 : v,
          g = a.unique,
          m = a.config,
          b = Rt(n),
          w = b.keys,
          x = b.items,
          O = u({}, o.current),
          S = [].concat(o.deleted),
          E = Object.keys(O),
          k = new Set(E),
          A = new Set(c),
          j = c.filter(function (t) {
        return !k.has(t);
      }),
          T = o.transitions.filter(function (t) {
        return !t.destroyed && !A.has(t.originalKey);
      }).map(function (t) {
        return t.originalKey;
      }),
          _ = c.filter(function (t) {
        return k.has(t);
      }),
          P = 0;

      j.forEach(function (t) {
        g && S.find(function (e) {
          return e.originalKey === t;
        }) && (S = S.filter(function (e) {
          return e.originalKey !== t;
        }));
        var e = c.indexOf(t),
            n = s[e];
        O[t] = {
          state: "enter",
          originalKey: t,
          key: g ? String(t) : Mt++,
          item: n,
          trail: P += y,
          config: st(m, n, "enter"),
          from: st(r && void 0 !== l ? l || {} : f, n),
          to: st(d, n)
        };
      }), T.forEach(function (t) {
        var e = w.indexOf(t),
            r = x[e];
        S.push(u({}, O[t], {
          state: "leave",
          destroyed: !0,
          left: w[Math.max(0, e - 1)],
          right: w[Math.min(w.length, e + 1)],
          trail: P += y,
          config: st(m, r, "leave"),
          to: st(p, r)
        })), delete O[t];
      }), _.forEach(function (t) {
        var e = c.indexOf(t),
            r = s[e];
        O[t] = u({}, O[t], {
          item: r,
          state: "update",
          trail: P += y,
          config: st(m, r, "update"),
          to: st(h, r)
        });
      });
      var M = c.map(function (t) {
        return O[t];
      });
      return S.forEach(function (t) {
        var e,
            r = t.left,
            n = t.right,
            o = i(t, ["left", "right"]);
        -1 !== (e = M.findIndex(function (t) {
          return t.originalKey === r;
        })) && (e += 1), -1 === e && (e = M.findIndex(function (t) {
          return t.originalKey === n;
        })), -1 === e && (e = S.findIndex(function (t) {
          return t.originalKey === r;
        })), -1 === e && (e = S.findIndex(function (t) {
          return t.originalKey === n;
        })), e = Math.max(0, e), M = [].concat(M.slice(0, e), [o], M.slice(e));
      }), {
        first: r && 0 === j.length,
        transitions: M,
        current: O,
        deleted: S,
        prevProps: t
      };
    }, e.render = function () {
      var t = this,
          e = this.props,
          r = (e.initial, e.from, e.enter, e.leave, e.update, e.onDestroyed, e.keys, e.items, e.onFrame),
          n = e.onRest,
          o = e.onStart,
          a = (e.trail, e.config, e.children),
          c = (e.unique, e.reset),
          l = i(e, ["initial", "from", "enter", "leave", "update", "onDestroyed", "keys", "items", "onFrame", "onRest", "onStart", "trail", "config", "children", "unique", "reset"]);
      return this.state.transitions.map(function (e, i) {
        var f,
            d = e.state,
            p = e.key,
            h = e.item,
            v = e.from,
            y = e.to,
            g = e.trail,
            m = e.config,
            b = e.destroyed;
        return s.createElement(Pt, u({
          reset: c && "enter" === d,
          primitive: jt,
          state: d,
          filter: lt,
          states: (f = {}, f[d] = y, f),
          key: p,
          onRest: b ? t.destroyItem(h, p, d) : n && function (t) {
            return n(h, d, t);
          },
          onStart: o && function () {
            return o(h, d);
          },
          onFrame: r && function (t) {
            return r(h, d, t);
          },
          delay: g,
          config: m
        }, l, {
          from: v,
          children: function children(t) {
            var e = a(h, d, i);
            return e ? e(t) : null;
          }
        }));
      });
    }, r;
  }(s.PureComponent);

  It.defaultProps = {
    keys: function keys(t) {
      return t;
    },
    unique: !1,
    reset: !1
  };
  var Ct = ["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"].reduce(function (t, e) {
    return t[e] = kt(e), t;
  }, kt);
  r.Spring = jt, r.Keyframes = Pt, r.Transition = It, r.Trail = Tt, r.Controller = St, r.config = At, r.animated = Ct, r.interpolate = function (t, e, r) {
    return t && new rt(t, e, r);
  }, r.Globals = A;
});

p(bd);
var wd = bd.Spring,
    xd = (bd.Keyframes, bd.Transition, bd.Trail, bd.Controller, bd.config, bd.animated);
bd.interpolate, bd.Globals;

function Od(t, e, r) {
  t.prototype = e.prototype = r, r.constructor = t;
}

function Sd(t, e) {
  var r = Object.create(t.prototype);

  for (var n in e) {
    r[n] = e[n];
  }

  return r;
}

function Ed() {}

var kd = "\\s*([+-]?\\d+)\\s*",
    Ad = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    jd = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    Td = /^#([0-9a-f]{3,8})$/,
    _d = new RegExp("^rgb\\(" + [kd, kd, kd] + "\\)$"),
    Pd = new RegExp("^rgb\\(" + [jd, jd, jd] + "\\)$"),
    Md = new RegExp("^rgba\\(" + [kd, kd, kd, Ad] + "\\)$"),
    Rd = new RegExp("^rgba\\(" + [jd, jd, jd, Ad] + "\\)$"),
    Id = new RegExp("^hsl\\(" + [Ad, jd, jd] + "\\)$"),
    Cd = new RegExp("^hsla\\(" + [Ad, jd, jd, Ad] + "\\)$"),
    Vd = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};

function Nd() {
  return this.rgb().formatHex();
}

function Fd() {
  return this.rgb().formatRgb();
}

function Ld(t) {
  var e, r;
  return t = (t + "").trim().toLowerCase(), (e = Td.exec(t)) ? (r = e[1].length, e = parseInt(e[1], 16), 6 === r ? Dd(e) : 3 === r ? new Ud(e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | 240 & e, (15 & e) << 4 | 15 & e, 1) : 8 === r ? new Ud(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, (255 & e) / 255) : 4 === r ? new Ud(e >> 12 & 15 | e >> 8 & 240, e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | 240 & e, ((15 & e) << 4 | 15 & e) / 255) : null) : (e = _d.exec(t)) ? new Ud(e[1], e[2], e[3], 1) : (e = Pd.exec(t)) ? new Ud(255 * e[1] / 100, 255 * e[2] / 100, 255 * e[3] / 100, 1) : (e = Md.exec(t)) ? zd(e[1], e[2], e[3], e[4]) : (e = Rd.exec(t)) ? zd(255 * e[1] / 100, 255 * e[2] / 100, 255 * e[3] / 100, e[4]) : (e = Id.exec(t)) ? Gd(e[1], e[2] / 100, e[3] / 100, 1) : (e = Cd.exec(t)) ? Gd(e[1], e[2] / 100, e[3] / 100, e[4]) : Vd.hasOwnProperty(t) ? Dd(Vd[t]) : "transparent" === t ? new Ud(NaN, NaN, NaN, 0) : null;
}

function Dd(t) {
  return new Ud(t >> 16 & 255, t >> 8 & 255, 255 & t, 1);
}

function zd(t, e, r, n) {
  return n <= 0 && (t = e = r = NaN), new Ud(t, e, r, n);
}

function qd(t) {
  return t instanceof Ed || (t = Ld(t)), t ? new Ud((t = t.rgb()).r, t.g, t.b, t.opacity) : new Ud();
}

function Bd(t, e, r, n) {
  return 1 === arguments.length ? qd(t) : new Ud(t, e, r, null == n ? 1 : n);
}

function Ud(t, e, r, n) {
  this.r = +t, this.g = +e, this.b = +r, this.opacity = +n;
}

function Wd() {
  return "#" + Hd(this.r) + Hd(this.g) + Hd(this.b);
}

function $d() {
  var t = this.opacity;
  return (1 === (t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t))) ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (1 === t ? ")" : ", " + t + ")");
}

function Hd(t) {
  return ((t = Math.max(0, Math.min(255, Math.round(t) || 0))) < 16 ? "0" : "") + t.toString(16);
}

function Gd(t, e, r, n) {
  return n <= 0 ? t = e = r = NaN : r <= 0 || r >= 1 ? t = e = NaN : e <= 0 && (t = NaN), new Kd(t, e, r, n);
}

function Yd(t) {
  if (t instanceof Kd) return new Kd(t.h, t.s, t.l, t.opacity);
  if (t instanceof Ed || (t = Ld(t)), !t) return new Kd();
  if (t instanceof Kd) return t;
  var e = (t = t.rgb()).r / 255,
      r = t.g / 255,
      n = t.b / 255,
      i = Math.min(e, r, n),
      o = Math.max(e, r, n),
      a = NaN,
      u = o - i,
      s = (o + i) / 2;
  return u ? (a = e === o ? (r - n) / u + 6 * (r < n) : r === o ? (n - e) / u + 2 : (e - r) / u + 4, u /= s < .5 ? o + i : 2 - o - i, a *= 60) : u = s > 0 && s < 1 ? 0 : a, new Kd(a, u, s, t.opacity);
}

function Kd(t, e, r, n) {
  this.h = +t, this.s = +e, this.l = +r, this.opacity = +n;
}

function Xd(t, e, r) {
  return 255 * (t < 60 ? e + (r - e) * t / 60 : t < 180 ? r : t < 240 ? e + (r - e) * (240 - t) / 60 : e);
}

function Qd(t) {
  return function () {
    return t;
  };
}

function Jd(t) {
  return 1 == (t = +t) ? Zd : function (e, r) {
    return r - e ? function (t, e, r) {
      return t = Math.pow(t, r), e = Math.pow(e, r) - t, r = 1 / r, function (n) {
        return Math.pow(t + n * e, r);
      };
    }(e, r, t) : Qd(isNaN(e) ? r : e);
  };
}

function Zd(t, e) {
  var r = e - t;
  return r ? function (t, e) {
    return function (r) {
      return t + r * e;
    };
  }(t, r) : Qd(isNaN(t) ? e : t);
}

Od(Ed, Ld, {
  copy: function copy(t) {
    return Object.assign(new this.constructor(), this, t);
  },
  displayable: function displayable() {
    return this.rgb().displayable();
  },
  hex: Nd,
  formatHex: Nd,
  formatHsl: function formatHsl() {
    return Yd(this).formatHsl();
  },
  formatRgb: Fd,
  toString: Fd
}), Od(Ud, Bd, Sd(Ed, {
  brighter: function brighter(t) {
    return t = null == t ? 1 / .7 : Math.pow(1 / .7, t), new Ud(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  darker: function darker(t) {
    return t = null == t ? .7 : Math.pow(.7, t), new Ud(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  rgb: function rgb() {
    return this;
  },
  displayable: function displayable() {
    return -.5 <= this.r && this.r < 255.5 && -.5 <= this.g && this.g < 255.5 && -.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: Wd,
  formatHex: Wd,
  formatRgb: $d,
  toString: $d
})), Od(Kd, function (t, e, r, n) {
  return 1 === arguments.length ? Yd(t) : new Kd(t, e, r, null == n ? 1 : n);
}, Sd(Ed, {
  brighter: function brighter(t) {
    return t = null == t ? 1 / .7 : Math.pow(1 / .7, t), new Kd(this.h, this.s, this.l * t, this.opacity);
  },
  darker: function darker(t) {
    return t = null == t ? .7 : Math.pow(.7, t), new Kd(this.h, this.s, this.l * t, this.opacity);
  },
  rgb: function rgb() {
    var t = this.h % 360 + 360 * (this.h < 0),
        e = isNaN(t) || isNaN(this.s) ? 0 : this.s,
        r = this.l,
        n = r + (r < .5 ? r : 1 - r) * e,
        i = 2 * r - n;
    return new Ud(Xd(t >= 240 ? t - 240 : t + 120, i, n), Xd(t, i, n), Xd(t < 120 ? t + 240 : t - 120, i, n), this.opacity);
  },
  displayable: function displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl: function formatHsl() {
    var t = this.opacity;
    return (1 === (t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t))) ? "hsl(" : "hsla(") + (this.h || 0) + ", " + 100 * (this.s || 0) + "%, " + 100 * (this.l || 0) + "%" + (1 === t ? ")" : ", " + t + ")");
  }
}));

var tp = function t(e) {
  var r = Jd(e);

  function n(t, e) {
    var n = r((t = Bd(t)).r, (e = Bd(e)).r),
        i = r(t.g, e.g),
        o = r(t.b, e.b),
        a = Zd(t.opacity, e.opacity);
    return function (e) {
      return t.r = n(e), t.g = i(e), t.b = o(e), t.opacity = a(e), t + "";
    };
  }

  return n.gamma = t, n;
}(1);

function ep(t, e) {
  e || (e = []);
  var r,
      n = t ? Math.min(e.length, t.length) : 0,
      i = e.slice();
  return function (o) {
    for (r = 0; r < n; ++r) {
      i[r] = t[r] * (1 - o) + e[r] * o;
    }

    return i;
  };
}

function rp(t, e) {
  var r,
      n = e ? e.length : 0,
      i = t ? Math.min(n, t.length) : 0,
      o = new Array(i),
      a = new Array(n);

  for (r = 0; r < i; ++r) {
    o[r] = lp(t[r], e[r]);
  }

  for (; r < n; ++r) {
    a[r] = e[r];
  }

  return function (t) {
    for (r = 0; r < i; ++r) {
      a[r] = o[r](t);
    }

    return a;
  };
}

function np(t, e) {
  var r = new Date();
  return t = +t, e = +e, function (n) {
    return r.setTime(t * (1 - n) + e * n), r;
  };
}

function ip(t, e) {
  return t = +t, e = +e, function (r) {
    return t * (1 - r) + e * r;
  };
}

function op(t, e) {
  var r,
      n = {},
      i = {};

  for (r in null !== t && "object" === ke(t) || (t = {}), null !== e && "object" === ke(e) || (e = {}), e) {
    r in t ? n[r] = lp(t[r], e[r]) : i[r] = e[r];
  }

  return function (t) {
    for (r in n) {
      i[r] = n[r](t);
    }

    return i;
  };
}

var ap = q.f;
!m || "lastIndex" in [] || (ap(Array.prototype, "lastIndex", {
  configurable: !0,
  get: function get() {
    var t = Ht(this),
        e = Ot(t.length);
    return 0 == e ? 0 : e - 1;
  }
}), Hr("lastIndex"));
var up = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    sp = new RegExp(up.source, "g");

function cp(t, e) {
  var r,
      n,
      i,
      o = up.lastIndex = sp.lastIndex = 0,
      a = -1,
      u = [],
      s = [];

  for (t += "", e += ""; (r = up.exec(t)) && (n = sp.exec(e));) {
    (i = n.index) > o && (i = e.slice(o, i), u[a] ? u[a] += i : u[++a] = i), (r = r[0]) === (n = n[0]) ? u[a] ? u[a] += n : u[++a] = n : (u[++a] = null, s.push({
      i: a,
      x: ip(r, n)
    })), o = sp.lastIndex;
  }

  return o < e.length && (i = e.slice(o), u[a] ? u[a] += i : u[++a] = i), u.length < 2 ? s[0] ? function (t) {
    return function (e) {
      return t(e) + "";
    };
  }(s[0].x) : function (t) {
    return function () {
      return t;
    };
  }(e) : (e = s.length, function (t) {
    for (var r, n = 0; n < e; ++n) {
      u[(r = s[n]).i] = r.x(t);
    }

    return u.join("");
  });
}

function lp(t, e) {
  var r,
      n,
      i = ke(e);
  return null == e || "boolean" === i ? Qd(e) : ("number" === i ? ip : "string" === i ? (r = Ld(e)) ? (e = r, tp) : cp : e instanceof Ld ? tp : e instanceof Date ? np : (n = e, !ArrayBuffer.isView(n) || n instanceof DataView ? Array.isArray(e) ? rp : "function" != typeof e.valueOf && "function" != typeof e.toString || isNaN(e) ? op : ip : ep))(t, e);
}

var fp = h(function (t, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var r = "function" == typeof Symbol && Symbol["for"],
      n = r ? Symbol["for"]("react.element") : 60103,
      i = r ? Symbol["for"]("react.portal") : 60106,
      o = r ? Symbol["for"]("react.fragment") : 60107,
      a = r ? Symbol["for"]("react.strict_mode") : 60108,
      u = r ? Symbol["for"]("react.profiler") : 60114,
      s = r ? Symbol["for"]("react.provider") : 60109,
      c = r ? Symbol["for"]("react.context") : 60110,
      l = r ? Symbol["for"]("react.async_mode") : 60111,
      f = r ? Symbol["for"]("react.concurrent_mode") : 60111,
      d = r ? Symbol["for"]("react.forward_ref") : 60112,
      p = r ? Symbol["for"]("react.suspense") : 60113,
      h = r ? Symbol["for"]("react.suspense_list") : 60120,
      v = r ? Symbol["for"]("react.memo") : 60115,
      y = r ? Symbol["for"]("react.lazy") : 60116,
      g = r ? Symbol["for"]("react.fundamental") : 60117,
      m = r ? Symbol["for"]("react.responder") : 60118,
      b = r ? Symbol["for"]("react.scope") : 60119;

  function w(t) {
    if ("object" === ke(t) && null !== t) {
      var e = t.$$typeof;

      switch (e) {
        case n:
          switch (t = t.type) {
            case l:
            case f:
            case o:
            case u:
            case a:
            case p:
              return t;

            default:
              switch (t = t && t.$$typeof) {
                case c:
                case d:
                case y:
                case v:
                case s:
                  return t;

                default:
                  return e;
              }

          }

        case i:
          return e;
      }
    }
  }

  function x(t) {
    return w(t) === f;
  }

  e.typeOf = w, e.AsyncMode = l, e.ConcurrentMode = f, e.ContextConsumer = c, e.ContextProvider = s, e.Element = n, e.ForwardRef = d, e.Fragment = o, e.Lazy = y, e.Memo = v, e.Portal = i, e.Profiler = u, e.StrictMode = a, e.Suspense = p, e.isValidElementType = function (t) {
    return "string" == typeof t || "function" == typeof t || t === o || t === f || t === u || t === a || t === p || t === h || "object" === ke(t) && null !== t && (t.$$typeof === y || t.$$typeof === v || t.$$typeof === s || t.$$typeof === c || t.$$typeof === d || t.$$typeof === g || t.$$typeof === m || t.$$typeof === b);
  }, e.isAsyncMode = function (t) {
    return x(t) || w(t) === l;
  }, e.isConcurrentMode = x, e.isContextConsumer = function (t) {
    return w(t) === c;
  }, e.isContextProvider = function (t) {
    return w(t) === s;
  }, e.isElement = function (t) {
    return "object" === ke(t) && null !== t && t.$$typeof === n;
  }, e.isForwardRef = function (t) {
    return w(t) === d;
  }, e.isFragment = function (t) {
    return w(t) === o;
  }, e.isLazy = function (t) {
    return w(t) === y;
  }, e.isMemo = function (t) {
    return w(t) === v;
  }, e.isPortal = function (t) {
    return w(t) === i;
  }, e.isProfiler = function (t) {
    return w(t) === u;
  }, e.isStrictMode = function (t) {
    return w(t) === a;
  }, e.isSuspense = function (t) {
    return w(t) === p;
  };
});
p(fp);
fp.typeOf, fp.AsyncMode, fp.ConcurrentMode, fp.ContextConsumer, fp.ContextProvider, fp.Element, fp.ForwardRef, fp.Fragment, fp.Lazy, fp.Memo, fp.Portal, fp.Profiler, fp.StrictMode, fp.Suspense, fp.isValidElementType, fp.isAsyncMode, fp.isConcurrentMode, fp.isContextConsumer, fp.isContextProvider, fp.isElement, fp.isForwardRef, fp.isFragment, fp.isLazy, fp.isMemo, fp.isPortal, fp.isProfiler, fp.isStrictMode, fp.isSuspense;
var dp = h(function (t, e) {
  "production" !== process.env.NODE_ENV && function () {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var t = "function" == typeof Symbol && Symbol["for"],
        r = t ? Symbol["for"]("react.element") : 60103,
        n = t ? Symbol["for"]("react.portal") : 60106,
        i = t ? Symbol["for"]("react.fragment") : 60107,
        o = t ? Symbol["for"]("react.strict_mode") : 60108,
        a = t ? Symbol["for"]("react.profiler") : 60114,
        u = t ? Symbol["for"]("react.provider") : 60109,
        s = t ? Symbol["for"]("react.context") : 60110,
        c = t ? Symbol["for"]("react.async_mode") : 60111,
        l = t ? Symbol["for"]("react.concurrent_mode") : 60111,
        f = t ? Symbol["for"]("react.forward_ref") : 60112,
        d = t ? Symbol["for"]("react.suspense") : 60113,
        p = t ? Symbol["for"]("react.suspense_list") : 60120,
        h = t ? Symbol["for"]("react.memo") : 60115,
        v = t ? Symbol["for"]("react.lazy") : 60116,
        y = t ? Symbol["for"]("react.fundamental") : 60117,
        g = t ? Symbol["for"]("react.responder") : 60118,
        m = t ? Symbol["for"]("react.scope") : 60119;

    var b = function b(t) {
      for (var e = arguments.length, r = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++) {
        r[n - 1] = arguments[n];
      }

      var i = 0,
          o = "Warning: " + t.replace(/%s/g, function () {
        return r[i++];
      });
      "undefined" != typeof console && console.warn(o);

      try {
        throw new Error(o);
      } catch (t) {}
    },
        w = function w(t, e) {
      if (void 0 === e) throw new Error("`lowPriorityWarningWithoutStack(condition, format, ...args)` requires a warning message argument");

      if (!t) {
        for (var r = arguments.length, n = new Array(r > 2 ? r - 2 : 0), i = 2; i < r; i++) {
          n[i - 2] = arguments[i];
        }

        b.apply(void 0, [e].concat(n));
      }
    };

    function x(t) {
      if ("object" === ke(t) && null !== t) {
        var e = t.$$typeof;

        switch (e) {
          case r:
            var p = t.type;

            switch (p) {
              case c:
              case l:
              case i:
              case a:
              case o:
              case d:
                return p;

              default:
                var y = p && p.$$typeof;

                switch (y) {
                  case s:
                  case f:
                  case v:
                  case h:
                  case u:
                    return y;

                  default:
                    return e;
                }

            }

          case n:
            return e;
        }
      }
    }

    var O = c,
        S = l,
        E = s,
        k = u,
        A = r,
        j = f,
        T = i,
        _ = v,
        P = h,
        M = n,
        R = a,
        I = o,
        C = d,
        V = !1;

    function N(t) {
      return x(t) === l;
    }

    e.typeOf = x, e.AsyncMode = O, e.ConcurrentMode = S, e.ContextConsumer = E, e.ContextProvider = k, e.Element = A, e.ForwardRef = j, e.Fragment = T, e.Lazy = _, e.Memo = P, e.Portal = M, e.Profiler = R, e.StrictMode = I, e.Suspense = C, e.isValidElementType = function (t) {
      return "string" == typeof t || "function" == typeof t || t === i || t === l || t === a || t === o || t === d || t === p || "object" === ke(t) && null !== t && (t.$$typeof === v || t.$$typeof === h || t.$$typeof === u || t.$$typeof === s || t.$$typeof === f || t.$$typeof === y || t.$$typeof === g || t.$$typeof === m);
    }, e.isAsyncMode = function (t) {
      return V || (V = !0, w(!1, "The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), N(t) || x(t) === c;
    }, e.isConcurrentMode = N, e.isContextConsumer = function (t) {
      return x(t) === s;
    }, e.isContextProvider = function (t) {
      return x(t) === u;
    }, e.isElement = function (t) {
      return "object" === ke(t) && null !== t && t.$$typeof === r;
    }, e.isForwardRef = function (t) {
      return x(t) === f;
    }, e.isFragment = function (t) {
      return x(t) === i;
    }, e.isLazy = function (t) {
      return x(t) === v;
    }, e.isMemo = function (t) {
      return x(t) === h;
    }, e.isPortal = function (t) {
      return x(t) === n;
    }, e.isProfiler = function (t) {
      return x(t) === a;
    }, e.isStrictMode = function (t) {
      return x(t) === o;
    }, e.isSuspense = function (t) {
      return x(t) === d;
    };
  }();
});
p(dp);
dp.typeOf, dp.AsyncMode, dp.ConcurrentMode, dp.ContextConsumer, dp.ContextProvider, dp.Element, dp.ForwardRef, dp.Fragment, dp.Lazy, dp.Memo, dp.Portal, dp.Profiler, dp.StrictMode, dp.Suspense, dp.isValidElementType, dp.isAsyncMode, dp.isConcurrentMode, dp.isContextConsumer, dp.isContextProvider, dp.isElement, dp.isForwardRef, dp.isFragment, dp.isLazy, dp.isMemo, dp.isPortal, dp.isProfiler, dp.isStrictMode, dp.isSuspense;
var pp = h(function (t) {
  "production" === process.env.NODE_ENV ? t.exports = fp : t.exports = dp;
}),
    hp = Ze.f,
    vp = g(function () {
  return !Object.getOwnPropertyNames(1);
});
Wt({
  target: "Object",
  stat: !0,
  forced: vp
}, {
  getOwnPropertyNames: hp
});
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var yp = Object.getOwnPropertySymbols,
    gp = Object.prototype.hasOwnProperty,
    mp = Object.prototype.propertyIsEnumerable;

function bp(t) {
  if (null == t) throw new TypeError("Object.assign cannot be called with null or undefined");
  return Object(t);
}

var wp = function () {
  try {
    if (!Object.assign) return !1;
    var t = new String("abc");
    if (t[5] = "de", "5" === Object.getOwnPropertyNames(t)[0]) return !1;

    for (var e = {}, r = 0; r < 10; r++) {
      e["_" + String.fromCharCode(r)] = r;
    }

    if ("0123456789" !== Object.getOwnPropertyNames(e).map(function (t) {
      return e[t];
    }).join("")) return !1;
    var n = {};
    return "abcdefghijklmnopqrst".split("").forEach(function (t) {
      n[t] = t;
    }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, n)).join("");
  } catch (t) {
    return !1;
  }
}() ? Object.assign : function (t, e) {
  for (var r, n, i = bp(t), o = 1; o < arguments.length; o++) {
    for (var a in r = Object(arguments[o])) {
      gp.call(r, a) && (i[a] = r[a]);
    }

    if (yp) {
      n = yp(r);

      for (var u = 0; u < n.length; u++) {
        mp.call(r, n[u]) && (i[n[u]] = r[n[u]]);
      }
    }
  }

  return i;
},
    xp = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
    Op = function Op() {};

if ("production" !== process.env.NODE_ENV) {
  var Sp = xp,
      Ep = {},
      kp = Function.call.bind(Object.prototype.hasOwnProperty);

  Op = function Op(t) {
    var e = "Warning: " + t;
    "undefined" != typeof console && console.error(e);

    try {
      throw new Error(e);
    } catch (t) {}
  };
}

function Ap(t, e, r, n, i) {
  if ("production" !== process.env.NODE_ENV) for (var o in t) {
    if (kp(t, o)) {
      var a;

      try {
        if ("function" != typeof t[o]) {
          var u = Error((n || "React class") + ": " + r + " type `" + o + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + ke(t[o]) + "`.");
          throw u.name = "Invariant Violation", u;
        }

        a = t[o](e, o, n, r, null, Sp);
      } catch (t) {
        a = t;
      }

      if (!a || a instanceof Error || Op((n || "React class") + ": type specification of " + r + " `" + o + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + ke(a) + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), a instanceof Error && !(a.message in Ep)) {
        Ep[a.message] = !0;
        var s = i ? i() : "";
        Op("Failed " + r + " type: " + a.message + (null != s ? s : ""));
      }
    }
  }
}

Ap.resetWarningCache = function () {
  "production" !== process.env.NODE_ENV && (Ep = {});
};

var jp = Ap,
    Tp = Function.call.bind(Object.prototype.hasOwnProperty),
    _p = function _p() {};

function Pp() {
  return null;
}

"production" !== process.env.NODE_ENV && (_p = function _p(t) {
  var e = "Warning: " + t;
  "undefined" != typeof console && console.error(e);

  try {
    throw new Error(e);
  } catch (t) {}
});

var Mp = function Mp(t, e) {
  var r = "function" == typeof Symbol && Symbol.iterator;
  var n = {
    array: u("array"),
    bool: u("boolean"),
    func: u("function"),
    number: u("number"),
    object: u("object"),
    string: u("string"),
    symbol: u("symbol"),
    any: a(Pp),
    arrayOf: function arrayOf(t) {
      return a(function (e, r, n, i, a) {
        if ("function" != typeof t) return new o("Property `" + a + "` of component `" + n + "` has invalid PropType notation inside arrayOf.");
        var u = e[r];
        if (!Array.isArray(u)) return new o("Invalid " + i + " `" + a + "` of type `" + c(u) + "` supplied to `" + n + "`, expected an array.");

        for (var s = 0; s < u.length; s++) {
          var l = t(u, s, n, i, a + "[" + s + "]", xp);
          if (l instanceof Error) return l;
        }

        return null;
      });
    },
    element: a(function (e, r, n, i, a) {
      var u = e[r];
      return t(u) ? null : new o("Invalid " + i + " `" + a + "` of type `" + c(u) + "` supplied to `" + n + "`, expected a single ReactElement.");
    }),
    elementType: a(function (t, e, r, n, i) {
      var a = t[e];
      return pp.isValidElementType(a) ? null : new o("Invalid " + n + " `" + i + "` of type `" + c(a) + "` supplied to `" + r + "`, expected a single ReactElement type.");
    }),
    instanceOf: function instanceOf(t) {
      return a(function (e, r, n, i, a) {
        if (!(e[r] instanceof t)) {
          var u = t.name || "<<anonymous>>";
          return new o("Invalid " + i + " `" + a + "` of type `" + function (t) {
            if (!t.constructor || !t.constructor.name) return "<<anonymous>>";
            return t.constructor.name;
          }(e[r]) + "` supplied to `" + n + "`, expected instance of `" + u + "`.");
        }

        return null;
      });
    },
    node: a(function (t, e, r, n, i) {
      return s(t[e]) ? null : new o("Invalid " + n + " `" + i + "` supplied to `" + r + "`, expected a ReactNode.");
    }),
    objectOf: function objectOf(t) {
      return a(function (e, r, n, i, a) {
        if ("function" != typeof t) return new o("Property `" + a + "` of component `" + n + "` has invalid PropType notation inside objectOf.");
        var u = e[r],
            s = c(u);
        if ("object" !== s) return new o("Invalid " + i + " `" + a + "` of type `" + s + "` supplied to `" + n + "`, expected an object.");

        for (var l in u) {
          if (Tp(u, l)) {
            var f = t(u, l, n, i, a + "." + l, xp);
            if (f instanceof Error) return f;
          }
        }

        return null;
      });
    },
    oneOf: function oneOf(t) {
      if (!Array.isArray(t)) return "production" !== process.env.NODE_ENV && (arguments.length > 1 ? _p("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).") : _p("Invalid argument supplied to oneOf, expected an array.")), Pp;

      function e(e, r, n, a, u) {
        for (var s = e[r], c = 0; c < t.length; c++) {
          if (i(s, t[c])) return null;
        }

        var f = JSON.stringify(t, function (t, e) {
          return "symbol" === l(e) ? String(e) : e;
        });
        return new o("Invalid " + a + " `" + u + "` of value `" + String(s) + "` supplied to `" + n + "`, expected one of " + f + ".");
      }

      return a(e);
    },
    oneOfType: function oneOfType(t) {
      if (!Array.isArray(t)) return "production" !== process.env.NODE_ENV && _p("Invalid argument supplied to oneOfType, expected an instance of array."), Pp;

      for (var e = 0; e < t.length; e++) {
        var r = t[e];
        if ("function" != typeof r) return _p("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + f(r) + " at index " + e + "."), Pp;
      }

      return a(function (e, r, n, i, a) {
        for (var u = 0; u < t.length; u++) {
          if (null == (0, t[u])(e, r, n, i, a, xp)) return null;
        }

        return new o("Invalid " + i + " `" + a + "` supplied to `" + n + "`.");
      });
    },
    shape: function shape(t) {
      return a(function (e, r, n, i, a) {
        var u = e[r],
            s = c(u);
        if ("object" !== s) return new o("Invalid " + i + " `" + a + "` of type `" + s + "` supplied to `" + n + "`, expected `object`.");

        for (var l in t) {
          var f = t[l];

          if (f) {
            var d = f(u, l, n, i, a + "." + l, xp);
            if (d) return d;
          }
        }

        return null;
      });
    },
    exact: function exact(t) {
      return a(function (e, r, n, i, a) {
        var u = e[r],
            s = c(u);
        if ("object" !== s) return new o("Invalid " + i + " `" + a + "` of type `" + s + "` supplied to `" + n + "`, expected `object`.");
        var l = wp({}, e[r], t);

        for (var f in l) {
          var d = t[f];
          if (!d) return new o("Invalid " + i + " `" + a + "` key `" + f + "` supplied to `" + n + "`.\nBad object: " + JSON.stringify(e[r], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(t), null, "  "));
          var p = d(u, f, n, i, a + "." + f, xp);
          if (p) return p;
        }

        return null;
      });
    }
  };

  function i(t, e) {
    return t === e ? 0 !== t || 1 / t == 1 / e : t != t && e != e;
  }

  function o(t) {
    this.message = t, this.stack = "";
  }

  function a(t) {
    if ("production" !== process.env.NODE_ENV) var r = {},
        n = 0;

    function i(i, a, u, s, c, l, f) {
      if (s = s || "<<anonymous>>", l = l || u, f !== xp) {
        if (e) {
          var d = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
          throw d.name = "Invariant Violation", d;
        }

        if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
          var p = s + ":" + u;
          !r[p] && n < 3 && (_p("You are manually calling a React.PropTypes validation function for the `" + l + "` prop on `" + s + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), r[p] = !0, n++);
        }
      }

      return null == a[u] ? i ? null === a[u] ? new o("The " + c + " `" + l + "` is marked as required in `" + s + "`, but its value is `null`.") : new o("The " + c + " `" + l + "` is marked as required in `" + s + "`, but its value is `undefined`.") : null : t(a, u, s, c, l);
    }

    var a = i.bind(null, !1);
    return a.isRequired = i.bind(null, !0), a;
  }

  function u(t) {
    return a(function (e, r, n, i, a, u) {
      var s = e[r];
      return c(s) !== t ? new o("Invalid " + i + " `" + a + "` of type `" + l(s) + "` supplied to `" + n + "`, expected `" + t + "`.") : null;
    });
  }

  function s(e) {
    switch (ke(e)) {
      case "number":
      case "string":
      case "undefined":
        return !0;

      case "boolean":
        return !e;

      case "object":
        if (Array.isArray(e)) return e.every(s);
        if (null === e || t(e)) return !0;

        var n = function (t) {
          var e = t && (r && t[r] || t["@@iterator"]);
          if ("function" == typeof e) return e;
        }(e);

        if (!n) return !1;
        var i,
            o = n.call(e);

        if (n !== e.entries) {
          for (; !(i = o.next()).done;) {
            if (!s(i.value)) return !1;
          }
        } else for (; !(i = o.next()).done;) {
          var a = i.value;
          if (a && !s(a[1])) return !1;
        }

        return !0;

      default:
        return !1;
    }
  }

  function c(t) {
    var e = ke(t);
    return Array.isArray(t) ? "array" : t instanceof RegExp ? "object" : function (t, e) {
      return "symbol" === t || !!e && ("Symbol" === e["@@toStringTag"] || "function" == typeof Symbol && e instanceof Symbol);
    }(e, t) ? "symbol" : e;
  }

  function l(t) {
    if (null == t) return "" + t;
    var e = c(t);

    if ("object" === e) {
      if (t instanceof Date) return "date";
      if (t instanceof RegExp) return "regexp";
    }

    return e;
  }

  function f(t) {
    var e = l(t);

    switch (e) {
      case "array":
      case "object":
        return "an " + e;

      case "boolean":
      case "date":
      case "regexp":
        return "a " + e;

      default:
        return e;
    }
  }

  return o.prototype = Error.prototype, n.checkPropTypes = jp, n.resetWarningCache = jp.resetWarningCache, n.PropTypes = n, n;
};

function Rp() {}

function Ip() {}

Ip.resetWarningCache = Rp;
var Cp = h(function (t) {
  if ("production" !== process.env.NODE_ENV) {
    var e = pp;
    t.exports = Mp(e.isElement, !0);
  } else t.exports = function () {
    function t(t, e, r, n, i, o) {
      if (o !== xp) {
        var a = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw a.name = "Invariant Violation", a;
      }
    }

    function e() {
      return t;
    }

    t.isRequired = t;
    var r = {
      array: t,
      bool: t,
      func: t,
      number: t,
      object: t,
      string: t,
      symbol: t,
      any: t,
      arrayOf: e,
      element: t,
      elementType: t,
      instanceOf: e,
      node: t,
      objectOf: e,
      oneOf: e,
      oneOfType: e,
      shape: e,
      exact: e,
      checkPropTypes: Ip,
      resetWarningCache: Rp
    };
    return r.PropTypes = r, r;
  }();
});

function Vp(e) {
  var r = e.generator,
      n = e.data,
      i = e.style,
      o = void 0 === i ? {} : i,
      a = Ne(e, ["generator", "data", "style"]),
      u = t.useRef(null),
      s = lp(u.current ? u.current.getAttribute("d") : "", r(n));
  return t.createElement(t.Fragment, null, t.createElement(wd, {
    "native": !0,
    reset: !0,
    to: {
      t: 1
    },
    from: {
      t: 0
    }
  }, function (e) {
    var r = e.t;
    return t.createElement(xd.path, Pe({
      ref: u,
      d: r.interpolate(s),
      style: o
    }, a));
  }));
}

Vp.displayName = "Path", Vp.propTypes = {
  generator: Cp.func.isRequired,
  data: Cp.array.isRequired
};

var Np,
    Fp = q.f,
    Lp = y.Int8Array,
    Dp = Lp && Lp.prototype,
    zp = y.Uint8ClampedArray,
    qp = zp && zp.prototype,
    Bp = Lp && Fn(Lp),
    Up = Dp && Fn(Dp),
    Wp = Object.prototype,
    $p = Wp.isPrototypeOf,
    Hp = Zt("toStringTag"),
    Gp = et("TYPED_ARRAY_TAG"),
    Yp = Of && !!Un && "Opera" !== gn(y.opera),
    Kp = !1,
    Xp = {
  Int8Array: 1,
  Uint8Array: 1,
  Uint8ClampedArray: 1,
  Int16Array: 2,
  Uint16Array: 2,
  Int32Array: 4,
  Uint32Array: 4,
  Float32Array: 4,
  Float64Array: 8
},
    Qp = function Qp(t) {
  return _(t) && R(Xp, gn(t));
};

for (Np in Xp) {
  y[Np] || (Yp = !1);
}

if ((!Yp || "function" != typeof Bp || Bp === Function.prototype) && (Bp = function Bp() {
  throw TypeError("Incorrect invocation");
}, Yp)) for (Np in Xp) {
  y[Np] && Un(y[Np], Bp);
}
if ((!Yp || !Up || Up === Wp) && (Up = Bp.prototype, Yp)) for (Np in Xp) {
  y[Np] && Un(y[Np].prototype, Up);
}
if (Yp && Fn(qp) !== Up && Un(qp, Up), m && !R(Up, Hp)) for (Np in Kp = !0, Fp(Up, Hp, {
  get: function get() {
    return _(this) ? this[Gp] : void 0;
  }
}), Xp) {
  y[Np] && B(y[Np], Gp, Np);
}

var Jp = {
  NATIVE_ARRAY_BUFFER_VIEWS: Yp,
  TYPED_ARRAY_TAG: Kp && Gp,
  aTypedArray: function aTypedArray(t) {
    if (Qp(t)) return t;
    throw TypeError("Target is not a typed array");
  },
  aTypedArrayConstructor: function aTypedArrayConstructor(t) {
    if (Un) {
      if ($p.call(Bp, t)) return t;
    } else for (var e in Xp) {
      if (R(Xp, Np)) {
        var r = y[e];
        if (r && (t === r || $p.call(r, t))) return t;
      }
    }

    throw TypeError("Target is not a typed array constructor");
  },
  exportTypedArrayMethod: function exportTypedArrayMethod(t, e, r) {
    if (m) {
      if (r) for (var n in Xp) {
        var i = y[n];
        i && R(i.prototype, t) && delete i.prototype[t];
      }
      Up[t] && !r || ht(Up, t, r ? e : Yp && Dp[t] || e);
    }
  },
  exportTypedArrayStaticMethod: function exportTypedArrayStaticMethod(t, e, r) {
    var n, i;

    if (m) {
      if (Un) {
        if (r) for (n in Xp) {
          (i = y[n]) && R(i, t) && delete i[t];
        }
        if (Bp[t] && !r) return;

        try {
          return ht(Bp, t, r ? e : Yp && Lp[t] || e);
        } catch (t) {}
      }

      for (n in Xp) {
        !(i = y[n]) || i[t] && !r || ht(i, t, e);
      }
    }
  },
  isView: function isView(t) {
    var e = gn(t);
    return "DataView" === e || R(Xp, e);
  },
  isTypedArray: Qp,
  TypedArray: Bp,
  TypedArrayPrototype: Up
},
    Zp = Jp.NATIVE_ARRAY_BUFFER_VIEWS,
    th = y.ArrayBuffer,
    eh = y.Int8Array,
    rh = !Zp || !g(function () {
  eh(1);
}) || !g(function () {
  new eh(-1);
}) || !En(function (t) {
  new eh(), new eh(null), new eh(1.5), new eh(t);
}, !0) || g(function () {
  return 1 !== new eh(new th(2), 1, void 0).length;
}),
    nh = function nh(t, e) {
  var r = function (t) {
    var e = wt(t);
    if (e < 0) throw RangeError("The argument can't be less than 0");
    return e;
  }(t);

  if (r % e) throw RangeError("Wrong offset");
  return r;
},
    ih = Jp.aTypedArrayConstructor,
    oh = function oh(t) {
  var e,
      r,
      n,
      i,
      o,
      a,
      u = Ht(t),
      s = arguments.length,
      c = s > 1 ? arguments[1] : void 0,
      l = void 0 !== c,
      f = bn(u);
  if (null != f && !dn(f)) for (a = (o = f.call(u)).next, u = []; !(i = a.call(o)).done;) {
    u.push(i.value);
  }

  for (l && s > 2 && (c = he(c, arguments[2], 2)), r = Ot(u.length), n = new (ih(this))(r), e = 0; r > e; e++) {
    n[e] = l ? c(u[e], e) : u[e];
  }

  return n;
},
    ah = h(function (t) {
  var e = Rt.f,
      r = ge.forEach,
      n = pt.get,
      i = pt.set,
      o = q.f,
      a = L.f,
      u = Math.round,
      s = y.RangeError,
      c = id.ArrayBuffer,
      l = id.DataView,
      f = Jp.NATIVE_ARRAY_BUFFER_VIEWS,
      d = Jp.TYPED_ARRAY_TAG,
      p = Jp.TypedArray,
      h = Jp.TypedArrayPrototype,
      v = Jp.aTypedArrayConstructor,
      g = Jp.isTypedArray,
      b = function b(t, e) {
    for (var r = 0, n = e.length, i = new (v(t))(n); n > r;) {
      i[r] = e[r++];
    }

    return i;
  },
      w = function w(t, e) {
    o(t, e, {
      get: function get() {
        return n(this)[e];
      }
    });
  },
      x = function x(t) {
    var e;
    return t instanceof c || "ArrayBuffer" == (e = gn(t)) || "SharedArrayBuffer" == e;
  },
      S = function S(t, e) {
    return g(t) && "symbol" != typeof e && e in t && String(+e) == String(e);
  },
      E = function E(t, e) {
    return S(t, e = P(e, !0)) ? O(2, t[e]) : a(t, e);
  },
      k = function k(t, e, r) {
    return !(S(t, e = P(e, !0)) && _(r) && R(r, "value")) || R(r, "get") || R(r, "set") || r.configurable || R(r, "writable") && !r.writable || R(r, "enumerable") && !r.enumerable ? o(t, e, r) : (t[e] = r.value, t);
  };

  m ? (f || (L.f = E, q.f = k, w(h, "buffer"), w(h, "byteOffset"), w(h, "byteLength"), w(h, "length")), Wt({
    target: "Object",
    stat: !0,
    forced: !f
  }, {
    getOwnPropertyDescriptor: E,
    defineProperty: k
  }), t.exports = function (t, a, v) {
    var m = t.match(/\d+$/)[0] / 8,
        w = t + (v ? "Clamped" : "") + "Array",
        O = "get" + t,
        S = "set" + t,
        E = y[w],
        k = E,
        A = k && k.prototype,
        j = {},
        T = function T(t, e) {
      o(t, e, {
        get: function get() {
          return function (t, e) {
            var r = n(t);
            return r.view[O](e * m + r.byteOffset, !0);
          }(this, e);
        },
        set: function set(t) {
          return function (t, e, r) {
            var i = n(t);
            v && (r = (r = u(r)) < 0 ? 0 : r > 255 ? 255 : 255 & r), i.view[S](e * m + i.byteOffset, r, !0);
          }(this, e, t);
        },
        enumerable: !0
      });
    };

    f ? rh && (k = a(function (t, e, r, n) {
      return ki(t, k, w), Ai(_(e) ? x(e) ? void 0 !== n ? new E(e, nh(r, m), n) : void 0 !== r ? new E(e, nh(r, m)) : new E(e) : g(e) ? b(k, e) : oh.call(k, e) : new E(Sf(e)), t, k);
    }), Un && Un(k, p), r(e(E), function (t) {
      t in k || B(k, t, E[t]);
    }), k.prototype = A) : (k = a(function (t, e, r, n) {
      ki(t, k, w);
      var o,
          a,
          u,
          f = 0,
          d = 0;

      if (_(e)) {
        if (!x(e)) return g(e) ? b(k, e) : oh.call(k, e);
        o = e, d = nh(r, m);
        var p = e.byteLength;

        if (void 0 === n) {
          if (p % m) throw s("Wrong length");
          if ((a = p - d) < 0) throw s("Wrong length");
        } else if ((a = Ot(n) * m) + d > p) throw s("Wrong length");

        u = a / m;
      } else u = Sf(e), o = new c(a = u * m);

      for (i(t, {
        buffer: o,
        byteOffset: d,
        byteLength: a,
        length: u,
        view: new l(o)
      }); f < u;) {
        T(t, f++);
      }
    }), Un && Un(k, p), A = k.prototype = Ke(h)), A.constructor !== k && B(A, "constructor", k), d && B(A, d, w), j[w] = k, Wt({
      global: !0,
      forced: k != E,
      sham: !f
    }, j), "BYTES_PER_ELEMENT" in k || B(k, "BYTES_PER_ELEMENT", m), "BYTES_PER_ELEMENT" in A || B(A, "BYTES_PER_ELEMENT", m), Pi(w);
  }) : t.exports = function () {};
});

ah("Float64", function (t) {
  return function (e, r, n) {
    return t(this, e, r, n);
  };
}), ah("Int32", function (t) {
  return function (e, r, n) {
    return t(this, e, r, n);
  };
});

var uh = Math.min,
    sh = [].copyWithin || function (t, e) {
  var r = Ht(this),
      n = Ot(r.length),
      i = kt(t, n),
      o = kt(e, n),
      a = arguments.length > 2 ? arguments[2] : void 0,
      u = uh((void 0 === a ? n : kt(a, n)) - o, n - i),
      s = 1;

  for (o < i && i < o + u && (s = -1, o += u - 1, i += u - 1); u-- > 0;) {
    o in r ? r[i] = r[o] : delete r[i], i += s, o += s;
  }

  return r;
},
    ch = Jp.aTypedArray;

(0, Jp.exportTypedArrayMethod)("copyWithin", function (t, e) {
  return sh.call(ch(this), t, e, arguments.length > 2 ? arguments[2] : void 0);
});
var lh = ge.every,
    fh = Jp.aTypedArray;
(0, Jp.exportTypedArrayMethod)("every", function (t) {
  return lh(fh(this), t, arguments.length > 1 ? arguments[1] : void 0);
});
var dh = Jp.aTypedArray;
(0, Jp.exportTypedArrayMethod)("fill", function (t) {
  return Ur.apply(dh(this), arguments);
});
var ph = ge.filter,
    hh = Jp.aTypedArray,
    vh = Jp.aTypedArrayConstructor;
(0, Jp.exportTypedArrayMethod)("filter", function (t) {
  for (var e = ph(hh(this), t, arguments.length > 1 ? arguments[1] : void 0), r = Qi(this, this.constructor), n = 0, i = e.length, o = new (vh(r))(i); i > n;) {
    o[n] = e[n++];
  }

  return o;
});
var yh = ge.find,
    gh = Jp.aTypedArray;
(0, Jp.exportTypedArrayMethod)("find", function (t) {
  return yh(gh(this), t, arguments.length > 1 ? arguments[1] : void 0);
});
var mh = ge.findIndex,
    bh = Jp.aTypedArray;
(0, Jp.exportTypedArrayMethod)("findIndex", function (t) {
  return mh(bh(this), t, arguments.length > 1 ? arguments[1] : void 0);
});
var wh = ge.forEach,
    xh = Jp.aTypedArray;
(0, Jp.exportTypedArrayMethod)("forEach", function (t) {
  wh(xh(this), t, arguments.length > 1 ? arguments[1] : void 0);
}), (0, Jp.exportTypedArrayStaticMethod)("from", oh, rh);
var Oh = jt.includes,
    Sh = Jp.aTypedArray;
(0, Jp.exportTypedArrayMethod)("includes", function (t) {
  return Oh(Sh(this), t, arguments.length > 1 ? arguments[1] : void 0);
});
var Eh = jt.indexOf,
    kh = Jp.aTypedArray;
(0, Jp.exportTypedArrayMethod)("indexOf", function (t) {
  return Eh(kh(this), t, arguments.length > 1 ? arguments[1] : void 0);
});

var Ah = Zt("iterator"),
    jh = y.Uint8Array,
    Th = Qn.values,
    _h = Qn.keys,
    Ph = Qn.entries,
    Mh = Jp.aTypedArray,
    Rh = Jp.exportTypedArrayMethod,
    Ih = jh && jh.prototype[Ah],
    Ch = !!Ih && ("values" == Ih.name || null == Ih.name),
    Vh = function Vh() {
  return Th.call(Mh(this));
};

Rh("entries", function () {
  return Ph.call(Mh(this));
}), Rh("keys", function () {
  return _h.call(Mh(this));
}), Rh("values", Vh, !Ch), Rh(Ah, Vh, !Ch);
var Nh = Jp.aTypedArray,
    Fh = [].join;
(0, Jp.exportTypedArrayMethod)("join", function (t) {
  return Fh.apply(Nh(this), arguments);
});
var Lh = Math.min,
    Dh = [].lastIndexOf,
    zh = !!Dh && 1 / [1].lastIndexOf(1, -0) < 0,
    qh = rn("lastIndexOf"),
    Bh = xe("indexOf", {
  ACCESSORS: !0,
  1: 0
}),
    Uh = zh || !qh || !Bh ? function (t) {
  if (zh) return Dh.apply(this, arguments) || 0;
  var e = T(this),
      r = Ot(e.length),
      n = r - 1;

  for (arguments.length > 1 && (n = Lh(n, wt(arguments[1]))), n < 0 && (n = r + n); n >= 0; n--) {
    if (n in e && e[n] === t) return n || 0;
  }

  return -1;
} : Dh,
    Wh = Jp.aTypedArray;
(0, Jp.exportTypedArrayMethod)("lastIndexOf", function (t) {
  return Uh.apply(Wh(this), arguments);
});
var $h = ge.map,
    Hh = Jp.aTypedArray,
    Gh = Jp.aTypedArrayConstructor;
(0, Jp.exportTypedArrayMethod)("map", function (t) {
  return $h(Hh(this), t, arguments.length > 1 ? arguments[1] : void 0, function (t, e) {
    return new (Gh(Qi(t, t.constructor)))(e);
  });
});
var Yh = ri.left,
    Kh = Jp.aTypedArray;
(0, Jp.exportTypedArrayMethod)("reduce", function (t) {
  return Yh(Kh(this), t, arguments.length, arguments.length > 1 ? arguments[1] : void 0);
});
var Xh = ri.right,
    Qh = Jp.aTypedArray;
(0, Jp.exportTypedArrayMethod)("reduceRight", function (t) {
  return Xh(Qh(this), t, arguments.length, arguments.length > 1 ? arguments[1] : void 0);
});
var Jh = Jp.aTypedArray,
    Zh = Jp.exportTypedArrayMethod,
    tv = Math.floor;
Zh("reverse", function () {
  for (var t, e = Jh(this).length, r = tv(e / 2), n = 0; n < r;) {
    t = this[n], this[n++] = this[--e], this[e] = t;
  }

  return this;
});
var ev = Jp.aTypedArray;
(0, Jp.exportTypedArrayMethod)("set", function (t) {
  ev(this);
  var e = nh(arguments.length > 1 ? arguments[1] : void 0, 1),
      r = this.length,
      n = Ht(t),
      i = Ot(n.length),
      o = 0;
  if (i + e > r) throw RangeError("Wrong length");

  for (; o < i;) {
    this[e + o] = n[o++];
  }
}, g(function () {
  new Int8Array(1).set({});
}));
var rv = Jp.aTypedArray,
    nv = Jp.aTypedArrayConstructor,
    iv = [].slice;
(0, Jp.exportTypedArrayMethod)("slice", function (t, e) {
  for (var r = iv.call(rv(this), t, e), n = Qi(this, this.constructor), i = 0, o = r.length, a = new (nv(n))(o); o > i;) {
    a[i] = r[i++];
  }

  return a;
}, g(function () {
  new Int8Array(1).slice();
}));
var ov = ge.some,
    av = Jp.aTypedArray;
(0, Jp.exportTypedArrayMethod)("some", function (t) {
  return ov(av(this), t, arguments.length > 1 ? arguments[1] : void 0);
});
var uv = Jp.aTypedArray,
    sv = [].sort;
(0, Jp.exportTypedArrayMethod)("sort", function (t) {
  return sv.call(uv(this), t);
});
var cv = Jp.aTypedArray;
(0, Jp.exportTypedArrayMethod)("subarray", function (t, e) {
  var r = cv(this),
      n = r.length,
      i = kt(t, n);
  return new (Qi(r, r.constructor))(r.buffer, r.byteOffset + i * r.BYTES_PER_ELEMENT, Ot((void 0 === e ? n : kt(e, n)) - i));
});
var lv = y.Int8Array,
    fv = Jp.aTypedArray,
    dv = Jp.exportTypedArrayMethod,
    pv = [].toLocaleString,
    hv = [].slice,
    vv = !!lv && g(function () {
  pv.call(new lv(1));
});
dv("toLocaleString", function () {
  return pv.apply(vv ? hv.call(fv(this)) : fv(this), arguments);
}, g(function () {
  return [1, 2].toLocaleString() != new lv([1, 2]).toLocaleString();
}) || !g(function () {
  lv.prototype.toLocaleString.call([1, 2]);
}));
var yv = Jp.exportTypedArrayMethod,
    gv = y.Uint8Array,
    mv = gv && gv.prototype || {},
    bv = [].toString,
    wv = [].join;
g(function () {
  bv.call({});
}) && (bv = function bv() {
  return wv.call(this);
});
var xv = mv.toString != bv;
yv("toString", bv, xv), rr("asyncIterator"), rr("toStringTag"), or(y.JSON, "JSON", !0), or(Math, "Math", !0);
var Ov = g(function () {
  Fn(1);
});
Wt({
  target: "Object",
  stat: !0,
  forced: Ov,
  sham: !Cn
}, {
  getPrototypeOf: function getPrototypeOf(t) {
    return Fn(Ht(t));
  }
});
h(function (t) {
  var e = function (t) {
    var e = Object.prototype,
        r = e.hasOwnProperty,
        n = "function" == typeof Symbol ? Symbol : {},
        i = n.iterator || "@@iterator",
        o = n.asyncIterator || "@@asyncIterator",
        a = n.toStringTag || "@@toStringTag";

    function u(t, e, r, n) {
      var i = e && e.prototype instanceof l ? e : l,
          o = Object.create(i.prototype),
          a = new O(n || []);
      return o._invoke = function (t, e, r) {
        var n = "suspendedStart";
        return function (i, o) {
          if ("executing" === n) throw new Error("Generator is already running");

          if ("completed" === n) {
            if ("throw" === i) throw o;
            return E();
          }

          for (r.method = i, r.arg = o;;) {
            var a = r.delegate;

            if (a) {
              var u = b(a, r);

              if (u) {
                if (u === c) continue;
                return u;
              }
            }

            if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
              if ("suspendedStart" === n) throw n = "completed", r.arg;
              r.dispatchException(r.arg);
            } else "return" === r.method && r.abrupt("return", r.arg);
            n = "executing";
            var l = s(t, e, r);

            if ("normal" === l.type) {
              if (n = r.done ? "completed" : "suspendedYield", l.arg === c) continue;
              return {
                value: l.arg,
                done: r.done
              };
            }

            "throw" === l.type && (n = "completed", r.method = "throw", r.arg = l.arg);
          }
        };
      }(t, r, a), o;
    }

    function s(t, e, r) {
      try {
        return {
          type: "normal",
          arg: t.call(e, r)
        };
      } catch (t) {
        return {
          type: "throw",
          arg: t
        };
      }
    }

    t.wrap = u;
    var c = {};

    function l() {}

    function f() {}

    function d() {}

    var p = {};

    p[i] = function () {
      return this;
    };

    var h = Object.getPrototypeOf,
        v = h && h(h(S([])));
    v && v !== e && r.call(v, i) && (p = v);
    var y = d.prototype = l.prototype = Object.create(p);

    function g(t) {
      ["next", "throw", "return"].forEach(function (e) {
        t[e] = function (t) {
          return this._invoke(e, t);
        };
      });
    }

    function m(t) {
      var e;

      this._invoke = function (n, i) {
        function o() {
          return new Promise(function (e, o) {
            !function e(n, i, o, a) {
              var u = s(t[n], t, i);

              if ("throw" !== u.type) {
                var c = u.arg,
                    l = c.value;
                return l && "object" === ke(l) && r.call(l, "__await") ? Promise.resolve(l.__await).then(function (t) {
                  e("next", t, o, a);
                }, function (t) {
                  e("throw", t, o, a);
                }) : Promise.resolve(l).then(function (t) {
                  c.value = t, o(c);
                }, function (t) {
                  return e("throw", t, o, a);
                });
              }

              a(u.arg);
            }(n, i, e, o);
          });
        }

        return e = e ? e.then(o, o) : o();
      };
    }

    function b(t, e) {
      var r = t.iterator[e.method];

      if (void 0 === r) {
        if (e.delegate = null, "throw" === e.method) {
          if (t.iterator["return"] && (e.method = "return", e.arg = void 0, b(t, e), "throw" === e.method)) return c;
          e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return c;
      }

      var n = s(r, t.iterator, e.arg);
      if ("throw" === n.type) return e.method = "throw", e.arg = n.arg, e.delegate = null, c;
      var i = n.arg;
      return i ? i.done ? (e[t.resultName] = i.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, c) : i : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, c);
    }

    function w(t) {
      var e = {
        tryLoc: t[0]
      };
      1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }

    function x(t) {
      var e = t.completion || {};
      e.type = "normal", delete e.arg, t.completion = e;
    }

    function O(t) {
      this.tryEntries = [{
        tryLoc: "root"
      }], t.forEach(w, this), this.reset(!0);
    }

    function S(t) {
      if (t) {
        var e = t[i];
        if (e) return e.call(t);
        if ("function" == typeof t.next) return t;

        if (!isNaN(t.length)) {
          var n = -1,
              o = function e() {
            for (; ++n < t.length;) {
              if (r.call(t, n)) return e.value = t[n], e.done = !1, e;
            }

            return e.value = void 0, e.done = !0, e;
          };

          return o.next = o;
        }
      }

      return {
        next: E
      };
    }

    function E() {
      return {
        value: void 0,
        done: !0
      };
    }

    return f.prototype = y.constructor = d, d.constructor = f, d[a] = f.displayName = "GeneratorFunction", t.isGeneratorFunction = function (t) {
      var e = "function" == typeof t && t.constructor;
      return !!e && (e === f || "GeneratorFunction" === (e.displayName || e.name));
    }, t.mark = function (t) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(t, d) : (t.__proto__ = d, a in t || (t[a] = "GeneratorFunction")), t.prototype = Object.create(y), t;
    }, t.awrap = function (t) {
      return {
        __await: t
      };
    }, g(m.prototype), m.prototype[o] = function () {
      return this;
    }, t.AsyncIterator = m, t.async = function (e, r, n, i) {
      var o = new m(u(e, r, n, i));
      return t.isGeneratorFunction(r) ? o : o.next().then(function (t) {
        return t.done ? t.value : o.next();
      });
    }, g(y), y[a] = "Generator", y[i] = function () {
      return this;
    }, y.toString = function () {
      return "[object Generator]";
    }, t.keys = function (t) {
      var e = [];

      for (var r in t) {
        e.push(r);
      }

      return e.reverse(), function r() {
        for (; e.length;) {
          var n = e.pop();
          if (n in t) return r.value = n, r.done = !1, r;
        }

        return r.done = !0, r;
      };
    }, t.values = S, O.prototype = {
      constructor: O,
      reset: function reset(t) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(x), !t) for (var e in this) {
          "t" === e.charAt(0) && r.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
        }
      },
      stop: function stop() {
        this.done = !0;
        var t = this.tryEntries[0].completion;
        if ("throw" === t.type) throw t.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(t) {
        if (this.done) throw t;
        var e = this;

        function n(r, n) {
          return a.type = "throw", a.arg = t, e.next = r, n && (e.method = "next", e.arg = void 0), !!n;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var o = this.tryEntries[i],
              a = o.completion;
          if ("root" === o.tryLoc) return n("end");

          if (o.tryLoc <= this.prev) {
            var u = r.call(o, "catchLoc"),
                s = r.call(o, "finallyLoc");

            if (u && s) {
              if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
              if (this.prev < o.finallyLoc) return n(o.finallyLoc);
            } else if (u) {
              if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
            } else {
              if (!s) throw new Error("try statement without catch or finally");
              if (this.prev < o.finallyLoc) return n(o.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(t, e) {
        for (var n = this.tryEntries.length - 1; n >= 0; --n) {
          var i = this.tryEntries[n];

          if (i.tryLoc <= this.prev && r.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
            var o = i;
            break;
          }
        }

        o && ("break" === t || "continue" === t) && o.tryLoc <= e && e <= o.finallyLoc && (o = null);
        var a = o ? o.completion : {};
        return a.type = t, a.arg = e, o ? (this.method = "next", this.next = o.finallyLoc, c) : this.complete(a);
      },
      complete: function complete(t, e) {
        if ("throw" === t.type) throw t.arg;
        return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), c;
      },
      finish: function finish(t) {
        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
          var r = this.tryEntries[e];
          if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), x(r), c;
        }
      },
      "catch": function _catch(t) {
        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
          var r = this.tryEntries[e];

          if (r.tryLoc === t) {
            var n = r.completion;

            if ("throw" === n.type) {
              var i = n.arg;
              x(r);
            }

            return i;
          }
        }

        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(t, e, r) {
        return this.delegate = {
          iterator: S(t),
          resultName: e,
          nextLoc: r
        }, "next" === this.method && (this.arg = void 0), c;
      }
    }, t;
  }(t.exports);

  try {
    regeneratorRuntime = e;
  } catch (t) {
    Function("r", "regeneratorRuntime = r")(e);
  }
});
ah("Uint32", function (t) {
  return function (e, r, n) {
    return t(this, e, r, n);
  };
});

var Sv = Math.pow(2, -52),
    Ev = new Uint32Array(512),
    kv = function () {
  function t(e) {
    Ae(this, t);
    var r = e.length >> 1;
    if (r > 0 && "number" != typeof e[0]) throw new Error("Expected coords to contain numbers.");
    this.coords = e;
    var n = Math.max(2 * r - 5, 0);
    this._triangles = new Uint32Array(3 * n), this._halfedges = new Int32Array(3 * n), this._hashSize = Math.ceil(Math.sqrt(r)), this._hullPrev = new Uint32Array(r), this._hullNext = new Uint32Array(r), this._hullTri = new Uint32Array(r), this._hullHash = new Int32Array(this._hashSize).fill(-1), this._ids = new Uint32Array(r), this._dists = new Float64Array(r), this.update();
  }

  return Te(t, null, [{
    key: "from",
    value: function value(e) {
      for (var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Rv, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : Iv, i = e.length, o = new Float64Array(2 * i), a = 0; a < i; a++) {
        var u = e[a];
        o[2 * a] = r(u), o[2 * a + 1] = n(u);
      }

      return new t(o);
    }
  }]), Te(t, [{
    key: "update",
    value: function value() {
      for (var t = this.coords, e = this._hullPrev, r = this._hullNext, n = this._hullTri, i = this._hullHash, o = t.length >> 1, a = 1 / 0, u = 1 / 0, s = -1 / 0, c = -1 / 0, l = 0; l < o; l++) {
        var f = t[2 * l],
            d = t[2 * l + 1];
        f < a && (a = f), d < u && (u = d), f > s && (s = f), d > c && (c = d), this._ids[l] = l;
      }

      for (var p, h, v, y = (a + s) / 2, g = (u + c) / 2, m = 1 / 0, b = 0; b < o; b++) {
        var w = Av(y, g, t[2 * b], t[2 * b + 1]);
        w < m && (p = b, m = w);
      }

      var x = t[2 * p],
          O = t[2 * p + 1];
      m = 1 / 0;

      for (var S = 0; S < o; S++) {
        if (S !== p) {
          var E = Av(x, O, t[2 * S], t[2 * S + 1]);
          E < m && E > 0 && (h = S, m = E);
        }
      }

      for (var k = t[2 * h], A = t[2 * h + 1], j = 1 / 0, T = 0; T < o; T++) {
        if (T !== p && T !== h) {
          var _ = _v(x, O, k, A, t[2 * T], t[2 * T + 1]);

          _ < j && (v = T, j = _);
        }
      }

      var P = t[2 * v],
          M = t[2 * v + 1];

      if (j === 1 / 0) {
        for (var R = 0; R < o; R++) {
          this._dists[R] = t[2 * R] - t[0] || t[2 * R + 1] - t[1];
        }

        Pv(this._ids, this._dists, 0, o - 1);

        for (var I = new Uint32Array(o), C = 0, V = 0, N = -1 / 0; V < o; V++) {
          var F = this._ids[V];
          this._dists[F] > N && (I[C++] = F, N = this._dists[F]);
        }

        return this.hull = I.subarray(0, C), this.triangles = new Uint32Array(0), void (this.halfedges = new Uint32Array(0));
      }

      if (Tv(x, O, k, A, P, M)) {
        var L = h,
            D = k,
            z = A;
        h = v, k = P, A = M, v = L, P = D, M = z;
      }

      var q = function (t, e, r, n, i, o) {
        var a = r - t,
            u = n - e,
            s = i - t,
            c = o - e,
            l = a * a + u * u,
            f = s * s + c * c,
            d = .5 / (a * c - u * s);
        return {
          x: t + (c * l - u * f) * d,
          y: e + (a * f - s * l) * d
        };
      }(x, O, k, A, P, M);

      this._cx = q.x, this._cy = q.y;

      for (var B = 0; B < o; B++) {
        this._dists[B] = Av(t[2 * B], t[2 * B + 1], q.x, q.y);
      }

      Pv(this._ids, this._dists, 0, o - 1), this._hullStart = p;
      var U = 3;
      r[p] = e[v] = h, r[h] = e[p] = v, r[v] = e[h] = p, n[p] = 0, n[h] = 1, n[v] = 2, i.fill(-1), i[this._hashKey(x, O)] = p, i[this._hashKey(k, A)] = h, i[this._hashKey(P, M)] = v, this.trianglesLen = 0, this._addTriangle(p, h, v, -1, -1, -1);

      for (var W, $, H = 0; H < this._ids.length; H++) {
        var G = this._ids[H],
            Y = t[2 * G],
            K = t[2 * G + 1];

        if (!(H > 0 && Math.abs(Y - W) <= Sv && Math.abs(K - $) <= Sv) && (W = Y, $ = K, G !== p && G !== h && G !== v)) {
          for (var X = 0, Q = 0, J = this._hashKey(Y, K); Q < this._hashSize && (-1 === (X = i[(J + Q) % this._hashSize]) || X === r[X]); Q++) {
            ;
          }

          for (var Z = X = e[X], tt = void 0; tt = r[Z], !Tv(Y, K, t[2 * Z], t[2 * Z + 1], t[2 * tt], t[2 * tt + 1]);) {
            if ((Z = tt) === X) {
              Z = -1;
              break;
            }
          }

          if (-1 !== Z) {
            var et = this._addTriangle(Z, G, r[Z], -1, -1, n[Z]);

            n[G] = this._legalize(et + 2), n[Z] = et, U++;

            for (var rt = r[Z]; tt = r[rt], Tv(Y, K, t[2 * rt], t[2 * rt + 1], t[2 * tt], t[2 * tt + 1]);) {
              et = this._addTriangle(rt, G, tt, n[G], -1, n[rt]), n[G] = this._legalize(et + 2), r[rt] = rt, U--, rt = tt;
            }

            if (Z === X) for (; Tv(Y, K, t[2 * (tt = e[Z])], t[2 * tt + 1], t[2 * Z], t[2 * Z + 1]);) {
              et = this._addTriangle(tt, G, Z, -1, n[Z], n[tt]), this._legalize(et + 2), n[tt] = et, r[Z] = Z, U--, Z = tt;
            }
            this._hullStart = e[G] = Z, r[Z] = e[rt] = G, r[G] = rt, i[this._hashKey(Y, K)] = G, i[this._hashKey(t[2 * Z], t[2 * Z + 1])] = Z;
          }
        }
      }

      this.hull = new Uint32Array(U);

      for (var nt = 0, it = this._hullStart; nt < U; nt++) {
        this.hull[nt] = it, it = r[it];
      }

      this.triangles = this._triangles.subarray(0, this.trianglesLen), this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
    }
  }, {
    key: "_hashKey",
    value: function value(t, e) {
      return Math.floor((r = t - this._cx, n = e - this._cy, i = r / (Math.abs(r) + Math.abs(n)), (n > 0 ? 3 - i : 1 + i) / 4 * this._hashSize)) % this._hashSize;
      var r, n, i;
    }
  }, {
    key: "_legalize",
    value: function value(t) {
      for (var e, r, n, i, o, a, u, s, c, l, f, d, p, h, v, y, g = this._triangles, m = this._halfedges, b = this.coords, w = 0, x = 0;;) {
        var O = m[t],
            S = t - t % 3;

        if (x = S + (t + 2) % 3, -1 !== O) {
          var E = O - O % 3,
              k = S + (t + 1) % 3,
              A = E + (O + 2) % 3,
              j = g[x],
              T = g[t],
              _ = g[k],
              P = g[A];

          if (e = b[2 * j], r = b[2 * j + 1], n = b[2 * T], i = b[2 * T + 1], o = b[2 * _], a = b[2 * _ + 1], u = b[2 * P], s = b[2 * P + 1], c = void 0, l = void 0, f = void 0, d = void 0, p = void 0, h = void 0, void 0, v = void 0, y = void 0, (c = e - u) * ((d = i - s) * (y = (p = o - u) * p + (h = a - s) * h) - (v = (f = n - u) * f + d * d) * h) - (l = r - s) * (f * y - v * p) + (c * c + l * l) * (f * h - d * p) < 0) {
            g[t] = P, g[O] = j;
            var M = m[A];

            if (-1 === M) {
              var R = this._hullStart;

              do {
                if (this._hullTri[R] === A) {
                  this._hullTri[R] = t;
                  break;
                }

                R = this._hullPrev[R];
              } while (R !== this._hullStart);
            }

            this._link(t, M), this._link(O, m[x]), this._link(x, A);
            var I = E + (O + 1) % 3;
            w < Ev.length && (Ev[w++] = I);
          } else {
            if (0 === w) break;
            t = Ev[--w];
          }
        } else {
          if (0 === w) break;
          t = Ev[--w];
        }
      }

      return x;
    }
  }, {
    key: "_link",
    value: function value(t, e) {
      this._halfedges[t] = e, -1 !== e && (this._halfedges[e] = t);
    }
  }, {
    key: "_addTriangle",
    value: function value(t, e, r, n, i, o) {
      var a = this.trianglesLen;
      return this._triangles[a] = t, this._triangles[a + 1] = e, this._triangles[a + 2] = r, this._link(a, n), this._link(a + 1, i), this._link(a + 2, o), this.trianglesLen += 3, a;
    }
  }]), t;
}();

function Av(t, e, r, n) {
  var i = t - r,
      o = e - n;
  return i * i + o * o;
}

function jv(t, e, r, n, i, o) {
  var a = (n - e) * (i - t),
      u = (r - t) * (o - e);
  return Math.abs(a - u) >= 33306690738754716e-32 * Math.abs(a + u) ? a - u : 0;
}

function Tv(t, e, r, n, i, o) {
  return (jv(i, o, t, e, r, n) || jv(t, e, r, n, i, o) || jv(r, n, i, o, t, e)) < 0;
}

function _v(t, e, r, n, i, o) {
  var a = r - t,
      u = n - e,
      s = i - t,
      c = o - e,
      l = a * a + u * u,
      f = s * s + c * c,
      d = .5 / (a * c - u * s),
      p = (c * l - u * f) * d,
      h = (a * f - s * l) * d;
  return p * p + h * h;
}

function Pv(t, e, r, n) {
  if (n - r <= 20) for (var i = r + 1; i <= n; i++) {
    for (var o = t[i], a = e[o], u = i - 1; u >= r && e[t[u]] > a;) {
      t[u + 1] = t[u--];
    }

    t[u + 1] = o;
  } else {
    var s = r + 1,
        c = n;
    Mv(t, r + n >> 1, s), e[t[r]] > e[t[n]] && Mv(t, r, n), e[t[s]] > e[t[n]] && Mv(t, s, n), e[t[r]] > e[t[s]] && Mv(t, r, s);

    for (var l = t[s], f = e[l];;) {
      do {
        s++;
      } while (e[t[s]] < f);

      do {
        c--;
      } while (e[t[c]] > f);

      if (c < s) break;
      Mv(t, s, c);
    }

    t[r + 1] = t[c], t[c] = l, n - s + 1 >= c - r ? (Pv(t, e, s, n), Pv(t, e, r, c - 1)) : (Pv(t, e, r, c - 1), Pv(t, e, s, n));
  }
}

function Mv(t, e, r) {
  var n = t[e];
  t[e] = t[r], t[r] = n;
}

function Rv(t) {
  return t[0];
}

function Iv(t) {
  return t[1];
}

var Cv = function () {
  function t() {
    Ae(this, t), this._x0 = this._y0 = this._x1 = this._y1 = null, this._ = "";
  }

  return Te(t, [{
    key: "moveTo",
    value: function value(t, e) {
      this._ += "M".concat(this._x0 = this._x1 = +t, ",").concat(this._y0 = this._y1 = +e);
    }
  }, {
    key: "closePath",
    value: function value() {
      null !== this._x1 && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
    }
  }, {
    key: "lineTo",
    value: function value(t, e) {
      this._ += "L".concat(this._x1 = +t, ",").concat(this._y1 = +e);
    }
  }, {
    key: "arc",
    value: function value(t, e, r) {
      var n = (t = +t) + (r = +r),
          i = e = +e;
      if (r < 0) throw new Error("negative radius");
      null === this._x1 ? this._ += "M".concat(n, ",").concat(i) : (Math.abs(this._x1 - n) > 1e-6 || Math.abs(this._y1 - i) > 1e-6) && (this._ += "L" + n + "," + i), r && (this._ += "A".concat(r, ",").concat(r, ",0,1,1,").concat(t - r, ",").concat(e, "A").concat(r, ",").concat(r, ",0,1,1,").concat(this._x1 = n, ",").concat(this._y1 = i));
    }
  }, {
    key: "rect",
    value: function value(t, e, r, n) {
      this._ += "M".concat(this._x0 = this._x1 = +t, ",").concat(this._y0 = this._y1 = +e, "h").concat(+r, "v").concat(+n, "h").concat(-r, "Z");
    }
  }, {
    key: "value",
    value: function value() {
      return this._ || null;
    }
  }]), t;
}(),
    Vv = function () {
  function t() {
    Ae(this, t), this._ = [];
  }

  return Te(t, [{
    key: "moveTo",
    value: function value(t, e) {
      this._.push([t, e]);
    }
  }, {
    key: "closePath",
    value: function value() {
      this._.push(this._[0].slice());
    }
  }, {
    key: "lineTo",
    value: function value(t, e) {
      this._.push([t, e]);
    }
  }, {
    key: "value",
    value: function value() {
      return this._.length ? this._ : null;
    }
  }]), t;
}(),
    Nv = function () {
  function t(e) {
    var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [0, 0, 960, 500],
        n = De(r, 4),
        i = n[0],
        o = n[1],
        a = n[2],
        u = n[3];
    if (Ae(this, t), !((a = +a) >= (i = +i) && (u = +u) >= (o = +o))) throw new Error("invalid bounds");
    this.delaunay = e, this._circumcenters = new Float64Array(2 * e.points.length), this.vectors = new Float64Array(2 * e.points.length), this.xmax = a, this.xmin = i, this.ymax = u, this.ymin = o, this._init();
  }

  return Te(t, [{
    key: "update",
    value: function value() {
      return this.delaunay.update(), this._init(), this;
    }
  }, {
    key: "_init",
    value: function value() {
      for (var t, e, r = this.delaunay, n = r.points, i = r.hull, o = r.triangles, a = this.vectors, u = this.circumcenters = this._circumcenters.subarray(0, o.length / 3 * 2), s = 0, c = 0, l = o.length; s < l; s += 3, c += 2) {
        var f = 2 * o[s],
            d = 2 * o[s + 1],
            p = 2 * o[s + 2],
            h = n[f],
            v = n[f + 1],
            y = n[d],
            g = n[d + 1],
            m = n[p],
            b = n[p + 1],
            w = y - h,
            x = g - v,
            O = m - h,
            S = b - v,
            E = w * w + x * x,
            k = O * O + S * S,
            A = 2 * (w * S - x * O);
        if (A) {
          if (Math.abs(A) < 1e-8) t = (h + m) / 2, e = (v + b) / 2;else {
            var j = 1 / A;
            t = h + (S * E - x * k) * j, e = v + (w * k - O * E) * j;
          }
        } else t = (h + m) / 2 - 1e8 * S, e = (v + b) / 2 + 1e8 * O;
        u[c] = t, u[c + 1] = e;
      }

      var T,
          _,
          P,
          M = i[i.length - 1],
          R = 4 * M,
          I = n[2 * M],
          C = n[2 * M + 1];

      a.fill(0);

      for (var V = 0; V < i.length; ++V) {
        T = R, _ = I, P = C, R = 4 * (M = i[V]), I = n[2 * M], C = n[2 * M + 1], a[T + 2] = a[R] = P - C, a[T + 3] = a[R + 1] = I - _;
      }
    }
  }, {
    key: "render",
    value: function value(t) {
      var e = null == t ? t = new Cv() : void 0,
          r = this.delaunay,
          n = r.halfedges,
          i = r.inedges,
          o = r.hull,
          a = this.circumcenters,
          u = this.vectors;
      if (o.length <= 1) return null;

      for (var s = 0, c = n.length; s < c; ++s) {
        var l = n[s];

        if (!(l < s)) {
          var f = 2 * Math.floor(s / 3),
              d = 2 * Math.floor(l / 3),
              p = a[f],
              h = a[f + 1],
              v = a[d],
              y = a[d + 1];

          this._renderSegment(p, h, v, y, t);
        }
      }

      for (var g, m = o[o.length - 1], b = 0; b < o.length; ++b) {
        g = m, m = o[b];

        var w = 2 * Math.floor(i[m] / 3),
            x = a[w],
            O = a[w + 1],
            S = 4 * g,
            E = this._project(x, O, u[S + 2], u[S + 3]);

        E && this._renderSegment(x, O, E[0], E[1], t);
      }

      return e && e.value();
    }
  }, {
    key: "renderBounds",
    value: function value(t) {
      var e = null == t ? t = new Cv() : void 0;
      return t.rect(this.xmin, this.ymin, this.xmax - this.xmin, this.ymax - this.ymin), e && e.value();
    }
  }, {
    key: "renderCell",
    value: function value(t, e) {
      var r = null == e ? e = new Cv() : void 0,
          n = this._clip(t);

      if (null !== n) {
        e.moveTo(n[0], n[1]);

        for (var i = n.length; n[0] === n[i - 2] && n[1] === n[i - 1] && i > 1;) {
          i -= 2;
        }

        for (var o = 2; o < i; o += 2) {
          n[o] === n[o - 2] && n[o + 1] === n[o - 1] || e.lineTo(n[o], n[o + 1]);
        }

        return e.closePath(), r && r.value();
      }
    }
  }, {
    key: "cellPolygons",
    value: _regeneratorRuntime.mark(function t() {
      var e, r, n, i;
      return _regeneratorRuntime.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              e = this.delaunay.points, r = 0, n = e.length / 2;

            case 2:
              if (!(r < n)) {
                t.next = 10;
                break;
              }

              if (!(i = this.cellPolygon(r))) {
                t.next = 7;
                break;
              }

              return t.next = 7, i;

            case 7:
              ++r, t.next = 2;
              break;

            case 10:
            case "end":
              return t.stop();
          }
        }
      }, t, this);
    })
  }, {
    key: "cellPolygon",
    value: function value(t) {
      var e = new Vv();
      return this.renderCell(t, e), e.value();
    }
  }, {
    key: "_renderSegment",
    value: function value(t, e, r, n, i) {
      var o,
          a = this._regioncode(t, e),
          u = this._regioncode(r, n);

      0 === a && 0 === u ? (i.moveTo(t, e), i.lineTo(r, n)) : (o = this._clipSegment(t, e, r, n, a, u)) && (i.moveTo(o[0], o[1]), i.lineTo(o[2], o[3]));
    }
  }, {
    key: "contains",
    value: function value(t, e, r) {
      return (e = +e) == e && (r = +r) == r && this.delaunay._step(t, e, r) === t;
    }
  }, {
    key: "neighbors",
    value: _regeneratorRuntime.mark(function t(e) {
      var r, n, i, o, a, u, s, c, l, f, d, p;
      return _regeneratorRuntime.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              if (!(r = this._clip(e))) {
                t.next = 42;
                break;
              }

              n = !0, i = !1, o = void 0, t.prev = 5, a = this.delaunay.neighbors(e)[Symbol.iterator]();

            case 7:
              if (n = (u = a.next()).done) {
                t.next = 28;
                break;
              }

              if (s = u.value, !(c = this._clip(s))) {
                t.next = 25;
                break;
              }

              l = 0, f = r.length;

            case 12:
              if (!(l < f)) {
                t.next = 25;
                break;
              }

              d = 0, p = c.length;

            case 14:
              if (!(d < p)) {
                t.next = 22;
                break;
              }

              if (r[l] != c[d] || r[l + 1] != c[d + 1] || r[(l + 2) % f] != c[(d + p - 2) % p] || r[(l + 3) % f] != c[(d + p - 1) % p]) {
                t.next = 19;
                break;
              }

              return t.next = 18, s;

            case 18:
              return t.abrupt("break", 25);

            case 19:
              d += 2, t.next = 14;
              break;

            case 22:
              l += 2, t.next = 12;
              break;

            case 25:
              n = !0, t.next = 7;
              break;

            case 28:
              t.next = 34;
              break;

            case 30:
              t.prev = 30, t.t0 = t["catch"](5), i = !0, o = t.t0;

            case 34:
              t.prev = 34, t.prev = 35, n || null == a["return"] || a["return"]();

            case 37:
              if (t.prev = 37, !i) {
                t.next = 40;
                break;
              }

              throw o;

            case 40:
              return t.finish(37);

            case 41:
              return t.finish(34);

            case 42:
            case "end":
              return t.stop();
          }
        }
      }, t, this, [[5, 30, 34, 42], [35,, 37, 41]]);
    })
  }, {
    key: "_cell",
    value: function value(t) {
      var e = this.circumcenters,
          r = this.delaunay,
          n = r.inedges,
          i = r.halfedges,
          o = r.triangles,
          a = n[t];
      if (-1 === a) return null;
      var u = [],
          s = a;

      do {
        var c = Math.floor(s / 3);
        if (u.push(e[2 * c], e[2 * c + 1]), o[s = s % 3 == 2 ? s - 2 : s + 1] !== t) break;
        s = i[s];
      } while (s !== a && -1 !== s);

      return u;
    }
  }, {
    key: "_clip",
    value: function value(t) {
      if (0 === t && 1 === this.delaunay.hull.length) return [this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax, this.xmin, this.ymin];

      var e = this._cell(t);

      if (null === e) return null;
      var r = this.vectors,
          n = 4 * t;
      return r[n] || r[n + 1] ? this._clipInfinite(t, e, r[n], r[n + 1], r[n + 2], r[n + 3]) : this._clipFinite(t, e);
    }
  }, {
    key: "_clipFinite",
    value: function value(t, e) {
      for (var r, n, i, o, a, u = e.length, s = null, c = e[u - 2], l = e[u - 1], f = this._regioncode(c, l), d = 0; d < u; d += 2) {
        if (r = c, n = l, c = e[d], l = e[d + 1], i = f, f = this._regioncode(c, l), 0 === i && 0 === f) o = a, a = 0, s ? s.push(c, l) : s = [c, l];else {
          var p = void 0,
              h = void 0,
              v = void 0,
              y = void 0,
              g = void 0;

          if (0 === i) {
            if (null === (p = this._clipSegment(r, n, c, l, i, f))) continue;
            var m = De(p, 4);
            h = m[0], v = m[1], y = m[2], g = m[3];
          } else {
            if (null === (p = this._clipSegment(c, l, r, n, f, i))) continue;
            var b = De(p, 4);
            y = b[0], g = b[1], h = b[2], v = b[3], o = a, a = this._edgecode(h, v), o && a && this._edge(t, o, a, s, s.length), s ? s.push(h, v) : s = [h, v];
          }

          o = a, a = this._edgecode(y, g), o && a && this._edge(t, o, a, s, s.length), s ? s.push(y, g) : s = [y, g];
        }
      }

      if (s) o = a, a = this._edgecode(s[0], s[1]), o && a && this._edge(t, o, a, s, s.length);else if (this.contains(t, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2)) return [this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax, this.xmin, this.ymin];
      return s;
    }
  }, {
    key: "_clipSegment",
    value: function value(t, e, r, n, i, o) {
      for (;;) {
        if (0 === i && 0 === o) return [t, e, r, n];
        if (i & o) return null;
        var a = void 0,
            u = void 0,
            s = i || o;
        8 & s ? (a = t + (r - t) * (this.ymax - e) / (n - e), u = this.ymax) : 4 & s ? (a = t + (r - t) * (this.ymin - e) / (n - e), u = this.ymin) : 2 & s ? (u = e + (n - e) * (this.xmax - t) / (r - t), a = this.xmax) : (u = e + (n - e) * (this.xmin - t) / (r - t), a = this.xmin), i ? (t = a, e = u, i = this._regioncode(t, e)) : (r = a, n = u, o = this._regioncode(r, n));
      }
    }
  }, {
    key: "_clipInfinite",
    value: function value(t, e, r, n, i, o) {
      var a,
          u = Array.from(e);
      if ((a = this._project(u[0], u[1], r, n)) && u.unshift(a[0], a[1]), (a = this._project(u[u.length - 2], u[u.length - 1], i, o)) && u.push(a[0], a[1]), u = this._clipFinite(t, u)) for (var s, c = 0, l = u.length, f = this._edgecode(u[l - 2], u[l - 1]); c < l; c += 2) {
        s = f, f = this._edgecode(u[c], u[c + 1]), s && f && (c = this._edge(t, s, f, u, c), l = u.length);
      } else this.contains(t, (this.xmin + this.xmax) / 2, (this.ymin + this.ymax) / 2) && (u = [this.xmin, this.ymin, this.xmax, this.ymin, this.xmax, this.ymax, this.xmin, this.ymax]);
      return u;
    }
  }, {
    key: "_edge",
    value: function value(t, e, r, n, i) {
      for (; e !== r;) {
        var o = void 0,
            a = void 0;

        switch (e) {
          case 5:
            e = 4;
            continue;

          case 4:
            e = 6, o = this.xmax, a = this.ymin;
            break;

          case 6:
            e = 2;
            continue;

          case 2:
            e = 10, o = this.xmax, a = this.ymax;
            break;

          case 10:
            e = 8;
            continue;

          case 8:
            e = 9, o = this.xmin, a = this.ymax;
            break;

          case 9:
            e = 1;
            continue;

          case 1:
            e = 5, o = this.xmin, a = this.ymin;
        }

        n[i] === o && n[i + 1] === a || !this.contains(t, o, a) || (n.splice(i, 0, o, a), i += 2);
      }

      if (n.length > 4) for (var u = 0; u < n.length; u += 2) {
        var s = (u + 2) % n.length,
            c = (u + 4) % n.length;
        (n[u] === n[s] && n[s] === n[c] || n[u + 1] === n[s + 1] && n[s + 1] === n[c + 1]) && (n.splice(s, 2), u -= 2);
      }
      return i;
    }
  }, {
    key: "_project",
    value: function value(t, e, r, n) {
      var i,
          o,
          a,
          u = 1 / 0;

      if (n < 0) {
        if (e <= this.ymin) return null;
        (i = (this.ymin - e) / n) < u && (a = this.ymin, o = t + (u = i) * r);
      } else if (n > 0) {
        if (e >= this.ymax) return null;
        (i = (this.ymax - e) / n) < u && (a = this.ymax, o = t + (u = i) * r);
      }

      if (r > 0) {
        if (t >= this.xmax) return null;
        (i = (this.xmax - t) / r) < u && (o = this.xmax, a = e + (u = i) * n);
      } else if (r < 0) {
        if (t <= this.xmin) return null;
        (i = (this.xmin - t) / r) < u && (o = this.xmin, a = e + (u = i) * n);
      }

      return [o, a];
    }
  }, {
    key: "_edgecode",
    value: function value(t, e) {
      return (t === this.xmin ? 1 : t === this.xmax ? 2 : 0) | (e === this.ymin ? 4 : e === this.ymax ? 8 : 0);
    }
  }, {
    key: "_regioncode",
    value: function value(t, e) {
      return (t < this.xmin ? 1 : t > this.xmax ? 2 : 0) | (e < this.ymin ? 4 : e > this.ymax ? 8 : 0);
    }
  }]), t;
}(),
    Fv = _regeneratorRuntime.mark(Wv),
    Lv = 2 * Math.PI;

function Dv(t) {
  return t[0];
}

function zv(t) {
  return t[1];
}

function qv(t, e, r) {
  return [t + Math.sin(t + e) * r, e + Math.cos(t - e) * r];
}

var Bv = function () {
  function t(e) {
    Ae(this, t), this._delaunator = new kv(e), this.inedges = new Int32Array(e.length / 2), this._hullIndex = new Int32Array(e.length / 2), this.points = this._delaunator.coords, this._init();
  }

  return Te(t, null, [{
    key: "from",
    value: function value(e) {
      var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Dv,
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : zv,
          i = arguments.length > 3 ? arguments[3] : void 0;
      return new t("length" in e ? Uv(e, r, n, i) : Float64Array.from(Wv(e, r, n, i)));
    }
  }]), Te(t, [{
    key: "update",
    value: function value() {
      return this._delaunator.update(), this._init(), this;
    }
  }, {
    key: "_init",
    value: function value() {
      var t = this._delaunator,
          e = this.points;

      if (t.hull && t.hull.length > 2 && function (t) {
        for (var e = t.triangles, r = t.coords, n = 0; n < e.length; n += 3) {
          var i = 2 * e[n],
              o = 2 * e[n + 1],
              a = 2 * e[n + 2];
          if ((r[a] - r[i]) * (r[o + 1] - r[i + 1]) - (r[o] - r[i]) * (r[a + 1] - r[i + 1]) > 1e-10) return !1;
        }

        return !0;
      }(t)) {
        this.collinear = Int32Array.from({
          length: e.length / 2
        }, function (t, e) {
          return e;
        }).sort(function (t, r) {
          return e[2 * t] - e[2 * r] || e[2 * t + 1] - e[2 * r + 1];
        });

        for (var r = this.collinear[0], n = this.collinear[this.collinear.length - 1], i = [e[2 * r], e[2 * r + 1], e[2 * n], e[2 * n + 1]], o = 1e-8 * Math.sqrt(Math.pow(i[3] - i[1], 2) + Math.pow(i[2] - i[0], 2)), a = 0, u = e.length / 2; a < u; ++a) {
          var s = qv(e[2 * a], e[2 * a + 1], o);
          e[2 * a] = s[0], e[2 * a + 1] = s[1];
        }

        this._delaunator = new kv(e);
      } else delete this.collinear;

      for (var c = this.halfedges = this._delaunator.halfedges, l = this.hull = this._delaunator.hull, f = this.triangles = this._delaunator.triangles, d = this.inedges.fill(-1), p = this._hullIndex.fill(-1), h = 0, v = c.length; h < v; ++h) {
        var y = f[h % 3 == 2 ? h - 2 : h + 1];
        -1 !== c[h] && -1 !== d[y] || (d[y] = h);
      }

      for (var g = 0, m = l.length; g < m; ++g) {
        p[l[g]] = g;
      }

      l.length <= 2 && l.length > 0 && (this.triangles = new Int32Array(3).fill(-1), this.halfedges = new Int32Array(3).fill(-1), this.triangles[0] = l[0], this.triangles[1] = l[1], this.triangles[2] = l[1], d[l[0]] = 1, 2 === l.length && (d[l[1]] = 0));
    }
  }, {
    key: "voronoi",
    value: function value(t) {
      return new Nv(this, t);
    }
  }, {
    key: "neighbors",
    value: _regeneratorRuntime.mark(function t(e) {
      var r, n, i, o, a, u, s, c, l, f, d;
      return _regeneratorRuntime.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              if (r = this.inedges, n = this.hull, i = this._hullIndex, o = this.halfedges, a = this.triangles, !(u = this.collinear)) {
                t.next = 10;
                break;
              }

              if (!((s = u.indexOf(e)) > 0)) {
                t.next = 6;
                break;
              }

              return t.next = 6, u[s - 1];

            case 6:
              if (!(s < u.length - 1)) {
                t.next = 9;
                break;
              }

              return t.next = 9, u[s + 1];

            case 9:
              return t.abrupt("return");

            case 10:
              if (-1 !== (c = r[e])) {
                t.next = 13;
                break;
              }

              return t.abrupt("return");

            case 13:
              l = c, f = -1;

            case 14:
              return t.next = 16, f = a[l];

            case 16:
              if (a[l = l % 3 == 2 ? l - 2 : l + 1] === e) {
                t.next = 19;
                break;
              }

              return t.abrupt("return");

            case 19:
              if (-1 !== (l = o[l])) {
                t.next = 26;
                break;
              }

              if ((d = n[(i[e] + 1) % n.length]) === f) {
                t.next = 25;
                break;
              }

              return t.next = 25, d;

            case 25:
              return t.abrupt("return");

            case 26:
              if (l !== c) {
                t.next = 14;
                break;
              }

            case 27:
            case "end":
              return t.stop();
          }
        }
      }, t, this);
    })
  }, {
    key: "find",
    value: function value(t, e) {
      var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
      if ((t = +t) != t || (e = +e) != e) return -1;

      for (var n, i = r; (n = this._step(r, t, e)) >= 0 && n !== r && n !== i;) {
        r = n;
      }

      return n;
    }
  }, {
    key: "_step",
    value: function value(t, e, r) {
      var n = this.inedges,
          i = this.hull,
          o = this._hullIndex,
          a = this.halfedges,
          u = this.triangles,
          s = this.points;
      if (-1 === n[t] || !s.length) return (t + 1) % (s.length >> 1);
      var c = t,
          l = Math.pow(e - s[2 * t], 2) + Math.pow(r - s[2 * t + 1], 2),
          f = n[t],
          d = f;

      do {
        var p = u[d],
            h = Math.pow(e - s[2 * p], 2) + Math.pow(r - s[2 * p + 1], 2);
        if (h < l && (l = h, c = p), u[d = d % 3 == 2 ? d - 2 : d + 1] !== t) break;

        if (-1 === (d = a[d])) {
          if ((d = i[(o[t] + 1) % i.length]) !== p && Math.pow(e - s[2 * d], 2) + Math.pow(r - s[2 * d + 1], 2) < l) return d;
          break;
        }
      } while (d !== f);

      return c;
    }
  }, {
    key: "render",
    value: function value(t) {
      for (var e = null == t ? t = new Cv() : void 0, r = this.points, n = this.halfedges, i = this.triangles, o = 0, a = n.length; o < a; ++o) {
        var u = n[o];

        if (!(u < o)) {
          var s = 2 * i[o],
              c = 2 * i[u];
          t.moveTo(r[s], r[s + 1]), t.lineTo(r[c], r[c + 1]);
        }
      }

      return this.renderHull(t), e && e.value();
    }
  }, {
    key: "renderPoints",
    value: function value(t) {
      for (var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2, r = null == t ? t = new Cv() : void 0, n = this.points, i = 0, o = n.length; i < o; i += 2) {
        var a = n[i],
            u = n[i + 1];
        t.moveTo(a + e, u), t.arc(a, u, e, 0, Lv);
      }

      return r && r.value();
    }
  }, {
    key: "renderHull",
    value: function value(t) {
      var e = null == t ? t = new Cv() : void 0,
          r = this.hull,
          n = this.points,
          i = 2 * r[0],
          o = r.length;
      t.moveTo(n[i], n[i + 1]);

      for (var a = 1; a < o; ++a) {
        var u = 2 * r[a];
        t.lineTo(n[u], n[u + 1]);
      }

      return t.closePath(), e && e.value();
    }
  }, {
    key: "hullPolygon",
    value: function value() {
      var t = new Vv();
      return this.renderHull(t), t.value();
    }
  }, {
    key: "renderTriangle",
    value: function value(t, e) {
      var r = null == e ? e = new Cv() : void 0,
          n = this.points,
          i = this.triangles,
          o = 2 * i[t *= 3],
          a = 2 * i[t + 1],
          u = 2 * i[t + 2];
      return e.moveTo(n[o], n[o + 1]), e.lineTo(n[a], n[a + 1]), e.lineTo(n[u], n[u + 1]), e.closePath(), r && r.value();
    }
  }, {
    key: "trianglePolygons",
    value: _regeneratorRuntime.mark(function t() {
      var e, r, n;
      return _regeneratorRuntime.wrap(function (t) {
        for (;;) {
          switch (t.prev = t.next) {
            case 0:
              e = this.triangles, r = 0, n = e.length / 3;

            case 2:
              if (!(r < n)) {
                t.next = 8;
                break;
              }

              return t.next = 5, this.trianglePolygon(r);

            case 5:
              ++r, t.next = 2;
              break;

            case 8:
            case "end":
              return t.stop();
          }
        }
      }, t, this);
    })
  }, {
    key: "trianglePolygon",
    value: function value(t) {
      var e = new Vv();
      return this.renderTriangle(t, e), e.value();
    }
  }]), t;
}();

function Uv(t, e, r, n) {
  for (var i = t.length, o = new Float64Array(2 * i), a = 0; a < i; ++a) {
    var u = t[a];
    o[2 * a] = e.call(n, u, a, t), o[2 * a + 1] = r.call(n, u, a, t);
  }

  return o;
}

function Wv(t, e, r, n) {
  var i, o, a, u, s, c, l;
  return _regeneratorRuntime.wrap(function (f) {
    for (;;) {
      switch (f.prev = f.next) {
        case 0:
          i = 0, o = !0, a = !1, u = void 0, f.prev = 4, s = t[Symbol.iterator]();

        case 6:
          if (o = (c = s.next()).done) {
            f.next = 16;
            break;
          }

          return l = c.value, f.next = 10, e.call(n, l, i, t);

        case 10:
          return f.next = 12, r.call(n, l, i, t);

        case 12:
          ++i;

        case 13:
          o = !0, f.next = 6;
          break;

        case 16:
          f.next = 22;
          break;

        case 18:
          f.prev = 18, f.t0 = f["catch"](4), a = !0, u = f.t0;

        case 22:
          f.prev = 22, f.prev = 23, o || null == s["return"] || s["return"]();

        case 25:
          if (f.prev = 25, !a) {
            f.next = 28;
            break;
          }

          throw u;

        case 28:
          return f.finish(25);

        case 29:
          return f.finish(22);

        case 30:
        case "end":
          return f.stop();
      }
    }
  }, Fv, null, [[4, 18, 22, 30], [23,, 25, 29]]);
}

var $v = function $v(e) {
  var r = e.points,
      n = e.style,
      i = void 0 === n ? {} : n,
      o = e.showPolygons,
      a = void 0 !== o && o,
      u = e.onMouseEnter,
      s = void 0 === u ? function () {} : u,
      c = e.onMouseMove,
      f = void 0 === c ? function () {} : c,
      d = e.onMouseOut,
      p = void 0 === d ? function () {} : d,
      h = e.onMouseDown,
      v = void 0 === h ? function () {} : h,
      y = e.onMouseUp,
      g = void 0 === y ? function () {} : y,
      m = e.onClick,
      b = void 0 === m ? function () {} : m,
      w = e.gProps,
      x = void 0 === w ? {} : w,
      O = Ne(e, ["points", "style", "showPolygons", "onMouseEnter", "onMouseMove", "onMouseOut", "onMouseDown", "onMouseUp", "onClick", "gProps"]),
      S = l(el),
      E = S.chartWidth,
      k = S.chartHeight,
      A = S.margin,
      j = S.getBoundingClientRect,
      T = Bv.from(r),
      _ = T.voronoi([0, 0, E, k]),
      P = function P(t) {
    var e = j(),
        r = t.clientX - e.left - A.left,
        n = t.clientY - e.top - A.top;
    return {
      point: {
        x: r,
        y: n
      },
      index: T.find(r, n)
    };
  };

  return t.createElement("g", x, t.createElement("path", Pe({
    d: _.renderBounds(),
    style: Re({
      fill: "transparent",
      stroke: a ? "black" : "none"
    }, i),
    onMouseEnter: function onMouseEnter(t) {
      var e = P(t),
          r = e.point,
          n = e.index;
      s(t, r, n);
    },
    onMouseMove: function onMouseMove(t) {
      var e = P(t),
          r = e.point,
          n = e.index;
      f(t, r, n);
    },
    onMouseOut: function onMouseOut(t) {
      var e = P(t),
          r = e.point,
          n = e.index;
      p(t, r, n);
    },
    onMouseDown: function onMouseDown(t) {
      var e = P(t),
          r = e.point,
          n = e.index;
      v(t, r, n);
    },
    onMouseUp: function onMouseUp(t) {
      var e = P(t),
          r = e.point,
          n = e.index;
      g(t, r, n);
    },
    onClick: function onClick(t) {
      var e = P(t),
          r = e.point,
          n = e.index;
      b(t, r, n);
    }
  }, O)), a && t.createElement("path", {
    d: _.render(),
    style: {
      fill: "transparent",
      stroke: "black",
      pointerEvents: "none"
    }
  }));
};

$v.displayName = "Voronoi";
var Hv = t.memo($v);
export { Hs as Axis, il as FlexPlot, hd as Hint, Vp as Path, rl as Plot, el as PlotContext, Hv as Voronoi };